function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3e92"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3e92"] = parcelRequire;
}
parcelRequire.register("0qhf8", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $0014624a040e5105$export$ffb0004e005737fa; }, function (v) { return $0014624a040e5105$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $0014624a040e5105$export$34b9dba7ce09269b; }, function (v) { return $0014624a040e5105$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $0014624a040e5105$export$25062201e9e25d76; }, function (v) { return $0014624a040e5105$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0014624a040e5105$export$ffb0004e005737fa;
var $0014624a040e5105$export$34b9dba7ce09269b;
var $0014624a040e5105$export$25062201e9e25d76;
"use strict";

var $bh6RR = parcelRequire("bh6RR");
var $0014624a040e5105$var$k = Symbol.for("react.element"), $0014624a040e5105$var$l = Symbol.for("react.fragment"), $0014624a040e5105$var$m = Object.prototype.hasOwnProperty, $0014624a040e5105$var$n = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0014624a040e5105$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0014624a040e5105$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0014624a040e5105$var$m.call(a, b) && !$0014624a040e5105$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0014624a040e5105$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0014624a040e5105$var$n.current
    };
}
$0014624a040e5105$export$ffb0004e005737fa = $0014624a040e5105$var$l;
$0014624a040e5105$export$34b9dba7ce09269b = $0014624a040e5105$var$q;
$0014624a040e5105$export$25062201e9e25d76 = $0014624a040e5105$var$q;

});
parcelRequire.register("bh6RR", function(module, exports) {
"use strict";

module.exports = (parcelRequire("cCfq4"));

});
parcelRequire.register("cCfq4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $92f4fea5bc247620$export$dca3b0875bd9a954; }, function (v) { return $92f4fea5bc247620$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $92f4fea5bc247620$export$16fa2f45be04daa8; }, function (v) { return $92f4fea5bc247620$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $92f4fea5bc247620$export$ffb0004e005737fa; }, function (v) { return $92f4fea5bc247620$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $92f4fea5bc247620$export$e2c29f18771995cb; }, function (v) { return $92f4fea5bc247620$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $92f4fea5bc247620$export$221d75b3f55bb0bd; }, function (v) { return $92f4fea5bc247620$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $92f4fea5bc247620$export$5f8d39834fd61797; }, function (v) { return $92f4fea5bc247620$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $92f4fea5bc247620$export$74bf444e3cd11ea5; }, function (v) { return $92f4fea5bc247620$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $92f4fea5bc247620$export$ae55be85d98224ed; }, function (v) { return $92f4fea5bc247620$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $92f4fea5bc247620$export$e530037191fcd5d7; }, function (v) { return $92f4fea5bc247620$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $92f4fea5bc247620$export$fd42f52fd3ae1109; }, function (v) { return $92f4fea5bc247620$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $92f4fea5bc247620$export$c8a8987d4410bf2d; }, function (v) { return $92f4fea5bc247620$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $92f4fea5bc247620$export$d38cd72104c1f0e9; }, function (v) { return $92f4fea5bc247620$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $92f4fea5bc247620$export$7d1e3a5e95ceca43; }, function (v) { return $92f4fea5bc247620$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $92f4fea5bc247620$export$257a8862b851cb5b; }, function (v) { return $92f4fea5bc247620$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $92f4fea5bc247620$export$a8257692ac88316c; }, function (v) { return $92f4fea5bc247620$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $92f4fea5bc247620$export$488013bae63b21da; }, function (v) { return $92f4fea5bc247620$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $92f4fea5bc247620$export$7c73462e0d25e514; }, function (v) { return $92f4fea5bc247620$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $92f4fea5bc247620$export$7568632d0d33d16d; }, function (v) { return $92f4fea5bc247620$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $92f4fea5bc247620$export$88948ce120ea2619; }, function (v) { return $92f4fea5bc247620$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $92f4fea5bc247620$export$35808ee640e87ca7; }, function (v) { return $92f4fea5bc247620$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $92f4fea5bc247620$export$fae74005e78b1a27; }, function (v) { return $92f4fea5bc247620$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e; }, function (v) { return $92f4fea5bc247620$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $92f4fea5bc247620$export$6a7bc4e911dc01cf; }, function (v) { return $92f4fea5bc247620$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $92f4fea5bc247620$export$6d9c69b0de29b591; }, function (v) { return $92f4fea5bc247620$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $92f4fea5bc247620$export$f680877a34711e37; }, function (v) { return $92f4fea5bc247620$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $92f4fea5bc247620$export$d5a552a76deda3c2; }, function (v) { return $92f4fea5bc247620$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $92f4fea5bc247620$export$aaabe4eda9ed9969; }, function (v) { return $92f4fea5bc247620$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $92f4fea5bc247620$export$e5c5a5f917a5871c; }, function (v) { return $92f4fea5bc247620$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $92f4fea5bc247620$export$1538c33de8887b59; }, function (v) { return $92f4fea5bc247620$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $92f4fea5bc247620$export$13e3392192263954; }, function (v) { return $92f4fea5bc247620$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $92f4fea5bc247620$export$b8f5890fc79d6aca; }, function (v) { return $92f4fea5bc247620$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $92f4fea5bc247620$export$60241385465d0a34; }, function (v) { return $92f4fea5bc247620$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $92f4fea5bc247620$export$306c0aa65ff9ec16; }, function (v) { return $92f4fea5bc247620$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $92f4fea5bc247620$export$7b286972b8d8ccbf; }, function (v) { return $92f4fea5bc247620$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $92f4fea5bc247620$export$83d89fbfd8236492; }, function (v) { return $92f4fea5bc247620$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $92f4fea5bc247620$export$dca3b0875bd9a954;
var $92f4fea5bc247620$export$16fa2f45be04daa8;
var $92f4fea5bc247620$export$ffb0004e005737fa;
var $92f4fea5bc247620$export$e2c29f18771995cb;
var $92f4fea5bc247620$export$221d75b3f55bb0bd;
var $92f4fea5bc247620$export$5f8d39834fd61797;
var $92f4fea5bc247620$export$74bf444e3cd11ea5;
var $92f4fea5bc247620$export$ae55be85d98224ed;
var $92f4fea5bc247620$export$e530037191fcd5d7;
var $92f4fea5bc247620$export$fd42f52fd3ae1109;
var $92f4fea5bc247620$export$c8a8987d4410bf2d;
var $92f4fea5bc247620$export$d38cd72104c1f0e9;
var $92f4fea5bc247620$export$7d1e3a5e95ceca43;
var $92f4fea5bc247620$export$257a8862b851cb5b;
var $92f4fea5bc247620$export$a8257692ac88316c;
var $92f4fea5bc247620$export$488013bae63b21da;
var $92f4fea5bc247620$export$7c73462e0d25e514;
var $92f4fea5bc247620$export$7568632d0d33d16d;
var $92f4fea5bc247620$export$88948ce120ea2619;
var $92f4fea5bc247620$export$35808ee640e87ca7;
var $92f4fea5bc247620$export$fae74005e78b1a27;
var $92f4fea5bc247620$export$dc8fbce3eb94dc1e;
var $92f4fea5bc247620$export$6a7bc4e911dc01cf;
var $92f4fea5bc247620$export$6d9c69b0de29b591;
var $92f4fea5bc247620$export$f680877a34711e37;
var $92f4fea5bc247620$export$d5a552a76deda3c2;
var $92f4fea5bc247620$export$aaabe4eda9ed9969;
var $92f4fea5bc247620$export$e5c5a5f917a5871c;
var $92f4fea5bc247620$export$1538c33de8887b59;
var $92f4fea5bc247620$export$13e3392192263954;
var $92f4fea5bc247620$export$b8f5890fc79d6aca;
var $92f4fea5bc247620$export$60241385465d0a34;
var $92f4fea5bc247620$export$306c0aa65ff9ec16;
var $92f4fea5bc247620$export$7b286972b8d8ccbf;
var $92f4fea5bc247620$export$83d89fbfd8236492;
"use strict";
var $92f4fea5bc247620$var$l = Symbol.for("react.element"), $92f4fea5bc247620$var$n = Symbol.for("react.portal"), $92f4fea5bc247620$var$p = Symbol.for("react.fragment"), $92f4fea5bc247620$var$q = Symbol.for("react.strict_mode"), $92f4fea5bc247620$var$r = Symbol.for("react.profiler"), $92f4fea5bc247620$var$t = Symbol.for("react.provider"), $92f4fea5bc247620$var$u = Symbol.for("react.context"), $92f4fea5bc247620$var$v = Symbol.for("react.forward_ref"), $92f4fea5bc247620$var$w = Symbol.for("react.suspense"), $92f4fea5bc247620$var$x = Symbol.for("react.memo"), $92f4fea5bc247620$var$y = Symbol.for("react.lazy"), $92f4fea5bc247620$var$z = Symbol.iterator;
function $92f4fea5bc247620$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $92f4fea5bc247620$var$z && a[$92f4fea5bc247620$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $92f4fea5bc247620$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $92f4fea5bc247620$var$C = Object.assign, $92f4fea5bc247620$var$D = {};
function $92f4fea5bc247620$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
$92f4fea5bc247620$var$E.prototype.isReactComponent = {};
$92f4fea5bc247620$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$92f4fea5bc247620$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $92f4fea5bc247620$var$F() {}
$92f4fea5bc247620$var$F.prototype = $92f4fea5bc247620$var$E.prototype;
function $92f4fea5bc247620$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $92f4fea5bc247620$var$D;
    this.updater = e || $92f4fea5bc247620$var$B;
}
var $92f4fea5bc247620$var$H = $92f4fea5bc247620$var$G.prototype = new $92f4fea5bc247620$var$F;
$92f4fea5bc247620$var$H.constructor = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$var$C($92f4fea5bc247620$var$H, $92f4fea5bc247620$var$E.prototype);
$92f4fea5bc247620$var$H.isPureReactComponent = !0;
var $92f4fea5bc247620$var$I = Array.isArray, $92f4fea5bc247620$var$J = Object.prototype.hasOwnProperty, $92f4fea5bc247620$var$K = {
    current: null
}, $92f4fea5bc247620$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $92f4fea5bc247620$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$92f4fea5bc247620$var$J.call(b, d) && !$92f4fea5bc247620$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $92f4fea5bc247620$var$K.current
    };
}
function $92f4fea5bc247620$var$N(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $92f4fea5bc247620$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $92f4fea5bc247620$var$l;
}
function $92f4fea5bc247620$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $92f4fea5bc247620$var$P = /\/+/g;
function $92f4fea5bc247620$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $92f4fea5bc247620$var$escape("" + a.key) : b.toString(36);
}
function $92f4fea5bc247620$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $92f4fea5bc247620$var$l:
                case $92f4fea5bc247620$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $92f4fea5bc247620$var$Q(h, 0) : d, $92f4fea5bc247620$var$I(c) ? (e = "", null != a && (e = a.replace($92f4fea5bc247620$var$P, "$&/") + "/"), $92f4fea5bc247620$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($92f4fea5bc247620$var$O(c) && (c = $92f4fea5bc247620$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($92f4fea5bc247620$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($92f4fea5bc247620$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $92f4fea5bc247620$var$Q(k, g);
        h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    }
    else if (f = $92f4fea5bc247620$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $92f4fea5bc247620$var$Q(k, g++), h += $92f4fea5bc247620$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $92f4fea5bc247620$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $92f4fea5bc247620$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $92f4fea5bc247620$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $92f4fea5bc247620$var$U = {
    current: null
}, $92f4fea5bc247620$var$V = {
    transition: null
}, $92f4fea5bc247620$var$W = {
    ReactCurrentDispatcher: $92f4fea5bc247620$var$U,
    ReactCurrentBatchConfig: $92f4fea5bc247620$var$V,
    ReactCurrentOwner: $92f4fea5bc247620$var$K
};
$92f4fea5bc247620$export$dca3b0875bd9a954 = {
    map: $92f4fea5bc247620$var$S,
    forEach: function(a, b, e) {
        $92f4fea5bc247620$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $92f4fea5bc247620$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $92f4fea5bc247620$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$92f4fea5bc247620$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$92f4fea5bc247620$export$16fa2f45be04daa8 = $92f4fea5bc247620$var$E;
$92f4fea5bc247620$export$ffb0004e005737fa = $92f4fea5bc247620$var$p;
$92f4fea5bc247620$export$e2c29f18771995cb = $92f4fea5bc247620$var$r;
$92f4fea5bc247620$export$221d75b3f55bb0bd = $92f4fea5bc247620$var$G;
$92f4fea5bc247620$export$5f8d39834fd61797 = $92f4fea5bc247620$var$q;
$92f4fea5bc247620$export$74bf444e3cd11ea5 = $92f4fea5bc247620$var$w;
$92f4fea5bc247620$export$ae55be85d98224ed = $92f4fea5bc247620$var$W;
$92f4fea5bc247620$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $92f4fea5bc247620$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $92f4fea5bc247620$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$92f4fea5bc247620$var$J.call(b, f) && !$92f4fea5bc247620$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $92f4fea5bc247620$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$92f4fea5bc247620$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $92f4fea5bc247620$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $92f4fea5bc247620$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$92f4fea5bc247620$export$c8a8987d4410bf2d = $92f4fea5bc247620$var$M;
$92f4fea5bc247620$export$d38cd72104c1f0e9 = function(a) {
    var b = $92f4fea5bc247620$var$M.bind(null, a);
    b.type = a;
    return b;
};
$92f4fea5bc247620$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$92f4fea5bc247620$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$v,
        render: a
    };
};
$92f4fea5bc247620$export$a8257692ac88316c = $92f4fea5bc247620$var$O;
$92f4fea5bc247620$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $92f4fea5bc247620$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $92f4fea5bc247620$var$T
    };
};
$92f4fea5bc247620$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $92f4fea5bc247620$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$92f4fea5bc247620$export$7568632d0d33d16d = function(a) {
    var b = $92f4fea5bc247620$var$V.transition;
    $92f4fea5bc247620$var$V.transition = {};
    try {
        a();
    } finally{
        $92f4fea5bc247620$var$V.transition = b;
    }
};
$92f4fea5bc247620$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$92f4fea5bc247620$export$35808ee640e87ca7 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useCallback(a, b);
};
$92f4fea5bc247620$export$fae74005e78b1a27 = function(a) {
    return $92f4fea5bc247620$var$U.current.useContext(a);
};
$92f4fea5bc247620$export$dc8fbce3eb94dc1e = function() {};
$92f4fea5bc247620$export$6a7bc4e911dc01cf = function(a) {
    return $92f4fea5bc247620$var$U.current.useDeferredValue(a);
};
$92f4fea5bc247620$export$6d9c69b0de29b591 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useEffect(a, b);
};
$92f4fea5bc247620$export$f680877a34711e37 = function() {
    return $92f4fea5bc247620$var$U.current.useId();
};
$92f4fea5bc247620$export$d5a552a76deda3c2 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useImperativeHandle(a, b, e);
};
$92f4fea5bc247620$export$aaabe4eda9ed9969 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useInsertionEffect(a, b);
};
$92f4fea5bc247620$export$e5c5a5f917a5871c = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useLayoutEffect(a, b);
};
$92f4fea5bc247620$export$1538c33de8887b59 = function(a, b) {
    return $92f4fea5bc247620$var$U.current.useMemo(a, b);
};
$92f4fea5bc247620$export$13e3392192263954 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useReducer(a, b, e);
};
$92f4fea5bc247620$export$b8f5890fc79d6aca = function(a) {
    return $92f4fea5bc247620$var$U.current.useRef(a);
};
$92f4fea5bc247620$export$60241385465d0a34 = function(a) {
    return $92f4fea5bc247620$var$U.current.useState(a);
};
$92f4fea5bc247620$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $92f4fea5bc247620$var$U.current.useSyncExternalStore(a, b, e);
};
$92f4fea5bc247620$export$7b286972b8d8ccbf = function() {
    return $92f4fea5bc247620$var$U.current.useTransition();
};
$92f4fea5bc247620$export$83d89fbfd8236492 = "18.2.0";

});



parcelRequire.register("foRq4", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b36288e2db101ba3$export$ae55be85d98224ed; }, function (v) { return $b36288e2db101ba3$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $b36288e2db101ba3$export$d39a5bbd09211389; }, function (v) { return $b36288e2db101ba3$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $b36288e2db101ba3$export$882461b6382ed46c; }, function (v) { return $b36288e2db101ba3$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $b36288e2db101ba3$export$466bfc07425424d5; }, function (v) { return $b36288e2db101ba3$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $b36288e2db101ba3$export$cd75ccfd720a3cd4; }, function (v) { return $b36288e2db101ba3$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $b36288e2db101ba3$export$fa8d919ba61d84db; }, function (v) { return $b36288e2db101ba3$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $b36288e2db101ba3$export$757ceba2d55c277e; }, function (v) { return $b36288e2db101ba3$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $b36288e2db101ba3$export$b3890eb0ae9dca99; }, function (v) { return $b36288e2db101ba3$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $b36288e2db101ba3$export$502457920280e6be; }, function (v) { return $b36288e2db101ba3$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $b36288e2db101ba3$export$c78a37762a8d58e1; }, function (v) { return $b36288e2db101ba3$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $b36288e2db101ba3$export$dc54d992c10e8a18; }, function (v) { return $b36288e2db101ba3$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $b36288e2db101ba3$export$83d89fbfd8236492; }, function (v) { return $b36288e2db101ba3$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $b36288e2db101ba3$export$ae55be85d98224ed;
var $b36288e2db101ba3$export$d39a5bbd09211389;
var $b36288e2db101ba3$export$882461b6382ed46c;
var $b36288e2db101ba3$export$466bfc07425424d5;
var $b36288e2db101ba3$export$cd75ccfd720a3cd4;
var $b36288e2db101ba3$export$fa8d919ba61d84db;
var $b36288e2db101ba3$export$757ceba2d55c277e;
var $b36288e2db101ba3$export$b3890eb0ae9dca99;
var $b36288e2db101ba3$export$502457920280e6be;
var $b36288e2db101ba3$export$c78a37762a8d58e1;
var $b36288e2db101ba3$export$dc54d992c10e8a18;
var $b36288e2db101ba3$export$83d89fbfd8236492;
"use strict";

var $bh6RR = parcelRequire("bh6RR");

var $4LCdk = parcelRequire("4LCdk");
function $b36288e2db101ba3$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $b36288e2db101ba3$var$da = new Set, $b36288e2db101ba3$var$ea = {};
function $b36288e2db101ba3$var$fa(a, b) {
    $b36288e2db101ba3$var$ha(a, b);
    $b36288e2db101ba3$var$ha(a + "Capture", b);
}
function $b36288e2db101ba3$var$ha(a, b) {
    $b36288e2db101ba3$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$da.add(b[a]);
}
var $b36288e2db101ba3$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $b36288e2db101ba3$var$ja = Object.prototype.hasOwnProperty, $b36288e2db101ba3$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $b36288e2db101ba3$var$la = {}, $b36288e2db101ba3$var$ma = {};
function $b36288e2db101ba3$var$oa(a) {
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$ma, a)) return !0;
    if ($b36288e2db101ba3$var$ja.call($b36288e2db101ba3$var$la, a)) return !1;
    if ($b36288e2db101ba3$var$ka.test(a)) return $b36288e2db101ba3$var$ma[a] = !0;
    $b36288e2db101ba3$var$la[a] = !0;
    return !1;
}
function $b36288e2db101ba3$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $b36288e2db101ba3$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $b36288e2db101ba3$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $b36288e2db101ba3$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $b36288e2db101ba3$var$ra = /[\-:]([a-z])/g;
function $b36288e2db101ba3$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($b36288e2db101ba3$var$ra, $b36288e2db101ba3$var$sa);
    $b36288e2db101ba3$var$z[b] = new $b36288e2db101ba3$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$b36288e2db101ba3$var$z.xlinkHref = new $b36288e2db101ba3$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $b36288e2db101ba3$var$z[a] = new $b36288e2db101ba3$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $b36288e2db101ba3$var$ta(a, b, c, d) {
    var e = $b36288e2db101ba3$var$z.hasOwnProperty(b) ? $b36288e2db101ba3$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $b36288e2db101ba3$var$qa(b, c, e, d) && (c = null), d || null === e ? $b36288e2db101ba3$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $b36288e2db101ba3$var$ua = $bh6RR.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $b36288e2db101ba3$var$va = Symbol.for("react.element"), $b36288e2db101ba3$var$wa = Symbol.for("react.portal"), $b36288e2db101ba3$var$ya = Symbol.for("react.fragment"), $b36288e2db101ba3$var$za = Symbol.for("react.strict_mode"), $b36288e2db101ba3$var$Aa = Symbol.for("react.profiler"), $b36288e2db101ba3$var$Ba = Symbol.for("react.provider"), $b36288e2db101ba3$var$Ca = Symbol.for("react.context"), $b36288e2db101ba3$var$Da = Symbol.for("react.forward_ref"), $b36288e2db101ba3$var$Ea = Symbol.for("react.suspense"), $b36288e2db101ba3$var$Fa = Symbol.for("react.suspense_list"), $b36288e2db101ba3$var$Ga = Symbol.for("react.memo"), $b36288e2db101ba3$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $b36288e2db101ba3$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $b36288e2db101ba3$var$Ja = Symbol.iterator;
function $b36288e2db101ba3$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b36288e2db101ba3$var$Ja && a[$b36288e2db101ba3$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b36288e2db101ba3$var$A = Object.assign, $b36288e2db101ba3$var$La;
function $b36288e2db101ba3$var$Ma(a) {
    if (void 0 === $b36288e2db101ba3$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $b36288e2db101ba3$var$La = b && b[1] || "";
    }
    return "\n" + $b36288e2db101ba3$var$La + a;
}
var $b36288e2db101ba3$var$Na = !1;
function $b36288e2db101ba3$var$Oa(a, b) {
    if (!a || $b36288e2db101ba3$var$Na) return "";
    $b36288e2db101ba3$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $b36288e2db101ba3$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $b36288e2db101ba3$var$Ma(a) : "";
}
function $b36288e2db101ba3$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $b36288e2db101ba3$var$Ma(a.type);
        case 16:
            return $b36288e2db101ba3$var$Ma("Lazy");
        case 13:
            return $b36288e2db101ba3$var$Ma("Suspense");
        case 19:
            return $b36288e2db101ba3$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $b36288e2db101ba3$var$Oa(a.type, !1), a;
        case 11:
            return a = $b36288e2db101ba3$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $b36288e2db101ba3$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $b36288e2db101ba3$var$ya:
            return "Fragment";
        case $b36288e2db101ba3$var$wa:
            return "Portal";
        case $b36288e2db101ba3$var$Aa:
            return "Profiler";
        case $b36288e2db101ba3$var$za:
            return "StrictMode";
        case $b36288e2db101ba3$var$Ea:
            return "Suspense";
        case $b36288e2db101ba3$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $b36288e2db101ba3$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $b36288e2db101ba3$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $b36288e2db101ba3$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $b36288e2db101ba3$var$Ga:
            return b = a.displayName || null, null !== b ? b : $b36288e2db101ba3$var$Qa(a.type) || "Memo";
        case $b36288e2db101ba3$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $b36288e2db101ba3$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $b36288e2db101ba3$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $b36288e2db101ba3$var$Qa(b);
        case 8:
            return b === $b36288e2db101ba3$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $b36288e2db101ba3$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $b36288e2db101ba3$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $b36288e2db101ba3$var$Ua(a) {
    var b = $b36288e2db101ba3$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $b36288e2db101ba3$var$Va(a) {
    a._valueTracker || (a._valueTracker = $b36288e2db101ba3$var$Ua(a));
}
function $b36288e2db101ba3$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $b36288e2db101ba3$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $b36288e2db101ba3$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $b36288e2db101ba3$var$Ya(a, b) {
    var c = b.checked;
    return $b36288e2db101ba3$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $b36288e2db101ba3$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $b36288e2db101ba3$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $b36288e2db101ba3$var$ab(a, b) {
    b = b.checked;
    null != b && $b36288e2db101ba3$var$ta(a, "checked", b, !1);
}
function $b36288e2db101ba3$var$bb(a, b) {
    $b36288e2db101ba3$var$ab(a, b);
    var c = $b36288e2db101ba3$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $b36288e2db101ba3$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $b36288e2db101ba3$var$cb(a, b.type, $b36288e2db101ba3$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $b36288e2db101ba3$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $b36288e2db101ba3$var$cb(a, b, c) {
    if ("number" !== b || $b36288e2db101ba3$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $b36288e2db101ba3$var$eb = Array.isArray;
function $b36288e2db101ba3$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $b36288e2db101ba3$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $b36288e2db101ba3$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($b36288e2db101ba3$var$p(91));
    return $b36288e2db101ba3$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $b36288e2db101ba3$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($b36288e2db101ba3$var$p(92));
            if ($b36288e2db101ba3$var$eb(c)) {
                if (1 < c.length) throw Error($b36288e2db101ba3$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $b36288e2db101ba3$var$Sa(c)
    };
}
function $b36288e2db101ba3$var$ib(a, b) {
    var c = $b36288e2db101ba3$var$Sa(b.value), d = $b36288e2db101ba3$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $b36288e2db101ba3$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $b36288e2db101ba3$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $b36288e2db101ba3$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $b36288e2db101ba3$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $b36288e2db101ba3$var$mb, $b36288e2db101ba3$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $b36288e2db101ba3$var$mb = $b36288e2db101ba3$var$mb || document.createElement("div");
        $b36288e2db101ba3$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $b36288e2db101ba3$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $b36288e2db101ba3$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $b36288e2db101ba3$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $b36288e2db101ba3$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($b36288e2db101ba3$var$pb).forEach(function(a) {
    $b36288e2db101ba3$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $b36288e2db101ba3$var$pb[b] = $b36288e2db101ba3$var$pb[a];
    });
});
function $b36288e2db101ba3$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $b36288e2db101ba3$var$pb.hasOwnProperty(a) && $b36288e2db101ba3$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $b36288e2db101ba3$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $b36288e2db101ba3$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $b36288e2db101ba3$var$tb = $b36288e2db101ba3$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $b36288e2db101ba3$var$ub(a, b) {
    if (b) {
        if ($b36288e2db101ba3$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($b36288e2db101ba3$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($b36288e2db101ba3$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($b36288e2db101ba3$var$p(62));
    }
}
function $b36288e2db101ba3$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $b36288e2db101ba3$var$wb = null;
function $b36288e2db101ba3$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $b36288e2db101ba3$var$yb = null, $b36288e2db101ba3$var$zb = null, $b36288e2db101ba3$var$Ab = null;
function $b36288e2db101ba3$var$Bb(a) {
    if (a = $b36288e2db101ba3$var$Cb(a)) {
        if ("function" !== typeof $b36288e2db101ba3$var$yb) throw Error($b36288e2db101ba3$var$p(280));
        var b = a.stateNode;
        b && (b = $b36288e2db101ba3$var$Db(b), $b36288e2db101ba3$var$yb(a.stateNode, a.type, b));
    }
}
function $b36288e2db101ba3$var$Eb(a) {
    $b36288e2db101ba3$var$zb ? $b36288e2db101ba3$var$Ab ? $b36288e2db101ba3$var$Ab.push(a) : $b36288e2db101ba3$var$Ab = [
        a
    ] : $b36288e2db101ba3$var$zb = a;
}
function $b36288e2db101ba3$var$Fb() {
    if ($b36288e2db101ba3$var$zb) {
        var a = $b36288e2db101ba3$var$zb, b = $b36288e2db101ba3$var$Ab;
        $b36288e2db101ba3$var$Ab = $b36288e2db101ba3$var$zb = null;
        $b36288e2db101ba3$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$b36288e2db101ba3$var$Bb(b[a]);
    }
}
function $b36288e2db101ba3$var$Gb(a, b) {
    return a(b);
}
function $b36288e2db101ba3$var$Hb() {}
var $b36288e2db101ba3$var$Ib = !1;
function $b36288e2db101ba3$var$Jb(a, b, c) {
    if ($b36288e2db101ba3$var$Ib) return a(b, c);
    $b36288e2db101ba3$var$Ib = !0;
    try {
        return $b36288e2db101ba3$var$Gb(a, b, c);
    } finally{
        if ($b36288e2db101ba3$var$Ib = !1, null !== $b36288e2db101ba3$var$zb || null !== $b36288e2db101ba3$var$Ab) $b36288e2db101ba3$var$Hb(), $b36288e2db101ba3$var$Fb();
    }
}
function $b36288e2db101ba3$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $b36288e2db101ba3$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($b36288e2db101ba3$var$p(231, b, typeof c));
    return c;
}
var $b36288e2db101ba3$var$Lb = !1;
if ($b36288e2db101ba3$var$ia) try {
    var $b36288e2db101ba3$var$Mb = {};
    Object.defineProperty($b36288e2db101ba3$var$Mb, "passive", {
        get: function() {
            $b36288e2db101ba3$var$Lb = !0;
        }
    });
    window.addEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
    window.removeEventListener("test", $b36288e2db101ba3$var$Mb, $b36288e2db101ba3$var$Mb);
} catch (a) {
    $b36288e2db101ba3$var$Lb = !1;
}
function $b36288e2db101ba3$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $b36288e2db101ba3$var$Ob = !1, $b36288e2db101ba3$var$Pb = null, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, $b36288e2db101ba3$var$Sb = {
    onError: function(a) {
        $b36288e2db101ba3$var$Ob = !0;
        $b36288e2db101ba3$var$Pb = a;
    }
};
function $b36288e2db101ba3$var$Tb(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Ob = !1;
    $b36288e2db101ba3$var$Pb = null;
    $b36288e2db101ba3$var$Nb.apply($b36288e2db101ba3$var$Sb, arguments);
}
function $b36288e2db101ba3$var$Ub(a, b, c, d, e, f, g, h, k) {
    $b36288e2db101ba3$var$Tb.apply(this, arguments);
    if ($b36288e2db101ba3$var$Ob) {
        if ($b36288e2db101ba3$var$Ob) {
            var l = $b36288e2db101ba3$var$Pb;
            $b36288e2db101ba3$var$Ob = !1;
            $b36288e2db101ba3$var$Pb = null;
        } else throw Error($b36288e2db101ba3$var$p(198));
        $b36288e2db101ba3$var$Qb || ($b36288e2db101ba3$var$Qb = !0, $b36288e2db101ba3$var$Rb = l);
    }
}
function $b36288e2db101ba3$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b36288e2db101ba3$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $b36288e2db101ba3$var$Xb(a) {
    if ($b36288e2db101ba3$var$Vb(a) !== a) throw Error($b36288e2db101ba3$var$p(188));
}
function $b36288e2db101ba3$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $b36288e2db101ba3$var$Vb(a);
        if (null === b) throw Error($b36288e2db101ba3$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $b36288e2db101ba3$var$Xb(e), a;
                if (f === d) return $b36288e2db101ba3$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($b36288e2db101ba3$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($b36288e2db101ba3$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($b36288e2db101ba3$var$p(190));
    }
    if (3 !== c.tag) throw Error($b36288e2db101ba3$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $b36288e2db101ba3$var$Zb(a) {
    a = $b36288e2db101ba3$var$Yb(a);
    return null !== a ? $b36288e2db101ba3$var$$b(a) : null;
}
function $b36288e2db101ba3$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $b36288e2db101ba3$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$ac = $4LCdk.unstable_scheduleCallback, $b36288e2db101ba3$var$bc = $4LCdk.unstable_cancelCallback, $b36288e2db101ba3$var$cc = $4LCdk.unstable_shouldYield, $b36288e2db101ba3$var$dc = $4LCdk.unstable_requestPaint, $b36288e2db101ba3$var$B = $4LCdk.unstable_now, $b36288e2db101ba3$var$ec = $4LCdk.unstable_getCurrentPriorityLevel, $b36288e2db101ba3$var$fc = $4LCdk.unstable_ImmediatePriority, $b36288e2db101ba3$var$gc = $4LCdk.unstable_UserBlockingPriority, $b36288e2db101ba3$var$hc = $4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$ic = $4LCdk.unstable_LowPriority, $b36288e2db101ba3$var$jc = $4LCdk.unstable_IdlePriority, $b36288e2db101ba3$var$kc = null, $b36288e2db101ba3$var$lc = null;
function $b36288e2db101ba3$var$mc(a) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberRoot) try {
        $b36288e2db101ba3$var$lc.onCommitFiberRoot($b36288e2db101ba3$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $b36288e2db101ba3$var$oc = Math.clz32 ? Math.clz32 : $b36288e2db101ba3$var$nc, $b36288e2db101ba3$var$pc = Math.log, $b36288e2db101ba3$var$qc = Math.LN2;
function $b36288e2db101ba3$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($b36288e2db101ba3$var$pc(a) / $b36288e2db101ba3$var$qc | 0) | 0;
}
var $b36288e2db101ba3$var$rc = 64, $b36288e2db101ba3$var$sc = 4194304;
function $b36288e2db101ba3$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $b36288e2db101ba3$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $b36288e2db101ba3$var$tc(h) : (f &= g, 0 !== f && (d = $b36288e2db101ba3$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $b36288e2db101ba3$var$tc(g) : 0 !== f && (d = $b36288e2db101ba3$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $b36288e2db101ba3$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $b36288e2db101ba3$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $b36288e2db101ba3$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $b36288e2db101ba3$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $b36288e2db101ba3$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $b36288e2db101ba3$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $b36288e2db101ba3$var$yc() {
    var a = $b36288e2db101ba3$var$rc;
    $b36288e2db101ba3$var$rc <<= 1;
    0 === ($b36288e2db101ba3$var$rc & 4194240) && ($b36288e2db101ba3$var$rc = 64);
    return a;
}
function $b36288e2db101ba3$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $b36288e2db101ba3$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $b36288e2db101ba3$var$oc(b);
    a[b] = c;
}
function $b36288e2db101ba3$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $b36288e2db101ba3$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $b36288e2db101ba3$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $b36288e2db101ba3$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $b36288e2db101ba3$var$C = 0;
function $b36288e2db101ba3$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $b36288e2db101ba3$var$Ec, $b36288e2db101ba3$var$Fc, $b36288e2db101ba3$var$Gc, $b36288e2db101ba3$var$Hc, $b36288e2db101ba3$var$Ic, $b36288e2db101ba3$var$Jc = !1, $b36288e2db101ba3$var$Kc = [], $b36288e2db101ba3$var$Lc = null, $b36288e2db101ba3$var$Mc = null, $b36288e2db101ba3$var$Nc = null, $b36288e2db101ba3$var$Oc = new Map, $b36288e2db101ba3$var$Pc = new Map, $b36288e2db101ba3$var$Qc = [], $b36288e2db101ba3$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $b36288e2db101ba3$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $b36288e2db101ba3$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $b36288e2db101ba3$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $b36288e2db101ba3$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $b36288e2db101ba3$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $b36288e2db101ba3$var$Pc.delete(b.pointerId);
    }
}
function $b36288e2db101ba3$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $b36288e2db101ba3$var$Cb(b), null !== b && $b36288e2db101ba3$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $b36288e2db101ba3$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $b36288e2db101ba3$var$Lc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $b36288e2db101ba3$var$Mc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $b36288e2db101ba3$var$Nc = $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $b36288e2db101ba3$var$Oc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $b36288e2db101ba3$var$Pc.set(f, $b36288e2db101ba3$var$Tc($b36288e2db101ba3$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $b36288e2db101ba3$var$Vc(a) {
    var b = $b36288e2db101ba3$var$Wc(a.target);
    if (null !== b) {
        var c = $b36288e2db101ba3$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b36288e2db101ba3$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $b36288e2db101ba3$var$Ic(a.priority, function() {
                        $b36288e2db101ba3$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $b36288e2db101ba3$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $b36288e2db101ba3$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $b36288e2db101ba3$var$wb = d;
            c.target.dispatchEvent(d);
            $b36288e2db101ba3$var$wb = null;
        } else return b = $b36288e2db101ba3$var$Cb(c), null !== b && $b36288e2db101ba3$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $b36288e2db101ba3$var$Zc(a, b, c) {
    $b36288e2db101ba3$var$Xc(a) && c.delete(b);
}
function $b36288e2db101ba3$var$$c() {
    $b36288e2db101ba3$var$Jc = !1;
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Lc) && ($b36288e2db101ba3$var$Lc = null);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Mc) && ($b36288e2db101ba3$var$Mc = null);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$Xc($b36288e2db101ba3$var$Nc) && ($b36288e2db101ba3$var$Nc = null);
    $b36288e2db101ba3$var$Oc.forEach($b36288e2db101ba3$var$Zc);
    $b36288e2db101ba3$var$Pc.forEach($b36288e2db101ba3$var$Zc);
}
function $b36288e2db101ba3$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $b36288e2db101ba3$var$Jc || ($b36288e2db101ba3$var$Jc = !0, $4LCdk.unstable_scheduleCallback($4LCdk.unstable_NormalPriority, $b36288e2db101ba3$var$$c)));
}
function $b36288e2db101ba3$var$bd(a) {
    function b(b) {
        return $b36288e2db101ba3$var$ad(b, a);
    }
    if (0 < $b36288e2db101ba3$var$Kc.length) {
        $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Kc[0], a);
        for(var c = 1; c < $b36288e2db101ba3$var$Kc.length; c++){
            var d = $b36288e2db101ba3$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $b36288e2db101ba3$var$Lc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Lc, a);
    null !== $b36288e2db101ba3$var$Mc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Mc, a);
    null !== $b36288e2db101ba3$var$Nc && $b36288e2db101ba3$var$ad($b36288e2db101ba3$var$Nc, a);
    $b36288e2db101ba3$var$Oc.forEach(b);
    $b36288e2db101ba3$var$Pc.forEach(b);
    for(c = 0; c < $b36288e2db101ba3$var$Qc.length; c++)d = $b36288e2db101ba3$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $b36288e2db101ba3$var$Qc.length && (c = $b36288e2db101ba3$var$Qc[0], null === c.blockedOn);)$b36288e2db101ba3$var$Vc(c), null === c.blockedOn && $b36288e2db101ba3$var$Qc.shift();
}
var $b36288e2db101ba3$var$cd = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$dd = !0;
function $b36288e2db101ba3$var$ed(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$gd(a, b, c, d) {
    var e = $b36288e2db101ba3$var$C, f = $b36288e2db101ba3$var$cd.transition;
    $b36288e2db101ba3$var$cd.transition = null;
    try {
        $b36288e2db101ba3$var$C = 4, $b36288e2db101ba3$var$fd(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$C = e, $b36288e2db101ba3$var$cd.transition = f;
    }
}
function $b36288e2db101ba3$var$fd(a, b, c, d) {
    if ($b36288e2db101ba3$var$dd) {
        var e = $b36288e2db101ba3$var$Yc(a, b, c, d);
        if (null === e) $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c), $b36288e2db101ba3$var$Sc(a, d);
        else if ($b36288e2db101ba3$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($b36288e2db101ba3$var$Sc(a, d), b & 4 && -1 < $b36288e2db101ba3$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $b36288e2db101ba3$var$Cb(e);
                null !== f && $b36288e2db101ba3$var$Ec(f);
                f = $b36288e2db101ba3$var$Yc(a, b, c, d);
                null === f && $b36288e2db101ba3$var$hd(a, b, d, $b36288e2db101ba3$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $b36288e2db101ba3$var$hd(a, b, d, null, c);
    }
}
var $b36288e2db101ba3$var$id = null;
function $b36288e2db101ba3$var$Yc(a, b, c, d) {
    $b36288e2db101ba3$var$id = null;
    a = $b36288e2db101ba3$var$xb(d);
    a = $b36288e2db101ba3$var$Wc(a);
    if (null !== a) {
        if (b = $b36288e2db101ba3$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $b36288e2db101ba3$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $b36288e2db101ba3$var$id = a;
    return null;
}
function $b36288e2db101ba3$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($b36288e2db101ba3$var$ec()){
                case $b36288e2db101ba3$var$fc:
                    return 1;
                case $b36288e2db101ba3$var$gc:
                    return 4;
                case $b36288e2db101ba3$var$hc:
                case $b36288e2db101ba3$var$ic:
                    return 16;
                case $b36288e2db101ba3$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ld = null, $b36288e2db101ba3$var$md = null;
function $b36288e2db101ba3$var$nd() {
    if ($b36288e2db101ba3$var$md) return $b36288e2db101ba3$var$md;
    var a, b = $b36288e2db101ba3$var$ld, c = b.length, d, e = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $b36288e2db101ba3$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $b36288e2db101ba3$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $b36288e2db101ba3$var$pd() {
    return !0;
}
function $b36288e2db101ba3$var$qd() {
    return !1;
}
function $b36288e2db101ba3$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $b36288e2db101ba3$var$pd : $b36288e2db101ba3$var$qd;
        this.isPropagationStopped = $b36288e2db101ba3$var$qd;
        return this;
    }
    $b36288e2db101ba3$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $b36288e2db101ba3$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $b36288e2db101ba3$var$pd);
        },
        persist: function() {},
        isPersistent: $b36288e2db101ba3$var$pd
    });
    return b;
}
var $b36288e2db101ba3$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $b36288e2db101ba3$var$td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$sd), $b36288e2db101ba3$var$ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    view: 0,
    detail: 0
}), $b36288e2db101ba3$var$vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$ud), $b36288e2db101ba3$var$wd, $b36288e2db101ba3$var$xd, $b36288e2db101ba3$var$yd, $b36288e2db101ba3$var$Ad = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $b36288e2db101ba3$var$yd && ($b36288e2db101ba3$var$yd && "mousemove" === a.type ? ($b36288e2db101ba3$var$wd = a.screenX - $b36288e2db101ba3$var$yd.screenX, $b36288e2db101ba3$var$xd = a.screenY - $b36288e2db101ba3$var$yd.screenY) : $b36288e2db101ba3$var$xd = $b36288e2db101ba3$var$wd = 0, $b36288e2db101ba3$var$yd = a);
        return $b36288e2db101ba3$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $b36288e2db101ba3$var$xd;
    }
}), $b36288e2db101ba3$var$Bd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ad), $b36288e2db101ba3$var$Cd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    dataTransfer: 0
}), $b36288e2db101ba3$var$Dd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Cd), $b36288e2db101ba3$var$Ed = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    relatedTarget: 0
}), $b36288e2db101ba3$var$Fd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ed), $b36288e2db101ba3$var$Gd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Hd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Gd), $b36288e2db101ba3$var$Id = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $b36288e2db101ba3$var$Jd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Id), $b36288e2db101ba3$var$Kd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    data: 0
}), $b36288e2db101ba3$var$Ld = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Kd), $b36288e2db101ba3$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $b36288e2db101ba3$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $b36288e2db101ba3$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $b36288e2db101ba3$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $b36288e2db101ba3$var$Od[a]) ? !!b[a] : !1;
}
function $b36288e2db101ba3$var$zd() {
    return $b36288e2db101ba3$var$Pd;
}
var $b36288e2db101ba3$var$Qd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $b36288e2db101ba3$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $b36288e2db101ba3$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $b36288e2db101ba3$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $b36288e2db101ba3$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $b36288e2db101ba3$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $b36288e2db101ba3$var$Rd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Qd), $b36288e2db101ba3$var$Sd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $b36288e2db101ba3$var$Td = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Sd), $b36288e2db101ba3$var$Ud = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $b36288e2db101ba3$var$zd
}), $b36288e2db101ba3$var$Vd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Ud), $b36288e2db101ba3$var$Wd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $b36288e2db101ba3$var$Xd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Wd), $b36288e2db101ba3$var$Yd = $b36288e2db101ba3$var$A({}, $b36288e2db101ba3$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $b36288e2db101ba3$var$Zd = $b36288e2db101ba3$var$rd($b36288e2db101ba3$var$Yd), $b36288e2db101ba3$var$$d = [
    9,
    13,
    27,
    32
], $b36288e2db101ba3$var$ae = $b36288e2db101ba3$var$ia && "CompositionEvent" in window, $b36288e2db101ba3$var$be = null;
$b36288e2db101ba3$var$ia && "documentMode" in document && ($b36288e2db101ba3$var$be = document.documentMode);
var $b36288e2db101ba3$var$ce = $b36288e2db101ba3$var$ia && "TextEvent" in window && !$b36288e2db101ba3$var$be, $b36288e2db101ba3$var$de = $b36288e2db101ba3$var$ia && (!$b36288e2db101ba3$var$ae || $b36288e2db101ba3$var$be && 8 < $b36288e2db101ba3$var$be && 11 >= $b36288e2db101ba3$var$be), $b36288e2db101ba3$var$ee = String.fromCharCode(32), $b36288e2db101ba3$var$fe = !1;
function $b36288e2db101ba3$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $b36288e2db101ba3$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $b36288e2db101ba3$var$ie = !1;
function $b36288e2db101ba3$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $b36288e2db101ba3$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $b36288e2db101ba3$var$fe = !0;
            return $b36288e2db101ba3$var$ee;
        case "textInput":
            return a = b.data, a === $b36288e2db101ba3$var$ee && $b36288e2db101ba3$var$fe ? null : a;
        default:
            return null;
    }
}
function $b36288e2db101ba3$var$ke(a, b) {
    if ($b36288e2db101ba3$var$ie) return "compositionend" === a || !$b36288e2db101ba3$var$ae && $b36288e2db101ba3$var$ge(a, b) ? (a = $b36288e2db101ba3$var$nd(), $b36288e2db101ba3$var$md = $b36288e2db101ba3$var$ld = $b36288e2db101ba3$var$kd = null, $b36288e2db101ba3$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $b36288e2db101ba3$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $b36288e2db101ba3$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$b36288e2db101ba3$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $b36288e2db101ba3$var$ne(a, b, c, d) {
    $b36288e2db101ba3$var$Eb(d);
    b = $b36288e2db101ba3$var$oe(b, "onChange");
    0 < b.length && (c = new $b36288e2db101ba3$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $b36288e2db101ba3$var$pe = null, $b36288e2db101ba3$var$qe = null;
function $b36288e2db101ba3$var$re(a) {
    $b36288e2db101ba3$var$se(a, 0);
}
function $b36288e2db101ba3$var$te(a) {
    var b = $b36288e2db101ba3$var$ue(a);
    if ($b36288e2db101ba3$var$Wa(b)) return a;
}
function $b36288e2db101ba3$var$ve(a, b) {
    if ("change" === a) return b;
}
var $b36288e2db101ba3$var$we = !1;
if ($b36288e2db101ba3$var$ia) {
    var $b36288e2db101ba3$var$xe;
    if ($b36288e2db101ba3$var$ia) {
        var $b36288e2db101ba3$var$ye = "oninput" in document;
        if (!$b36288e2db101ba3$var$ye) {
            var $b36288e2db101ba3$var$ze = document.createElement("div");
            $b36288e2db101ba3$var$ze.setAttribute("oninput", "return;");
            $b36288e2db101ba3$var$ye = "function" === typeof $b36288e2db101ba3$var$ze.oninput;
        }
        $b36288e2db101ba3$var$xe = $b36288e2db101ba3$var$ye;
    } else $b36288e2db101ba3$var$xe = !1;
    $b36288e2db101ba3$var$we = $b36288e2db101ba3$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $b36288e2db101ba3$var$Ae() {
    $b36288e2db101ba3$var$pe && ($b36288e2db101ba3$var$pe.detachEvent("onpropertychange", $b36288e2db101ba3$var$Be), $b36288e2db101ba3$var$qe = $b36288e2db101ba3$var$pe = null);
}
function $b36288e2db101ba3$var$Be(a) {
    if ("value" === a.propertyName && $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe)) {
        var b = [];
        $b36288e2db101ba3$var$ne(b, $b36288e2db101ba3$var$qe, a, $b36288e2db101ba3$var$xb(a));
        $b36288e2db101ba3$var$Jb($b36288e2db101ba3$var$re, b);
    }
}
function $b36288e2db101ba3$var$Ce(a, b, c) {
    "focusin" === a ? ($b36288e2db101ba3$var$Ae(), $b36288e2db101ba3$var$pe = b, $b36288e2db101ba3$var$qe = c, $b36288e2db101ba3$var$pe.attachEvent("onpropertychange", $b36288e2db101ba3$var$Be)) : "focusout" === a && $b36288e2db101ba3$var$Ae();
}
function $b36288e2db101ba3$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $b36288e2db101ba3$var$te($b36288e2db101ba3$var$qe);
}
function $b36288e2db101ba3$var$Ee(a, b) {
    if ("click" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $b36288e2db101ba3$var$te(b);
}
function $b36288e2db101ba3$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $b36288e2db101ba3$var$He = "function" === typeof Object.is ? Object.is : $b36288e2db101ba3$var$Ge;
function $b36288e2db101ba3$var$Ie(a, b) {
    if ($b36288e2db101ba3$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$b36288e2db101ba3$var$ja.call(b, e) || !$b36288e2db101ba3$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $b36288e2db101ba3$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $b36288e2db101ba3$var$Ke(a, b) {
    var c = $b36288e2db101ba3$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $b36288e2db101ba3$var$Je(c);
    }
}
function $b36288e2db101ba3$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $b36288e2db101ba3$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $b36288e2db101ba3$var$Me() {
    for(var a = window, b = $b36288e2db101ba3$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $b36288e2db101ba3$var$Xa(a.document);
    }
    return b;
}
function $b36288e2db101ba3$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $b36288e2db101ba3$var$Oe(a) {
    var b = $b36288e2db101ba3$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $b36288e2db101ba3$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $b36288e2db101ba3$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $b36288e2db101ba3$var$Ke(c, f);
                var g = $b36288e2db101ba3$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $b36288e2db101ba3$var$Pe = $b36288e2db101ba3$var$ia && "documentMode" in document && 11 >= document.documentMode, $b36288e2db101ba3$var$Qe = null, $b36288e2db101ba3$var$Re = null, $b36288e2db101ba3$var$Se = null, $b36288e2db101ba3$var$Te = !1;
function $b36288e2db101ba3$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $b36288e2db101ba3$var$Te || null == $b36288e2db101ba3$var$Qe || $b36288e2db101ba3$var$Qe !== $b36288e2db101ba3$var$Xa(d) || (d = $b36288e2db101ba3$var$Qe, "selectionStart" in d && $b36288e2db101ba3$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $b36288e2db101ba3$var$Se && $b36288e2db101ba3$var$Ie($b36288e2db101ba3$var$Se, d) || ($b36288e2db101ba3$var$Se = d, d = $b36288e2db101ba3$var$oe($b36288e2db101ba3$var$Re, "onSelect"), 0 < d.length && (b = new $b36288e2db101ba3$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $b36288e2db101ba3$var$Qe)));
}
function $b36288e2db101ba3$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $b36288e2db101ba3$var$We = {
    animationend: $b36288e2db101ba3$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $b36288e2db101ba3$var$Ve("Animation", "AnimationIteration"),
    animationstart: $b36288e2db101ba3$var$Ve("Animation", "AnimationStart"),
    transitionend: $b36288e2db101ba3$var$Ve("Transition", "TransitionEnd")
}, $b36288e2db101ba3$var$Xe = {}, $b36288e2db101ba3$var$Ye = {};
$b36288e2db101ba3$var$ia && ($b36288e2db101ba3$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $b36288e2db101ba3$var$We.animationend.animation, delete $b36288e2db101ba3$var$We.animationiteration.animation, delete $b36288e2db101ba3$var$We.animationstart.animation), "TransitionEvent" in window || delete $b36288e2db101ba3$var$We.transitionend.transition);
function $b36288e2db101ba3$var$Ze(a) {
    if ($b36288e2db101ba3$var$Xe[a]) return $b36288e2db101ba3$var$Xe[a];
    if (!$b36288e2db101ba3$var$We[a]) return a;
    var b = $b36288e2db101ba3$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $b36288e2db101ba3$var$Ye) return $b36288e2db101ba3$var$Xe[a] = b[c];
    return a;
}
var $b36288e2db101ba3$var$$e = $b36288e2db101ba3$var$Ze("animationend"), $b36288e2db101ba3$var$af = $b36288e2db101ba3$var$Ze("animationiteration"), $b36288e2db101ba3$var$bf = $b36288e2db101ba3$var$Ze("animationstart"), $b36288e2db101ba3$var$cf = $b36288e2db101ba3$var$Ze("transitionend"), $b36288e2db101ba3$var$df = new Map, $b36288e2db101ba3$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $b36288e2db101ba3$var$ff(a, b) {
    $b36288e2db101ba3$var$df.set(a, b);
    $b36288e2db101ba3$var$fa(b, [
        a
    ]);
}
for(var $b36288e2db101ba3$var$gf = 0; $b36288e2db101ba3$var$gf < $b36288e2db101ba3$var$ef.length; $b36288e2db101ba3$var$gf++){
    var $b36288e2db101ba3$var$hf = $b36288e2db101ba3$var$ef[$b36288e2db101ba3$var$gf], $b36288e2db101ba3$var$jf = $b36288e2db101ba3$var$hf.toLowerCase(), $b36288e2db101ba3$var$kf = $b36288e2db101ba3$var$hf[0].toUpperCase() + $b36288e2db101ba3$var$hf.slice(1);
    $b36288e2db101ba3$var$ff($b36288e2db101ba3$var$jf, "on" + $b36288e2db101ba3$var$kf);
}
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$$e, "onAnimationEnd");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$af, "onAnimationIteration");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$bf, "onAnimationStart");
$b36288e2db101ba3$var$ff("dblclick", "onDoubleClick");
$b36288e2db101ba3$var$ff("focusin", "onFocus");
$b36288e2db101ba3$var$ff("focusout", "onBlur");
$b36288e2db101ba3$var$ff($b36288e2db101ba3$var$cf, "onTransitionEnd");
$b36288e2db101ba3$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$b36288e2db101ba3$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$b36288e2db101ba3$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$b36288e2db101ba3$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$b36288e2db101ba3$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$b36288e2db101ba3$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $b36288e2db101ba3$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $b36288e2db101ba3$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($b36288e2db101ba3$var$lf));
function $b36288e2db101ba3$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $b36288e2db101ba3$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $b36288e2db101ba3$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $b36288e2db101ba3$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($b36288e2db101ba3$var$Qb) throw a = $b36288e2db101ba3$var$Rb, $b36288e2db101ba3$var$Qb = !1, $b36288e2db101ba3$var$Rb = null, a;
}
function $b36288e2db101ba3$var$D(a, b) {
    var c = b[$b36288e2db101ba3$var$of];
    void 0 === c && (c = b[$b36288e2db101ba3$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($b36288e2db101ba3$var$pf(b, a, 2, !1), c.add(d));
}
function $b36288e2db101ba3$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $b36288e2db101ba3$var$pf(c, a, d, b);
}
var $b36288e2db101ba3$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $b36288e2db101ba3$var$sf(a) {
    if (!a[$b36288e2db101ba3$var$rf]) {
        a[$b36288e2db101ba3$var$rf] = !0;
        $b36288e2db101ba3$var$da.forEach(function(b) {
            "selectionchange" !== b && ($b36288e2db101ba3$var$mf.has(b) || $b36288e2db101ba3$var$qf(b, !1, a), $b36288e2db101ba3$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$b36288e2db101ba3$var$rf] || (b[$b36288e2db101ba3$var$rf] = !0, $b36288e2db101ba3$var$qf("selectionchange", !1, b));
    }
}
function $b36288e2db101ba3$var$pf(a, b, c, d) {
    switch($b36288e2db101ba3$var$jd(b)){
        case 1:
            var e = $b36288e2db101ba3$var$ed;
            break;
        case 4:
            e = $b36288e2db101ba3$var$gd;
            break;
        default:
            e = $b36288e2db101ba3$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$b36288e2db101ba3$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $b36288e2db101ba3$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $b36288e2db101ba3$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $b36288e2db101ba3$var$Jb(function() {
        var d = f, e = $b36288e2db101ba3$var$xb(c), g = [];
        a: {
            var h = $b36288e2db101ba3$var$df.get(a);
            if (void 0 !== h) {
                var k = $b36288e2db101ba3$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $b36288e2db101ba3$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $b36288e2db101ba3$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $b36288e2db101ba3$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $b36288e2db101ba3$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $b36288e2db101ba3$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $b36288e2db101ba3$var$Vd;
                        break;
                    case $b36288e2db101ba3$var$$e:
                    case $b36288e2db101ba3$var$af:
                    case $b36288e2db101ba3$var$bf:
                        k = $b36288e2db101ba3$var$Hd;
                        break;
                    case $b36288e2db101ba3$var$cf:
                        k = $b36288e2db101ba3$var$Xd;
                        break;
                    case "scroll":
                        k = $b36288e2db101ba3$var$vd;
                        break;
                    case "wheel":
                        k = $b36288e2db101ba3$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $b36288e2db101ba3$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $b36288e2db101ba3$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $b36288e2db101ba3$var$Kb(w, x), null != F && t.push($b36288e2db101ba3$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $b36288e2db101ba3$var$wb && (n = c.relatedTarget || c.fromElement) && ($b36288e2db101ba3$var$Wc(n) || n[$b36288e2db101ba3$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $b36288e2db101ba3$var$Wc(n) : null, null !== n && (J = $b36288e2db101ba3$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $b36288e2db101ba3$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $b36288e2db101ba3$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $b36288e2db101ba3$var$ue(k);
                        u = null == n ? h : $b36288e2db101ba3$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $b36288e2db101ba3$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $b36288e2db101ba3$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $b36288e2db101ba3$var$vf(F))u++;
                            for(; 0 < w - u;)t = $b36288e2db101ba3$var$vf(t), w--;
                            for(; 0 < u - w;)x = $b36288e2db101ba3$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $b36288e2db101ba3$var$vf(t);
                                x = $b36288e2db101ba3$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $b36288e2db101ba3$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $b36288e2db101ba3$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $b36288e2db101ba3$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $b36288e2db101ba3$var$ve;
                else if ($b36288e2db101ba3$var$me(h)) {
                    if ($b36288e2db101ba3$var$we) na = $b36288e2db101ba3$var$Fe;
                    else {
                        na = $b36288e2db101ba3$var$De;
                        var xa = $b36288e2db101ba3$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $b36288e2db101ba3$var$Ee);
                if (na && (na = na(a, d))) {
                    $b36288e2db101ba3$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $b36288e2db101ba3$var$cb(h, "number", h.value);
            }
            xa = d ? $b36288e2db101ba3$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($b36288e2db101ba3$var$me(xa) || "true" === xa.contentEditable) $b36288e2db101ba3$var$Qe = xa, $b36288e2db101ba3$var$Re = d, $b36288e2db101ba3$var$Se = null;
                    break;
                case "focusout":
                    $b36288e2db101ba3$var$Se = $b36288e2db101ba3$var$Re = $b36288e2db101ba3$var$Qe = null;
                    break;
                case "mousedown":
                    $b36288e2db101ba3$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $b36288e2db101ba3$var$Te = !1;
                    $b36288e2db101ba3$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($b36288e2db101ba3$var$Pe) break;
                case "keydown":
                case "keyup":
                    $b36288e2db101ba3$var$Ue(g, c, e);
            }
            var $a;
            if ($b36288e2db101ba3$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $b36288e2db101ba3$var$ie ? $b36288e2db101ba3$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($b36288e2db101ba3$var$de && "ko" !== c.locale && ($b36288e2db101ba3$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $b36288e2db101ba3$var$ie && ($a = $b36288e2db101ba3$var$nd()) : ($b36288e2db101ba3$var$kd = e, $b36288e2db101ba3$var$ld = "value" in $b36288e2db101ba3$var$kd ? $b36288e2db101ba3$var$kd.value : $b36288e2db101ba3$var$kd.textContent, $b36288e2db101ba3$var$ie = !0)), xa = $b36288e2db101ba3$var$oe(d, ba), 0 < xa.length && (ba = new $b36288e2db101ba3$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $b36288e2db101ba3$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $b36288e2db101ba3$var$ce ? $b36288e2db101ba3$var$je(a, c) : $b36288e2db101ba3$var$ke(a, c)) d = $b36288e2db101ba3$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $b36288e2db101ba3$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $b36288e2db101ba3$var$se(g, b);
    });
}
function $b36288e2db101ba3$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $b36288e2db101ba3$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $b36288e2db101ba3$var$Kb(a, c), null != f && d.unshift($b36288e2db101ba3$var$tf(a, f, e)), f = $b36288e2db101ba3$var$Kb(a, b), null != f && d.push($b36288e2db101ba3$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $b36288e2db101ba3$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $b36288e2db101ba3$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.unshift($b36288e2db101ba3$var$tf(c, k, h))) : e || (k = $b36288e2db101ba3$var$Kb(c, f), null != k && g.push($b36288e2db101ba3$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $b36288e2db101ba3$var$xf = /\r\n?/g, $b36288e2db101ba3$var$yf = /\u0000|\uFFFD/g;
function $b36288e2db101ba3$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($b36288e2db101ba3$var$xf, "\n").replace($b36288e2db101ba3$var$yf, "");
}
function $b36288e2db101ba3$var$Af(a, b, c) {
    b = $b36288e2db101ba3$var$zf(b);
    if ($b36288e2db101ba3$var$zf(a) !== b && c) throw Error($b36288e2db101ba3$var$p(425));
}
function $b36288e2db101ba3$var$Bf() {}
var $b36288e2db101ba3$var$Cf = null, $b36288e2db101ba3$var$Df = null;
function $b36288e2db101ba3$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $b36288e2db101ba3$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $b36288e2db101ba3$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $b36288e2db101ba3$var$Hf = "function" === typeof Promise ? Promise : void 0, $b36288e2db101ba3$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $b36288e2db101ba3$var$Hf ? function(a) {
    return $b36288e2db101ba3$var$Hf.resolve(null).then(a).catch($b36288e2db101ba3$var$If);
} : $b36288e2db101ba3$var$Ff;
function $b36288e2db101ba3$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $b36288e2db101ba3$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $b36288e2db101ba3$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $b36288e2db101ba3$var$bd(b);
}
function $b36288e2db101ba3$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $b36288e2db101ba3$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nf = Math.random().toString(36).slice(2), $b36288e2db101ba3$var$Of = "__reactFiber$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Pf = "__reactProps$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$uf = "__reactContainer$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$of = "__reactEvents$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Qf = "__reactListeners$" + $b36288e2db101ba3$var$Nf, $b36288e2db101ba3$var$Rf = "__reactHandles$" + $b36288e2db101ba3$var$Nf;
function $b36288e2db101ba3$var$Wc(a) {
    var b = a[$b36288e2db101ba3$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$b36288e2db101ba3$var$uf] || c[$b36288e2db101ba3$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $b36288e2db101ba3$var$Mf(a); null !== a;){
                if (c = a[$b36288e2db101ba3$var$Of]) return c;
                a = $b36288e2db101ba3$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $b36288e2db101ba3$var$Cb(a) {
    a = a[$b36288e2db101ba3$var$Of] || a[$b36288e2db101ba3$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $b36288e2db101ba3$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($b36288e2db101ba3$var$p(33));
}
function $b36288e2db101ba3$var$Db(a) {
    return a[$b36288e2db101ba3$var$Pf] || null;
}
var $b36288e2db101ba3$var$Sf = [], $b36288e2db101ba3$var$Tf = -1;
function $b36288e2db101ba3$var$Uf(a) {
    return {
        current: a
    };
}
function $b36288e2db101ba3$var$E(a) {
    0 > $b36288e2db101ba3$var$Tf || (a.current = $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf], $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = null, $b36288e2db101ba3$var$Tf--);
}
function $b36288e2db101ba3$var$G(a, b) {
    $b36288e2db101ba3$var$Tf++;
    $b36288e2db101ba3$var$Sf[$b36288e2db101ba3$var$Tf] = a.current;
    a.current = b;
}
var $b36288e2db101ba3$var$Vf = {}, $b36288e2db101ba3$var$H = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Vf), $b36288e2db101ba3$var$Wf = $b36288e2db101ba3$var$Uf(!1), $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$Vf;
function $b36288e2db101ba3$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $b36288e2db101ba3$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $b36288e2db101ba3$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $b36288e2db101ba3$var$$f() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
}
function $b36288e2db101ba3$var$ag(a, b, c) {
    if ($b36288e2db101ba3$var$H.current !== $b36288e2db101ba3$var$Vf) throw Error($b36288e2db101ba3$var$p(168));
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
function $b36288e2db101ba3$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($b36288e2db101ba3$var$p(108, $b36288e2db101ba3$var$Ra(a) || "Unknown", e));
    return $b36288e2db101ba3$var$A({}, c, d);
}
function $b36288e2db101ba3$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $b36288e2db101ba3$var$Vf;
    $b36288e2db101ba3$var$Xf = $b36288e2db101ba3$var$H.current;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, $b36288e2db101ba3$var$Wf.current);
    return !0;
}
function $b36288e2db101ba3$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($b36288e2db101ba3$var$p(169));
    c ? (a = $b36288e2db101ba3$var$bg(a, b, $b36288e2db101ba3$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$H, a)) : $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Wf, c);
}
var $b36288e2db101ba3$var$eg = null, $b36288e2db101ba3$var$fg = !1, $b36288e2db101ba3$var$gg = !1;
function $b36288e2db101ba3$var$hg(a) {
    null === $b36288e2db101ba3$var$eg ? $b36288e2db101ba3$var$eg = [
        a
    ] : $b36288e2db101ba3$var$eg.push(a);
}
function $b36288e2db101ba3$var$ig(a) {
    $b36288e2db101ba3$var$fg = !0;
    $b36288e2db101ba3$var$hg(a);
}
function $b36288e2db101ba3$var$jg() {
    if (!$b36288e2db101ba3$var$gg && null !== $b36288e2db101ba3$var$eg) {
        $b36288e2db101ba3$var$gg = !0;
        var a = 0, b = $b36288e2db101ba3$var$C;
        try {
            var c = $b36288e2db101ba3$var$eg;
            for($b36288e2db101ba3$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $b36288e2db101ba3$var$eg = null;
            $b36288e2db101ba3$var$fg = !1;
        } catch (e) {
            throw null !== $b36288e2db101ba3$var$eg && ($b36288e2db101ba3$var$eg = $b36288e2db101ba3$var$eg.slice(a + 1)), $b36288e2db101ba3$var$ac($b36288e2db101ba3$var$fc, $b36288e2db101ba3$var$jg), e;
        } finally{
            $b36288e2db101ba3$var$C = b, $b36288e2db101ba3$var$gg = !1;
        }
    }
    return null;
}
var $b36288e2db101ba3$var$kg = [], $b36288e2db101ba3$var$lg = 0, $b36288e2db101ba3$var$mg = null, $b36288e2db101ba3$var$ng = 0, $b36288e2db101ba3$var$og = [], $b36288e2db101ba3$var$pg = 0, $b36288e2db101ba3$var$qg = null, $b36288e2db101ba3$var$rg = 1, $b36288e2db101ba3$var$sg = "";
function $b36288e2db101ba3$var$tg(a, b) {
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$ng;
    $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg++] = $b36288e2db101ba3$var$mg;
    $b36288e2db101ba3$var$mg = a;
    $b36288e2db101ba3$var$ng = b;
}
function $b36288e2db101ba3$var$ug(a, b, c) {
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg;
    $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg;
    $b36288e2db101ba3$var$qg = a;
    var d = $b36288e2db101ba3$var$rg;
    a = $b36288e2db101ba3$var$sg;
    var e = 32 - $b36288e2db101ba3$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $b36288e2db101ba3$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $b36288e2db101ba3$var$rg = 1 << 32 - $b36288e2db101ba3$var$oc(b) + e | c << e | d;
        $b36288e2db101ba3$var$sg = f + a;
    } else $b36288e2db101ba3$var$rg = 1 << f | c << e | d, $b36288e2db101ba3$var$sg = a;
}
function $b36288e2db101ba3$var$vg(a) {
    null !== a.return && ($b36288e2db101ba3$var$tg(a, 1), $b36288e2db101ba3$var$ug(a, 1, 0));
}
function $b36288e2db101ba3$var$wg(a) {
    for(; a === $b36288e2db101ba3$var$mg;)$b36288e2db101ba3$var$mg = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null, $b36288e2db101ba3$var$ng = $b36288e2db101ba3$var$kg[--$b36288e2db101ba3$var$lg], $b36288e2db101ba3$var$kg[$b36288e2db101ba3$var$lg] = null;
    for(; a === $b36288e2db101ba3$var$qg;)$b36288e2db101ba3$var$qg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$sg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null, $b36288e2db101ba3$var$rg = $b36288e2db101ba3$var$og[--$b36288e2db101ba3$var$pg], $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg] = null;
}
var $b36288e2db101ba3$var$xg = null, $b36288e2db101ba3$var$yg = null, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$zg = null;
function $b36288e2db101ba3$var$Ag(a, b) {
    var c = $b36288e2db101ba3$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $b36288e2db101ba3$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $b36288e2db101ba3$var$qg ? {
                id: $b36288e2db101ba3$var$rg,
                overflow: $b36288e2db101ba3$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $b36288e2db101ba3$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $b36288e2db101ba3$var$xg = a, $b36288e2db101ba3$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $b36288e2db101ba3$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $b36288e2db101ba3$var$Eg(a) {
    if ($b36288e2db101ba3$var$I) {
        var b = $b36288e2db101ba3$var$yg;
        if (b) {
            var c = b;
            if (!$b36288e2db101ba3$var$Cg(a, b)) {
                if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
                b = $b36288e2db101ba3$var$Lf(c.nextSibling);
                var d = $b36288e2db101ba3$var$xg;
                b && $b36288e2db101ba3$var$Cg(a, b) ? $b36288e2db101ba3$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $b36288e2db101ba3$var$I = !1, $b36288e2db101ba3$var$xg = a);
            }
        } else {
            if ($b36288e2db101ba3$var$Dg(a)) throw Error($b36288e2db101ba3$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $b36288e2db101ba3$var$I = !1;
            $b36288e2db101ba3$var$xg = a;
        }
    }
}
function $b36288e2db101ba3$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $b36288e2db101ba3$var$xg = a;
}
function $b36288e2db101ba3$var$Gg(a) {
    if (a !== $b36288e2db101ba3$var$xg) return !1;
    if (!$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$Fg(a), $b36288e2db101ba3$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$b36288e2db101ba3$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $b36288e2db101ba3$var$yg)) {
        if ($b36288e2db101ba3$var$Dg(a)) throw $b36288e2db101ba3$var$Hg(), Error($b36288e2db101ba3$var$p(418));
        for(; b;)$b36288e2db101ba3$var$Ag(a, b), b = $b36288e2db101ba3$var$Lf(b.nextSibling);
    }
    $b36288e2db101ba3$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($b36288e2db101ba3$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $b36288e2db101ba3$var$yg = null;
        }
    } else $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg ? $b36288e2db101ba3$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $b36288e2db101ba3$var$Hg() {
    for(var a = $b36288e2db101ba3$var$yg; a;)a = $b36288e2db101ba3$var$Lf(a.nextSibling);
}
function $b36288e2db101ba3$var$Ig() {
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$xg = null;
    $b36288e2db101ba3$var$I = !1;
}
function $b36288e2db101ba3$var$Jg(a) {
    null === $b36288e2db101ba3$var$zg ? $b36288e2db101ba3$var$zg = [
        a
    ] : $b36288e2db101ba3$var$zg.push(a);
}
var $b36288e2db101ba3$var$Kg = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig;
function $b36288e2db101ba3$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $b36288e2db101ba3$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $b36288e2db101ba3$var$Mg = $b36288e2db101ba3$var$Uf(null), $b36288e2db101ba3$var$Ng = null, $b36288e2db101ba3$var$Og = null, $b36288e2db101ba3$var$Pg = null;
function $b36288e2db101ba3$var$Qg() {
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Ng = null;
}
function $b36288e2db101ba3$var$Rg(a) {
    var b = $b36288e2db101ba3$var$Mg.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Mg);
    a._currentValue = b;
}
function $b36288e2db101ba3$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $b36288e2db101ba3$var$Tg(a, b) {
    $b36288e2db101ba3$var$Ng = a;
    $b36288e2db101ba3$var$Pg = $b36288e2db101ba3$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($b36288e2db101ba3$var$Ug = !0), a.firstContext = null);
}
function $b36288e2db101ba3$var$Vg(a) {
    var b = a._currentValue;
    if ($b36288e2db101ba3$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $b36288e2db101ba3$var$Og) {
            if (null === $b36288e2db101ba3$var$Ng) throw Error($b36288e2db101ba3$var$p(308));
            $b36288e2db101ba3$var$Og = a;
            $b36288e2db101ba3$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $b36288e2db101ba3$var$Og = $b36288e2db101ba3$var$Og.next = a;
    }
    return b;
}
var $b36288e2db101ba3$var$Wg = null;
function $b36288e2db101ba3$var$Xg(a) {
    null === $b36288e2db101ba3$var$Wg ? $b36288e2db101ba3$var$Wg = [
        a
    ] : $b36288e2db101ba3$var$Wg.push(a);
}
function $b36288e2db101ba3$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $b36288e2db101ba3$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $b36288e2db101ba3$var$Zg(a, d);
}
function $b36288e2db101ba3$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $b36288e2db101ba3$var$$g = !1;
function $b36288e2db101ba3$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $b36288e2db101ba3$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $b36288e2db101ba3$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $b36288e2db101ba3$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($b36288e2db101ba3$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $b36288e2db101ba3$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $b36288e2db101ba3$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $b36288e2db101ba3$var$Zg(a, c);
}
function $b36288e2db101ba3$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
function $b36288e2db101ba3$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $b36288e2db101ba3$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $b36288e2db101ba3$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $b36288e2db101ba3$var$A({}, q, r);
                            break a;
                        case 2:
                            $b36288e2db101ba3$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $b36288e2db101ba3$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $b36288e2db101ba3$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($b36288e2db101ba3$var$p(191, e));
            e.call(d);
        }
    }
}
var $b36288e2db101ba3$var$jh = (new $bh6RR.Component).refs;
function $b36288e2db101ba3$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $b36288e2db101ba3$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $b36288e2db101ba3$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $b36288e2db101ba3$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $b36288e2db101ba3$var$L(), e = $b36288e2db101ba3$var$lh(a), f = $b36288e2db101ba3$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $b36288e2db101ba3$var$dh(a, f, e);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, e, d), $b36288e2db101ba3$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $b36288e2db101ba3$var$L(), d = $b36288e2db101ba3$var$lh(a), e = $b36288e2db101ba3$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $b36288e2db101ba3$var$dh(a, e, d);
        null !== b && ($b36288e2db101ba3$var$mh(b, a, d, c), $b36288e2db101ba3$var$eh(b, a, d));
    }
};
function $b36288e2db101ba3$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$b36288e2db101ba3$var$Ie(c, d) || !$b36288e2db101ba3$var$Ie(e, f) : !0;
}
function $b36288e2db101ba3$var$ph(a, b, c) {
    var d = !1, e = $b36288e2db101ba3$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $b36288e2db101ba3$var$Vg(f) : (e = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $b36288e2db101ba3$var$Yf(a, e) : $b36288e2db101ba3$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $b36288e2db101ba3$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $b36288e2db101ba3$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $b36288e2db101ba3$var$nh.enqueueReplaceState(b, b.state, null);
}
function $b36288e2db101ba3$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $b36288e2db101ba3$var$jh;
    $b36288e2db101ba3$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $b36288e2db101ba3$var$Vg(f) : (f = $b36288e2db101ba3$var$Zf(b) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, e.context = $b36288e2db101ba3$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($b36288e2db101ba3$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $b36288e2db101ba3$var$nh.enqueueReplaceState(e, e.state, null), $b36288e2db101ba3$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $b36288e2db101ba3$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($b36288e2db101ba3$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($b36288e2db101ba3$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $b36288e2db101ba3$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($b36288e2db101ba3$var$p(284));
        if (!c._owner) throw Error($b36288e2db101ba3$var$p(290, a));
    }
    return a;
}
function $b36288e2db101ba3$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($b36288e2db101ba3$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $b36288e2db101ba3$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $b36288e2db101ba3$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $b36288e2db101ba3$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $b36288e2db101ba3$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $b36288e2db101ba3$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $b36288e2db101ba3$var$sh(a, b, c), d.return = a, d;
        d = $b36288e2db101ba3$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $b36288e2db101ba3$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $b36288e2db101ba3$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $b36288e2db101ba3$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $b36288e2db101ba3$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c = $b36288e2db101ba3$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $b36288e2db101ba3$var$sh(a, null, b), c.return = a, c;
                case $b36288e2db101ba3$var$wa:
                    return b = $b36288e2db101ba3$var$zh(b, a.mode, c), b.return = a, b;
                case $b36288e2db101ba3$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($b36288e2db101ba3$var$eb(b) || $b36288e2db101ba3$var$Ka(b)) return b = $b36288e2db101ba3$var$Ah(b, a.mode, c, null), b.return = a, b;
            $b36288e2db101ba3$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $b36288e2db101ba3$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $b36288e2db101ba3$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($b36288e2db101ba3$var$eb(c) || $b36288e2db101ba3$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $b36288e2db101ba3$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $b36288e2db101ba3$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $b36288e2db101ba3$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $b36288e2db101ba3$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($b36288e2db101ba3$var$eb(d) || $b36288e2db101ba3$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $b36288e2db101ba3$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $b36288e2db101ba3$var$Ka(h);
        if ("function" !== typeof l) throw Error($b36288e2db101ba3$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($b36288e2db101ba3$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $b36288e2db101ba3$var$I && $b36288e2db101ba3$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $b36288e2db101ba3$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $b36288e2db101ba3$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $b36288e2db101ba3$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $b36288e2db101ba3$var$Ha && $b36288e2db101ba3$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $b36288e2db101ba3$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $b36288e2db101ba3$var$ya ? (d = $b36288e2db101ba3$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $b36288e2db101ba3$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $b36288e2db101ba3$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $b36288e2db101ba3$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $b36288e2db101ba3$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $b36288e2db101ba3$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($b36288e2db101ba3$var$eb(f)) return n(a, d, f, h);
            if ($b36288e2db101ba3$var$Ka(f)) return t(a, d, f, h);
            $b36288e2db101ba3$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $b36288e2db101ba3$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $b36288e2db101ba3$var$Bh = $b36288e2db101ba3$var$vh(!0), $b36288e2db101ba3$var$Ch = $b36288e2db101ba3$var$vh(!1), $b36288e2db101ba3$var$Dh = {}, $b36288e2db101ba3$var$Eh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Fh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh), $b36288e2db101ba3$var$Gh = $b36288e2db101ba3$var$Uf($b36288e2db101ba3$var$Dh);
function $b36288e2db101ba3$var$Hh(a) {
    if (a === $b36288e2db101ba3$var$Dh) throw Error($b36288e2db101ba3$var$p(174));
    return a;
}
function $b36288e2db101ba3$var$Ih(a, b) {
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Gh, b);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, $b36288e2db101ba3$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $b36288e2db101ba3$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $b36288e2db101ba3$var$lb(b, a);
    }
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, b);
}
function $b36288e2db101ba3$var$Jh() {
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh);
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Gh);
}
function $b36288e2db101ba3$var$Kh(a) {
    $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
    var b = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
    var c = $b36288e2db101ba3$var$lb(b, a.type);
    b !== c && ($b36288e2db101ba3$var$G($b36288e2db101ba3$var$Fh, a), $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Eh, c));
}
function $b36288e2db101ba3$var$Lh(a) {
    $b36288e2db101ba3$var$Fh.current === a && ($b36288e2db101ba3$var$E($b36288e2db101ba3$var$Eh), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Fh));
}
var $b36288e2db101ba3$var$M = $b36288e2db101ba3$var$Uf(0);
function $b36288e2db101ba3$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $b36288e2db101ba3$var$Nh = [];
function $b36288e2db101ba3$var$Oh() {
    for(var a = 0; a < $b36288e2db101ba3$var$Nh.length; a++)$b36288e2db101ba3$var$Nh[a]._workInProgressVersionPrimary = null;
    $b36288e2db101ba3$var$Nh.length = 0;
}
var $b36288e2db101ba3$var$Ph = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$Qh = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$Rh = 0, $b36288e2db101ba3$var$N = null, $b36288e2db101ba3$var$O = null, $b36288e2db101ba3$var$P = null, $b36288e2db101ba3$var$Sh = !1, $b36288e2db101ba3$var$Th = !1, $b36288e2db101ba3$var$Uh = 0, $b36288e2db101ba3$var$Vh = 0;
function $b36288e2db101ba3$var$Q() {
    throw Error($b36288e2db101ba3$var$p(321));
}
function $b36288e2db101ba3$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$b36288e2db101ba3$var$He(a[c], b[c])) return !1;
    return !0;
}
function $b36288e2db101ba3$var$Xh(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$Rh = f;
    $b36288e2db101ba3$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $b36288e2db101ba3$var$Ph.current = null === a || null === a.memoizedState ? $b36288e2db101ba3$var$Yh : $b36288e2db101ba3$var$Zh;
    a = c(d, e);
    if ($b36288e2db101ba3$var$Th) {
        f = 0;
        do {
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            if (25 <= f) throw Error($b36288e2db101ba3$var$p(301));
            f += 1;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = null;
            b.updateQueue = null;
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$$h;
            a = c(d, e);
        }while ($b36288e2db101ba3$var$Th);
    }
    $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
    b = null !== $b36288e2db101ba3$var$O && null !== $b36288e2db101ba3$var$O.next;
    $b36288e2db101ba3$var$Rh = 0;
    $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
    $b36288e2db101ba3$var$Sh = !1;
    if (b) throw Error($b36288e2db101ba3$var$p(300));
    return a;
}
function $b36288e2db101ba3$var$bi() {
    var a = 0 !== $b36288e2db101ba3$var$Uh;
    $b36288e2db101ba3$var$Uh = 0;
    return a;
}
function $b36288e2db101ba3$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$di() {
    if (null === $b36288e2db101ba3$var$O) {
        var a = $b36288e2db101ba3$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $b36288e2db101ba3$var$O.next;
    var b = null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState : $b36288e2db101ba3$var$P.next;
    if (null !== b) $b36288e2db101ba3$var$P = b, $b36288e2db101ba3$var$O = a;
    else {
        if (null === a) throw Error($b36288e2db101ba3$var$p(310));
        $b36288e2db101ba3$var$O = a;
        a = {
            memoizedState: $b36288e2db101ba3$var$O.memoizedState,
            baseState: $b36288e2db101ba3$var$O.baseState,
            baseQueue: $b36288e2db101ba3$var$O.baseQueue,
            queue: $b36288e2db101ba3$var$O.queue,
            next: null
        };
        null === $b36288e2db101ba3$var$P ? $b36288e2db101ba3$var$N.memoizedState = $b36288e2db101ba3$var$P = a : $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$P.next = a;
    }
    return $b36288e2db101ba3$var$P;
}
function $b36288e2db101ba3$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $b36288e2db101ba3$var$fi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = $b36288e2db101ba3$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($b36288e2db101ba3$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $b36288e2db101ba3$var$N.lanes |= m;
                $b36288e2db101ba3$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $b36288e2db101ba3$var$He(d, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $b36288e2db101ba3$var$N.lanes |= f, $b36288e2db101ba3$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $b36288e2db101ba3$var$gi(a) {
    var b = $b36288e2db101ba3$var$di(), c = b.queue;
    if (null === c) throw Error($b36288e2db101ba3$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $b36288e2db101ba3$var$He(f, b.memoizedState) || ($b36288e2db101ba3$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $b36288e2db101ba3$var$hi() {}
function $b36288e2db101ba3$var$ii(a, b) {
    var c = $b36288e2db101ba3$var$N, d = $b36288e2db101ba3$var$di(), e = b(), f = !$b36288e2db101ba3$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $b36288e2db101ba3$var$Ug = !0);
    d = d.queue;
    $b36288e2db101ba3$var$ji($b36288e2db101ba3$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $b36288e2db101ba3$var$P && $b36288e2db101ba3$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
        0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(c, b, e);
    }
    return e;
}
function $b36288e2db101ba3$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $b36288e2db101ba3$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
}
function $b36288e2db101ba3$var$ki(a, b, c) {
    return c(function() {
        $b36288e2db101ba3$var$oi(b) && $b36288e2db101ba3$var$pi(a);
    });
}
function $b36288e2db101ba3$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$b36288e2db101ba3$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $b36288e2db101ba3$var$pi(a) {
    var b = $b36288e2db101ba3$var$Zg(a, 1);
    null !== b && $b36288e2db101ba3$var$mh(b, a, 1, -1);
}
function $b36288e2db101ba3$var$qi(a) {
    var b = $b36288e2db101ba3$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $b36288e2db101ba3$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $b36288e2db101ba3$var$ri.bind(null, $b36288e2db101ba3$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $b36288e2db101ba3$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $b36288e2db101ba3$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $b36288e2db101ba3$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $b36288e2db101ba3$var$si() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$ti(a, b, c, d) {
    var e = $b36288e2db101ba3$var$ci();
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $b36288e2db101ba3$var$ui(a, b, c, d) {
    var e = $b36288e2db101ba3$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $b36288e2db101ba3$var$O) {
        var g = $b36288e2db101ba3$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $b36288e2db101ba3$var$Wh(d, g.deps)) {
            e.memoizedState = $b36288e2db101ba3$var$li(b, c, f, d);
            return;
        }
    }
    $b36288e2db101ba3$var$N.flags |= a;
    e.memoizedState = $b36288e2db101ba3$var$li(1 | b, c, f, d);
}
function $b36288e2db101ba3$var$vi(a, b) {
    return $b36288e2db101ba3$var$ti(8390656, 8, a, b);
}
function $b36288e2db101ba3$var$ji(a, b) {
    return $b36288e2db101ba3$var$ui(2048, 8, a, b);
}
function $b36288e2db101ba3$var$wi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 2, a, b);
}
function $b36288e2db101ba3$var$xi(a, b) {
    return $b36288e2db101ba3$var$ui(4, 4, a, b);
}
function $b36288e2db101ba3$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $b36288e2db101ba3$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $b36288e2db101ba3$var$ui(4, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
}
function $b36288e2db101ba3$var$Ai() {}
function $b36288e2db101ba3$var$Bi(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Ci(a, b) {
    var c = $b36288e2db101ba3$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $b36288e2db101ba3$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $b36288e2db101ba3$var$Di(a, b, c) {
    if (0 === ($b36288e2db101ba3$var$Rh & 21)) return a.baseState && (a.baseState = !1, $b36288e2db101ba3$var$Ug = !0), a.memoizedState = c;
    $b36288e2db101ba3$var$He(c, b) || (c = $b36288e2db101ba3$var$yc(), $b36288e2db101ba3$var$N.lanes |= c, $b36288e2db101ba3$var$hh |= c, a.baseState = !0);
    return b;
}
function $b36288e2db101ba3$var$Ei(a, b) {
    var c = $b36288e2db101ba3$var$C;
    $b36288e2db101ba3$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $b36288e2db101ba3$var$Qh.transition;
    $b36288e2db101ba3$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$Qh.transition = d;
    }
}
function $b36288e2db101ba3$var$Fi() {
    return $b36288e2db101ba3$var$di().memoizedState;
}
function $b36288e2db101ba3$var$Gi(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, c);
    else if (c = $b36288e2db101ba3$var$Yg(a, b, c, d), null !== c) {
        var e = $b36288e2db101ba3$var$L();
        $b36288e2db101ba3$var$mh(c, a, d, e);
        $b36288e2db101ba3$var$Ji(c, b, d);
    }
}
function $b36288e2db101ba3$var$ri(a, b, c) {
    var d = $b36288e2db101ba3$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($b36288e2db101ba3$var$Hi(a)) $b36288e2db101ba3$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($b36288e2db101ba3$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $b36288e2db101ba3$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $b36288e2db101ba3$var$Yg(a, b, e, d);
        null !== c && (e = $b36288e2db101ba3$var$L(), $b36288e2db101ba3$var$mh(c, a, d, e), $b36288e2db101ba3$var$Ji(c, b, d));
    }
}
function $b36288e2db101ba3$var$Hi(a) {
    var b = a.alternate;
    return a === $b36288e2db101ba3$var$N || null !== b && b === $b36288e2db101ba3$var$N;
}
function $b36288e2db101ba3$var$Ii(a, b) {
    $b36288e2db101ba3$var$Th = $b36288e2db101ba3$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $b36288e2db101ba3$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $b36288e2db101ba3$var$Cc(a, c);
    }
}
var $b36288e2db101ba3$var$ai = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Q,
    useContext: $b36288e2db101ba3$var$Q,
    useEffect: $b36288e2db101ba3$var$Q,
    useImperativeHandle: $b36288e2db101ba3$var$Q,
    useInsertionEffect: $b36288e2db101ba3$var$Q,
    useLayoutEffect: $b36288e2db101ba3$var$Q,
    useMemo: $b36288e2db101ba3$var$Q,
    useReducer: $b36288e2db101ba3$var$Q,
    useRef: $b36288e2db101ba3$var$Q,
    useState: $b36288e2db101ba3$var$Q,
    useDebugValue: $b36288e2db101ba3$var$Q,
    useDeferredValue: $b36288e2db101ba3$var$Q,
    useTransition: $b36288e2db101ba3$var$Q,
    useMutableSource: $b36288e2db101ba3$var$Q,
    useSyncExternalStore: $b36288e2db101ba3$var$Q,
    useId: $b36288e2db101ba3$var$Q,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Yh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: function(a, b) {
        $b36288e2db101ba3$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $b36288e2db101ba3$var$ti(4194308, 4, $b36288e2db101ba3$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $b36288e2db101ba3$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $b36288e2db101ba3$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $b36288e2db101ba3$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $b36288e2db101ba3$var$Gi.bind(null, $b36288e2db101ba3$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $b36288e2db101ba3$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $b36288e2db101ba3$var$qi,
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        return $b36288e2db101ba3$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$qi(!1), b = a[0];
        a = $b36288e2db101ba3$var$Ei.bind(null, a[1]);
        $b36288e2db101ba3$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $b36288e2db101ba3$var$N, e = $b36288e2db101ba3$var$ci();
        if ($b36288e2db101ba3$var$I) {
            if (void 0 === c) throw Error($b36288e2db101ba3$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $b36288e2db101ba3$var$R) throw Error($b36288e2db101ba3$var$p(349));
            0 !== ($b36288e2db101ba3$var$Rh & 30) || $b36288e2db101ba3$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $b36288e2db101ba3$var$vi($b36288e2db101ba3$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $b36288e2db101ba3$var$li(9, $b36288e2db101ba3$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $b36288e2db101ba3$var$ci(), b = $b36288e2db101ba3$var$R.identifierPrefix;
        if ($b36288e2db101ba3$var$I) {
            var c = $b36288e2db101ba3$var$sg;
            var d = $b36288e2db101ba3$var$rg;
            c = (d & ~(1 << 32 - $b36288e2db101ba3$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $b36288e2db101ba3$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $b36288e2db101ba3$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$Zh = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$fi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$fi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
}, $b36288e2db101ba3$var$$h = {
    readContext: $b36288e2db101ba3$var$Vg,
    useCallback: $b36288e2db101ba3$var$Bi,
    useContext: $b36288e2db101ba3$var$Vg,
    useEffect: $b36288e2db101ba3$var$ji,
    useImperativeHandle: $b36288e2db101ba3$var$zi,
    useInsertionEffect: $b36288e2db101ba3$var$wi,
    useLayoutEffect: $b36288e2db101ba3$var$xi,
    useMemo: $b36288e2db101ba3$var$Ci,
    useReducer: $b36288e2db101ba3$var$gi,
    useRef: $b36288e2db101ba3$var$si,
    useState: function() {
        return $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei);
    },
    useDebugValue: $b36288e2db101ba3$var$Ai,
    useDeferredValue: function(a) {
        var b = $b36288e2db101ba3$var$di();
        return null === $b36288e2db101ba3$var$O ? b.memoizedState = a : $b36288e2db101ba3$var$Di(b, $b36288e2db101ba3$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $b36288e2db101ba3$var$gi($b36288e2db101ba3$var$ei)[0], b = $b36288e2db101ba3$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $b36288e2db101ba3$var$hi,
    useSyncExternalStore: $b36288e2db101ba3$var$ii,
    useId: $b36288e2db101ba3$var$Fi,
    unstable_isNewReconciler: !1
};
function $b36288e2db101ba3$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $b36288e2db101ba3$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $b36288e2db101ba3$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $b36288e2db101ba3$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $b36288e2db101ba3$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $b36288e2db101ba3$var$Oi(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $b36288e2db101ba3$var$Pi || ($b36288e2db101ba3$var$Pi = !0, $b36288e2db101ba3$var$Qi = d);
        $b36288e2db101ba3$var$Mi(a, b);
    };
    return c;
}
function $b36288e2db101ba3$var$Ri(a, b, c) {
    c = $b36288e2db101ba3$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $b36288e2db101ba3$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $b36288e2db101ba3$var$Mi(a, b);
        "function" !== typeof d && (null === $b36288e2db101ba3$var$Si ? $b36288e2db101ba3$var$Si = new Set([
            this
        ]) : $b36288e2db101ba3$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $b36288e2db101ba3$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $b36288e2db101ba3$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $b36288e2db101ba3$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $b36288e2db101ba3$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $b36288e2db101ba3$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $b36288e2db101ba3$var$ch(-1, 1), b.tag = 2, $b36288e2db101ba3$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $b36288e2db101ba3$var$Xi = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$Ug = !1;
function $b36288e2db101ba3$var$Yi(a, b, c, d) {
    b.child = null === a ? $b36288e2db101ba3$var$Ch(b, null, c, d) : $b36288e2db101ba3$var$Bh(b, a.child, c, d);
}
function $b36288e2db101ba3$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $b36288e2db101ba3$var$Tg(b, e);
    d = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    c = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && c && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, d, e);
    return b.child;
}
function $b36288e2db101ba3$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$b36288e2db101ba3$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $b36288e2db101ba3$var$cj(a, b, f, d, e);
        a = $b36288e2db101ba3$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $b36288e2db101ba3$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $b36288e2db101ba3$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $b36288e2db101ba3$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $b36288e2db101ba3$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($b36288e2db101ba3$var$Ie(f, d) && a.ref === b.ref) {
            if ($b36288e2db101ba3$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($b36288e2db101ba3$var$Ug = !0);
            else return b.lanes = a.lanes, $b36288e2db101ba3$var$$i(a, b, e);
        }
    }
    return $b36288e2db101ba3$var$dj(a, b, c, d, e);
}
function $b36288e2db101ba3$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj);
            $b36288e2db101ba3$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$fj, $b36288e2db101ba3$var$gj), $b36288e2db101ba3$var$gj |= d;
    $b36288e2db101ba3$var$Yi(a, b, e, c);
    return b.child;
}
function $b36288e2db101ba3$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $b36288e2db101ba3$var$dj(a, b, c, d, e) {
    var f = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current;
    f = $b36288e2db101ba3$var$Yf(b, f);
    $b36288e2db101ba3$var$Tg(b, e);
    c = $b36288e2db101ba3$var$Xh(a, b, c, d, f, e);
    d = $b36288e2db101ba3$var$bi();
    if (null !== a && !$b36288e2db101ba3$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $b36288e2db101ba3$var$$i(a, b, e);
    $b36288e2db101ba3$var$I && d && $b36288e2db101ba3$var$vg(b);
    b.flags |= 1;
    $b36288e2db101ba3$var$Yi(a, b, c, e);
    return b.child;
}
function $b36288e2db101ba3$var$ij(a, b, c, d, e) {
    if ($b36288e2db101ba3$var$Zf(c)) {
        var f = !0;
        $b36288e2db101ba3$var$cg(b);
    } else f = !1;
    $b36288e2db101ba3$var$Tg(b, e);
    if (null === b.stateNode) $b36288e2db101ba3$var$jj(a, b), $b36288e2db101ba3$var$ph(b, c, d), $b36288e2db101ba3$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $b36288e2db101ba3$var$Vg(l) : (l = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, l = $b36288e2db101ba3$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $b36288e2db101ba3$var$qh(b, g, d, l);
        $b36288e2db101ba3$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof m && ($b36288e2db101ba3$var$kh(b, c, m, d), k = b.memoizedState), (h = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $b36288e2db101ba3$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $b36288e2db101ba3$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $b36288e2db101ba3$var$Vg(k) : (k = $b36288e2db101ba3$var$Zf(c) ? $b36288e2db101ba3$var$Xf : $b36288e2db101ba3$var$H.current, k = $b36288e2db101ba3$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $b36288e2db101ba3$var$qh(b, g, d, k);
        $b36288e2db101ba3$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $b36288e2db101ba3$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $b36288e2db101ba3$var$Wf.current || $b36288e2db101ba3$var$$g ? ("function" === typeof y && ($b36288e2db101ba3$var$kh(b, c, y, d), n = b.memoizedState), (l = $b36288e2db101ba3$var$$g || $b36288e2db101ba3$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $b36288e2db101ba3$var$kj(a, b, c, d, f, e);
}
function $b36288e2db101ba3$var$kj(a, b, c, d, e, f) {
    $b36288e2db101ba3$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $b36288e2db101ba3$var$dg(b, c, !1), $b36288e2db101ba3$var$$i(a, b, f);
    d = b.stateNode;
    $b36288e2db101ba3$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $b36288e2db101ba3$var$Bh(b, a.child, null, f), b.child = $b36288e2db101ba3$var$Bh(b, null, h, f)) : $b36288e2db101ba3$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $b36288e2db101ba3$var$dg(b, c, !0);
    return b.child;
}
function $b36288e2db101ba3$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $b36288e2db101ba3$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $b36288e2db101ba3$var$ag(a, b.context, !1);
    $b36288e2db101ba3$var$Ih(a, b.containerInfo);
}
function $b36288e2db101ba3$var$mj(a, b, c, d, e) {
    $b36288e2db101ba3$var$Ig();
    $b36288e2db101ba3$var$Jg(e);
    b.flags |= 256;
    $b36288e2db101ba3$var$Yi(a, b, c, d);
    return b.child;
}
var $b36288e2db101ba3$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $b36288e2db101ba3$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $b36288e2db101ba3$var$pj(a, b, c) {
    var d = b.pendingProps, e = $b36288e2db101ba3$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, e & 1);
    if (null === a) {
        $b36288e2db101ba3$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $b36288e2db101ba3$var$qj(g, d, 0, null), a = $b36288e2db101ba3$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $b36288e2db101ba3$var$oj(c), b.memoizedState = $b36288e2db101ba3$var$nj, a) : $b36288e2db101ba3$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $b36288e2db101ba3$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $b36288e2db101ba3$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $b36288e2db101ba3$var$wh(h, f) : (f = $b36288e2db101ba3$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $b36288e2db101ba3$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $b36288e2db101ba3$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $b36288e2db101ba3$var$rj(a, b) {
    b = $b36288e2db101ba3$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $b36288e2db101ba3$var$tj(a, b, c, d) {
    null !== d && $b36288e2db101ba3$var$Jg(d);
    $b36288e2db101ba3$var$Bh(b, a.child, null, c);
    a = $b36288e2db101ba3$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $b36288e2db101ba3$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(422))), $b36288e2db101ba3$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $b36288e2db101ba3$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $b36288e2db101ba3$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $b36288e2db101ba3$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $b36288e2db101ba3$var$oj(g);
        b.memoizedState = $b36288e2db101ba3$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $b36288e2db101ba3$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($b36288e2db101ba3$var$p(419));
        d = $b36288e2db101ba3$var$Li(f, d, void 0);
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($b36288e2db101ba3$var$Ug || h) {
        d = $b36288e2db101ba3$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $b36288e2db101ba3$var$Zg(a, e), $b36288e2db101ba3$var$mh(d, a, e, -1));
        }
        $b36288e2db101ba3$var$uj();
        d = $b36288e2db101ba3$var$Li(Error($b36288e2db101ba3$var$p(421)));
        return $b36288e2db101ba3$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $b36288e2db101ba3$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(e.nextSibling);
    $b36288e2db101ba3$var$xg = b;
    $b36288e2db101ba3$var$I = !0;
    $b36288e2db101ba3$var$zg = null;
    null !== a && ($b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$rg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$sg, $b36288e2db101ba3$var$og[$b36288e2db101ba3$var$pg++] = $b36288e2db101ba3$var$qg, $b36288e2db101ba3$var$rg = a.id, $b36288e2db101ba3$var$sg = a.overflow, $b36288e2db101ba3$var$qg = b);
    b = $b36288e2db101ba3$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $b36288e2db101ba3$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $b36288e2db101ba3$var$Sg(a.return, b, c);
}
function $b36288e2db101ba3$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $b36288e2db101ba3$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $b36288e2db101ba3$var$Yi(a, b, d.children, c);
    d = $b36288e2db101ba3$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $b36288e2db101ba3$var$wj(a, c, b);
            else if (19 === a.tag) $b36288e2db101ba3$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $b36288e2db101ba3$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $b36288e2db101ba3$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $b36288e2db101ba3$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $b36288e2db101ba3$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $b36288e2db101ba3$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $b36288e2db101ba3$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $b36288e2db101ba3$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($b36288e2db101ba3$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $b36288e2db101ba3$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $b36288e2db101ba3$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $b36288e2db101ba3$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $b36288e2db101ba3$var$lj(b);
            $b36288e2db101ba3$var$Ig();
            break;
        case 5:
            $b36288e2db101ba3$var$Kh(b);
            break;
        case 1:
            $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$cg(b);
            break;
        case 4:
            $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $b36288e2db101ba3$var$pj(a, b, c);
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
                a = $b36288e2db101ba3$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $b36288e2db101ba3$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $b36288e2db101ba3$var$ej(a, b, c);
    }
    return $b36288e2db101ba3$var$$i(a, b, c);
}
var $b36288e2db101ba3$var$Aj, $b36288e2db101ba3$var$Bj, $b36288e2db101ba3$var$Cj, $b36288e2db101ba3$var$Dj;
$b36288e2db101ba3$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$b36288e2db101ba3$var$Bj = function() {};
$b36288e2db101ba3$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $b36288e2db101ba3$var$Ya(a, e);
                d = $b36288e2db101ba3$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $b36288e2db101ba3$var$A({}, e, {
                    value: void 0
                });
                d = $b36288e2db101ba3$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $b36288e2db101ba3$var$gb(a, e);
                d = $b36288e2db101ba3$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
        }
        $b36288e2db101ba3$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($b36288e2db101ba3$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $b36288e2db101ba3$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$b36288e2db101ba3$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $b36288e2db101ba3$var$Ej(a, b) {
    if (!$b36288e2db101ba3$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $b36288e2db101ba3$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $b36288e2db101ba3$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $b36288e2db101ba3$var$S(b), null;
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 3:
            d = b.stateNode;
            $b36288e2db101ba3$var$Jh();
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
            $b36288e2db101ba3$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $b36288e2db101ba3$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null));
            $b36288e2db101ba3$var$Bj(a, b);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 5:
            $b36288e2db101ba3$var$Lh(b);
            var e = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $b36288e2db101ba3$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                    $b36288e2db101ba3$var$S(b);
                    return null;
                }
                a = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    d[$b36288e2db101ba3$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $b36288e2db101ba3$var$D("cancel", d);
                            $b36288e2db101ba3$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], d);
                            break;
                        case "source":
                            $b36288e2db101ba3$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $b36288e2db101ba3$var$D("error", d);
                            $b36288e2db101ba3$var$D("load", d);
                            break;
                        case "details":
                            $b36288e2db101ba3$var$D("toggle", d);
                            break;
                        case "input":
                            $b36288e2db101ba3$var$Za(d, f);
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $b36288e2db101ba3$var$D("invalid", d);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$hb(d, f), $b36288e2db101ba3$var$D("invalid", d);
                    }
                    $b36288e2db101ba3$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $b36288e2db101ba3$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $b36288e2db101ba3$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$Va(d);
                            $b36288e2db101ba3$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $b36288e2db101ba3$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $b36288e2db101ba3$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$b36288e2db101ba3$var$Of] = b;
                    a[$b36288e2db101ba3$var$Pf] = d;
                    $b36288e2db101ba3$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $b36288e2db101ba3$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $b36288e2db101ba3$var$D("cancel", a);
                                $b36288e2db101ba3$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $b36288e2db101ba3$var$lf.length; e++)$b36288e2db101ba3$var$D($b36288e2db101ba3$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $b36288e2db101ba3$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $b36288e2db101ba3$var$D("error", a);
                                $b36288e2db101ba3$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $b36288e2db101ba3$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $b36288e2db101ba3$var$Za(a, d);
                                e = $b36288e2db101ba3$var$Ya(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $b36288e2db101ba3$var$A({}, d, {
                                    value: void 0
                                });
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$hb(a, d);
                                e = $b36288e2db101ba3$var$gb(a, d);
                                $b36288e2db101ba3$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $b36288e2db101ba3$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $b36288e2db101ba3$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $b36288e2db101ba3$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $b36288e2db101ba3$var$ob(a, k) : "number" === typeof k && $b36288e2db101ba3$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($b36288e2db101ba3$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $b36288e2db101ba3$var$D("scroll", a) : null != k && $b36288e2db101ba3$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $b36288e2db101ba3$var$Va(a);
                                $b36288e2db101ba3$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $b36288e2db101ba3$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $b36288e2db101ba3$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $b36288e2db101ba3$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $b36288e2db101ba3$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $b36288e2db101ba3$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($b36288e2db101ba3$var$p(166));
                c = $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Gh.current);
                $b36288e2db101ba3$var$Hh($b36288e2db101ba3$var$Eh.current);
                if ($b36288e2db101ba3$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$b36288e2db101ba3$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $b36288e2db101ba3$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $b36288e2db101ba3$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$b36288e2db101ba3$var$Of] = b, b.stateNode = d;
            }
            $b36288e2db101ba3$var$S(b);
            return null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($b36288e2db101ba3$var$I && null !== $b36288e2db101ba3$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $b36288e2db101ba3$var$Hg(), $b36288e2db101ba3$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $b36288e2db101ba3$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($b36288e2db101ba3$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($b36288e2db101ba3$var$p(317));
                        f[$b36288e2db101ba3$var$Of] = b;
                    } else $b36288e2db101ba3$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $b36288e2db101ba3$var$S(b);
                    f = !1;
                } else null !== $b36288e2db101ba3$var$zg && ($b36288e2db101ba3$var$Gj($b36288e2db101ba3$var$zg), $b36288e2db101ba3$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($b36288e2db101ba3$var$M.current & 1) ? 0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 3) : $b36288e2db101ba3$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $b36288e2db101ba3$var$S(b);
            return null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$Bj(a, b), null === a && $b36288e2db101ba3$var$sf(b.stateNode.containerInfo), $b36288e2db101ba3$var$S(b), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), $b36288e2db101ba3$var$S(b), null;
        case 17:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), $b36288e2db101ba3$var$S(b), null;
        case 19:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            f = b.memoizedState;
            if (null === f) return $b36288e2db101ba3$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $b36288e2db101ba3$var$Ej(f, !1);
                else {
                    if (0 !== $b36288e2db101ba3$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $b36288e2db101ba3$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $b36288e2db101ba3$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, $b36288e2db101ba3$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $b36288e2db101ba3$var$B() > $b36288e2db101ba3$var$Hj && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $b36288e2db101ba3$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $b36288e2db101ba3$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$b36288e2db101ba3$var$I) return $b36288e2db101ba3$var$S(b), null;
                    } else 2 * $b36288e2db101ba3$var$B() - f.renderingStartTime > $b36288e2db101ba3$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $b36288e2db101ba3$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $b36288e2db101ba3$var$B(), b.sibling = null, c = $b36288e2db101ba3$var$M.current, $b36288e2db101ba3$var$G($b36288e2db101ba3$var$M, d ? c & 1 | 2 : c & 1), b;
            $b36288e2db101ba3$var$S(b);
            return null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($b36288e2db101ba3$var$gj & 1073741824) && ($b36288e2db101ba3$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $b36288e2db101ba3$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
}
function $b36288e2db101ba3$var$Jj(a, b) {
    $b36288e2db101ba3$var$wg(b);
    switch(b.tag){
        case 1:
            return $b36288e2db101ba3$var$Zf(b.type) && $b36288e2db101ba3$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $b36288e2db101ba3$var$Jh(), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf), $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H), $b36288e2db101ba3$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $b36288e2db101ba3$var$Lh(b), null;
        case 13:
            $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($b36288e2db101ba3$var$p(340));
                $b36288e2db101ba3$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M), null;
        case 4:
            return $b36288e2db101ba3$var$Jh(), null;
        case 10:
            return $b36288e2db101ba3$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $b36288e2db101ba3$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $b36288e2db101ba3$var$Kj = !1, $b36288e2db101ba3$var$U = !1, $b36288e2db101ba3$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $b36288e2db101ba3$var$V = null;
function $b36288e2db101ba3$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $b36288e2db101ba3$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $b36288e2db101ba3$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $b36288e2db101ba3$var$W(a, b, d);
    }
}
var $b36288e2db101ba3$var$Oj = !1;
function $b36288e2db101ba3$var$Pj(a, b) {
    $b36288e2db101ba3$var$Cf = $b36288e2db101ba3$var$dd;
    a = $b36288e2db101ba3$var$Me();
    if ($b36288e2db101ba3$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $b36288e2db101ba3$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $b36288e2db101ba3$var$dd = !1;
    for($b36288e2db101ba3$var$V = b; null !== $b36288e2db101ba3$var$V;)if (b = $b36288e2db101ba3$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $b36288e2db101ba3$var$V = a;
    else for(; null !== $b36288e2db101ba3$var$V;){
        b = $b36288e2db101ba3$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $b36288e2db101ba3$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(163));
            }
        } catch (F) {
            $b36288e2db101ba3$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $b36288e2db101ba3$var$V = a;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
    n = $b36288e2db101ba3$var$Oj;
    $b36288e2db101ba3$var$Oj = !1;
    return n;
}
function $b36288e2db101ba3$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $b36288e2db101ba3$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $b36288e2db101ba3$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $b36288e2db101ba3$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $b36288e2db101ba3$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $b36288e2db101ba3$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$b36288e2db101ba3$var$Of], delete b[$b36288e2db101ba3$var$Pf], delete b[$b36288e2db101ba3$var$of], delete b[$b36288e2db101ba3$var$Qf], delete b[$b36288e2db101ba3$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $b36288e2db101ba3$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $b36288e2db101ba3$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $b36288e2db101ba3$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $b36288e2db101ba3$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $b36288e2db101ba3$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Wj(a, b, c), a = a.sibling;
}
function $b36288e2db101ba3$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling; null !== a;)$b36288e2db101ba3$var$Xj(a, b, c), a = a.sibling;
}
var $b36288e2db101ba3$var$X = null, $b36288e2db101ba3$var$Yj = !1;
function $b36288e2db101ba3$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$b36288e2db101ba3$var$ak(a, b, c), c = c.sibling;
}
function $b36288e2db101ba3$var$ak(a, b, c) {
    if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onCommitFiberUnmount) try {
        $b36288e2db101ba3$var$lc.onCommitFiberUnmount($b36288e2db101ba3$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Mj(c, b);
        case 6:
            var d = $b36288e2db101ba3$var$X, e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $b36288e2db101ba3$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $b36288e2db101ba3$var$X && ($b36288e2db101ba3$var$Yj ? (a = $b36288e2db101ba3$var$X, c = c.stateNode, 8 === a.nodeType ? $b36288e2db101ba3$var$Kf(a.parentNode, c) : 1 === a.nodeType && $b36288e2db101ba3$var$Kf(a, c), $b36288e2db101ba3$var$bd(a)) : $b36288e2db101ba3$var$Kf($b36288e2db101ba3$var$X, c.stateNode));
            break;
        case 4:
            d = $b36288e2db101ba3$var$X;
            e = $b36288e2db101ba3$var$Yj;
            $b36288e2db101ba3$var$X = c.stateNode.containerInfo;
            $b36288e2db101ba3$var$Yj = !0;
            $b36288e2db101ba3$var$Zj(a, b, c);
            $b36288e2db101ba3$var$X = d;
            $b36288e2db101ba3$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$b36288e2db101ba3$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $b36288e2db101ba3$var$Nj(c, b, g) : 0 !== (f & 4) && $b36288e2db101ba3$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 1:
            if (!$b36288e2db101ba3$var$U && ($b36288e2db101ba3$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $b36288e2db101ba3$var$W(c, b, h);
            }
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 21:
            $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($b36288e2db101ba3$var$U = (d = $b36288e2db101ba3$var$U) || null !== c.memoizedState, $b36288e2db101ba3$var$Zj(a, b, c), $b36288e2db101ba3$var$U = d) : $b36288e2db101ba3$var$Zj(a, b, c);
            break;
        default:
            $b36288e2db101ba3$var$Zj(a, b, c);
    }
}
function $b36288e2db101ba3$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $b36288e2db101ba3$var$Lj);
        b.forEach(function(b) {
            var d = $b36288e2db101ba3$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $b36288e2db101ba3$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $b36288e2db101ba3$var$X = h.stateNode;
                        $b36288e2db101ba3$var$Yj = !1;
                        break a;
                    case 3:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                    case 4:
                        $b36288e2db101ba3$var$X = h.stateNode.containerInfo;
                        $b36288e2db101ba3$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $b36288e2db101ba3$var$X) throw Error($b36288e2db101ba3$var$p(160));
            $b36288e2db101ba3$var$ak(f, g, e);
            $b36288e2db101ba3$var$X = null;
            $b36288e2db101ba3$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $b36288e2db101ba3$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$b36288e2db101ba3$var$ek(b, a), b = b.sibling;
}
function $b36288e2db101ba3$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                try {
                    $b36288e2db101ba3$var$Qj(3, a, a.return), $b36288e2db101ba3$var$Rj(3, a);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
                try {
                    $b36288e2db101ba3$var$Qj(5, a, a.return);
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            break;
        case 5:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 512 && null !== c && $b36288e2db101ba3$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $b36288e2db101ba3$var$ob(e, "");
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $b36288e2db101ba3$var$ab(e, f);
                    $b36288e2db101ba3$var$vb(h, g);
                    var l = $b36288e2db101ba3$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $b36288e2db101ba3$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $b36288e2db101ba3$var$nb(e, q) : "children" === m ? $b36288e2db101ba3$var$ob(e, q) : $b36288e2db101ba3$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $b36288e2db101ba3$var$bb(e, f);
                            break;
                        case "textarea":
                            $b36288e2db101ba3$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $b36288e2db101ba3$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $b36288e2db101ba3$var$fb(e, !!f.multiple, f.defaultValue, !0) : $b36288e2db101ba3$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$b36288e2db101ba3$var$Pf] = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($b36288e2db101ba3$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $b36288e2db101ba3$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $b36288e2db101ba3$var$bd(b.containerInfo);
            } catch (t) {
                $b36288e2db101ba3$var$W(a, a.return, t);
            }
            break;
        case 4:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            break;
        case 13:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($b36288e2db101ba3$var$gk = $b36288e2db101ba3$var$B()));
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($b36288e2db101ba3$var$U = (l = $b36288e2db101ba3$var$U) || m, $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$U = l) : $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($b36288e2db101ba3$var$V = a, m = a.child; null !== m;){
                    for(q = $b36288e2db101ba3$var$V = m; null !== $b36288e2db101ba3$var$V;){
                        r = $b36288e2db101ba3$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $b36288e2db101ba3$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $b36288e2db101ba3$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $b36288e2db101ba3$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $b36288e2db101ba3$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $b36288e2db101ba3$var$V = y) : $b36288e2db101ba3$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $b36288e2db101ba3$var$rb("display", g));
                            } catch (t) {
                                $b36288e2db101ba3$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $b36288e2db101ba3$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $b36288e2db101ba3$var$dk(b, a);
            $b36288e2db101ba3$var$fk(a);
            d & 4 && $b36288e2db101ba3$var$bk(a);
            break;
        case 21:
            break;
        default:
            $b36288e2db101ba3$var$dk(b, a), $b36288e2db101ba3$var$fk(a);
    }
}
function $b36288e2db101ba3$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($b36288e2db101ba3$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($b36288e2db101ba3$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($b36288e2db101ba3$var$ob(e, ""), d.flags &= -33);
                    var f = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $b36288e2db101ba3$var$Vj(a);
                    $b36288e2db101ba3$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(161));
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $b36288e2db101ba3$var$ik(a, b, c) {
    $b36288e2db101ba3$var$V = a;
    $b36288e2db101ba3$var$jk(a, b, c);
}
function $b36288e2db101ba3$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $b36288e2db101ba3$var$V;){
        var e = $b36288e2db101ba3$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $b36288e2db101ba3$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $b36288e2db101ba3$var$U;
                h = $b36288e2db101ba3$var$Kj;
                var l = $b36288e2db101ba3$var$U;
                $b36288e2db101ba3$var$Kj = g;
                if (($b36288e2db101ba3$var$U = k) && !l) for($b36288e2db101ba3$var$V = e; null !== $b36288e2db101ba3$var$V;)g = $b36288e2db101ba3$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $b36288e2db101ba3$var$kk(e) : null !== k ? (k.return = g, $b36288e2db101ba3$var$V = k) : $b36288e2db101ba3$var$kk(e);
                for(; null !== f;)$b36288e2db101ba3$var$V = f, $b36288e2db101ba3$var$jk(f, b, c), f = f.sibling;
                $b36288e2db101ba3$var$V = e;
                $b36288e2db101ba3$var$Kj = h;
                $b36288e2db101ba3$var$U = l;
            }
            $b36288e2db101ba3$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $b36288e2db101ba3$var$V = f) : $b36288e2db101ba3$var$lk(a, b, c);
    }
}
function $b36288e2db101ba3$var$lk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $b36288e2db101ba3$var$U || $b36288e2db101ba3$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$b36288e2db101ba3$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $b36288e2db101ba3$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $b36288e2db101ba3$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $b36288e2db101ba3$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $b36288e2db101ba3$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($b36288e2db101ba3$var$p(163));
                }
                $b36288e2db101ba3$var$U || b.flags & 512 && $b36288e2db101ba3$var$Sj(b);
            } catch (r) {
                $b36288e2db101ba3$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$hk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $b36288e2db101ba3$var$V = c;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
function $b36288e2db101ba3$var$kk(a) {
    for(; null !== $b36288e2db101ba3$var$V;){
        var b = $b36288e2db101ba3$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $b36288e2db101ba3$var$Rj(4, b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $b36288e2db101ba3$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $b36288e2db101ba3$var$Sj(b);
                    } catch (k) {
                        $b36288e2db101ba3$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $b36288e2db101ba3$var$W(b, b.return, k);
        }
        if (b === a) {
            $b36288e2db101ba3$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $b36288e2db101ba3$var$V = h;
            break;
        }
        $b36288e2db101ba3$var$V = b.return;
    }
}
var $b36288e2db101ba3$var$mk = Math.ceil, $b36288e2db101ba3$var$nk = $b36288e2db101ba3$var$ua.ReactCurrentDispatcher, $b36288e2db101ba3$var$ok = $b36288e2db101ba3$var$ua.ReactCurrentOwner, $b36288e2db101ba3$var$pk = $b36288e2db101ba3$var$ua.ReactCurrentBatchConfig, $b36288e2db101ba3$var$K = 0, $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Y = null, $b36288e2db101ba3$var$Z = 0, $b36288e2db101ba3$var$gj = 0, $b36288e2db101ba3$var$fj = $b36288e2db101ba3$var$Uf(0), $b36288e2db101ba3$var$T = 0, $b36288e2db101ba3$var$qk = null, $b36288e2db101ba3$var$hh = 0, $b36288e2db101ba3$var$rk = 0, $b36288e2db101ba3$var$sk = 0, $b36288e2db101ba3$var$tk = null, $b36288e2db101ba3$var$uk = null, $b36288e2db101ba3$var$gk = 0, $b36288e2db101ba3$var$Hj = Infinity, $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Pi = !1, $b36288e2db101ba3$var$Qi = null, $b36288e2db101ba3$var$Si = null, $b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = null, $b36288e2db101ba3$var$yk = 0, $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, $b36288e2db101ba3$var$Bk = -1, $b36288e2db101ba3$var$Ck = 0;
function $b36288e2db101ba3$var$L() {
    return 0 !== ($b36288e2db101ba3$var$K & 6) ? $b36288e2db101ba3$var$B() : -1 !== $b36288e2db101ba3$var$Bk ? $b36288e2db101ba3$var$Bk : $b36288e2db101ba3$var$Bk = $b36288e2db101ba3$var$B();
}
function $b36288e2db101ba3$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($b36288e2db101ba3$var$K & 2) && 0 !== $b36288e2db101ba3$var$Z) return $b36288e2db101ba3$var$Z & -$b36288e2db101ba3$var$Z;
    if (null !== $b36288e2db101ba3$var$Kg.transition) return 0 === $b36288e2db101ba3$var$Ck && ($b36288e2db101ba3$var$Ck = $b36288e2db101ba3$var$yc()), $b36288e2db101ba3$var$Ck;
    a = $b36288e2db101ba3$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $b36288e2db101ba3$var$jd(a.type);
    return a;
}
function $b36288e2db101ba3$var$mh(a, b, c, d) {
    if (50 < $b36288e2db101ba3$var$zk) throw $b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = null, Error($b36288e2db101ba3$var$p(185));
    $b36288e2db101ba3$var$Ac(a, c, d);
    if (0 === ($b36288e2db101ba3$var$K & 2) || a !== $b36288e2db101ba3$var$R) a === $b36288e2db101ba3$var$R && (0 === ($b36288e2db101ba3$var$K & 2) && ($b36288e2db101ba3$var$rk |= c), 4 === $b36288e2db101ba3$var$T && $b36288e2db101ba3$var$Dk(a, $b36288e2db101ba3$var$Z)), $b36288e2db101ba3$var$Ek(a, d), 1 === c && 0 === $b36288e2db101ba3$var$K && 0 === (b.mode & 1) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
}
function $b36288e2db101ba3$var$Ek(a, b) {
    var c = a.callbackNode;
    $b36288e2db101ba3$var$wc(a, b);
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) null !== c && $b36288e2db101ba3$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $b36288e2db101ba3$var$bc(c);
        if (1 === b) 0 === a.tag ? $b36288e2db101ba3$var$ig($b36288e2db101ba3$var$Fk.bind(null, a)) : $b36288e2db101ba3$var$hg($b36288e2db101ba3$var$Fk.bind(null, a)), $b36288e2db101ba3$var$Jf(function() {
            0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
        }), c = null;
        else {
            switch($b36288e2db101ba3$var$Dc(d)){
                case 1:
                    c = $b36288e2db101ba3$var$fc;
                    break;
                case 4:
                    c = $b36288e2db101ba3$var$gc;
                    break;
                case 16:
                    c = $b36288e2db101ba3$var$hc;
                    break;
                case 536870912:
                    c = $b36288e2db101ba3$var$jc;
                    break;
                default:
                    c = $b36288e2db101ba3$var$hc;
            }
            c = $b36288e2db101ba3$var$Gk(c, $b36288e2db101ba3$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $b36288e2db101ba3$var$Hk(a, b) {
    $b36288e2db101ba3$var$Bk = -1;
    $b36288e2db101ba3$var$Ck = 0;
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    var c = a.callbackNode;
    if ($b36288e2db101ba3$var$Ik() && a.callbackNode !== c) return null;
    var d = $b36288e2db101ba3$var$uc(a, a === $b36288e2db101ba3$var$R ? $b36288e2db101ba3$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $b36288e2db101ba3$var$Jk(a, d);
    else {
        b = d;
        var e = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 2;
        var f = $b36288e2db101ba3$var$Kk();
        if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$Lk(a, b);
        for(;;)try {
            $b36288e2db101ba3$var$Mk();
            break;
        } catch (h) {
            $b36288e2db101ba3$var$Nk(a, h);
        }
        $b36288e2db101ba3$var$Qg();
        $b36288e2db101ba3$var$nk.current = f;
        $b36288e2db101ba3$var$K = e;
        null !== $b36288e2db101ba3$var$Y ? b = 0 : ($b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0, b = $b36288e2db101ba3$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $b36288e2db101ba3$var$xc(a), 0 !== e && (d = e, b = $b36288e2db101ba3$var$Ok(a, e)));
        if (1 === b) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
        if (6 === b) $b36288e2db101ba3$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$b36288e2db101ba3$var$Pk(e) && (b = $b36288e2db101ba3$var$Jk(a, d), 2 === b && (f = $b36288e2db101ba3$var$xc(a), 0 !== f && (d = f, b = $b36288e2db101ba3$var$Ok(a, f))), 1 === b)) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, d), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($b36288e2db101ba3$var$p(345));
                case 2:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 3:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $b36288e2db101ba3$var$gk + 500 - $b36288e2db101ba3$var$B(), 10 < b)) {
                        if (0 !== $b36288e2db101ba3$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $b36288e2db101ba3$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), b);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 4:
                    $b36288e2db101ba3$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $b36288e2db101ba3$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $b36288e2db101ba3$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $b36288e2db101ba3$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $b36288e2db101ba3$var$Ff($b36288e2db101ba3$var$Qk.bind(null, a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk), d);
                        break;
                    }
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                case 5:
                    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
                    break;
                default:
                    throw Error($b36288e2db101ba3$var$p(329));
            }
        }
    }
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return a.callbackNode === c ? $b36288e2db101ba3$var$Hk.bind(null, a) : null;
}
function $b36288e2db101ba3$var$Ok(a, b) {
    var c = $b36288e2db101ba3$var$tk;
    a.current.memoizedState.isDehydrated && ($b36288e2db101ba3$var$Lk(a, b).flags |= 256);
    a = $b36288e2db101ba3$var$Jk(a, b);
    2 !== a && (b = $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$uk = c, null !== b && $b36288e2db101ba3$var$Gj(b));
    return a;
}
function $b36288e2db101ba3$var$Gj(a) {
    null === $b36288e2db101ba3$var$uk ? $b36288e2db101ba3$var$uk = a : $b36288e2db101ba3$var$uk.push.apply($b36288e2db101ba3$var$uk, a);
}
function $b36288e2db101ba3$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$b36288e2db101ba3$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $b36288e2db101ba3$var$Dk(a, b) {
    b &= ~$b36288e2db101ba3$var$sk;
    b &= ~$b36288e2db101ba3$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $b36288e2db101ba3$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $b36288e2db101ba3$var$Fk(a) {
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$uc(a, 0);
    if (0 === (b & 1)) return $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), null;
    var c = $b36288e2db101ba3$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $b36288e2db101ba3$var$xc(a);
        0 !== d && (b = d, c = $b36288e2db101ba3$var$Ok(a, d));
    }
    if (1 === c) throw c = $b36288e2db101ba3$var$qk, $b36288e2db101ba3$var$Lk(a, 0), $b36288e2db101ba3$var$Dk(a, b), $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B()), c;
    if (6 === c) throw Error($b36288e2db101ba3$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $b36288e2db101ba3$var$Qk(a, $b36288e2db101ba3$var$uk, $b36288e2db101ba3$var$vk);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    return null;
}
function $b36288e2db101ba3$var$Rk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    try {
        return a(b);
    } finally{
        $b36288e2db101ba3$var$K = c, 0 === $b36288e2db101ba3$var$K && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$fg && $b36288e2db101ba3$var$jg());
    }
}
function $b36288e2db101ba3$var$Sk(a) {
    null !== $b36288e2db101ba3$var$xk && 0 === $b36288e2db101ba3$var$xk.tag && 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$Ik();
    var b = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 1;
    var c = $b36288e2db101ba3$var$pk.transition, d = $b36288e2db101ba3$var$C;
    try {
        if ($b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, a) return a();
    } finally{
        $b36288e2db101ba3$var$C = d, $b36288e2db101ba3$var$pk.transition = c, $b36288e2db101ba3$var$K = b, 0 === ($b36288e2db101ba3$var$K & 6) && $b36288e2db101ba3$var$jg();
    }
}
function $b36288e2db101ba3$var$Ij() {
    $b36288e2db101ba3$var$gj = $b36288e2db101ba3$var$fj.current;
    $b36288e2db101ba3$var$E($b36288e2db101ba3$var$fj);
}
function $b36288e2db101ba3$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $b36288e2db101ba3$var$Gf(c));
    if (null !== $b36288e2db101ba3$var$Y) for(c = $b36288e2db101ba3$var$Y.return; null !== c;){
        var d = c;
        $b36288e2db101ba3$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $b36288e2db101ba3$var$$f();
                break;
            case 3:
                $b36288e2db101ba3$var$Jh();
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$Wf);
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$H);
                $b36288e2db101ba3$var$Oh();
                break;
            case 5:
                $b36288e2db101ba3$var$Lh(d);
                break;
            case 4:
                $b36288e2db101ba3$var$Jh();
                break;
            case 13:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 19:
                $b36288e2db101ba3$var$E($b36288e2db101ba3$var$M);
                break;
            case 10:
                $b36288e2db101ba3$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $b36288e2db101ba3$var$Ij();
        }
        c = c.return;
    }
    $b36288e2db101ba3$var$R = a;
    $b36288e2db101ba3$var$Y = a = $b36288e2db101ba3$var$wh(a.current, null);
    $b36288e2db101ba3$var$Z = $b36288e2db101ba3$var$gj = b;
    $b36288e2db101ba3$var$T = 0;
    $b36288e2db101ba3$var$qk = null;
    $b36288e2db101ba3$var$sk = $b36288e2db101ba3$var$rk = $b36288e2db101ba3$var$hh = 0;
    $b36288e2db101ba3$var$uk = $b36288e2db101ba3$var$tk = null;
    if (null !== $b36288e2db101ba3$var$Wg) {
        for(b = 0; b < $b36288e2db101ba3$var$Wg.length; b++)if (c = $b36288e2db101ba3$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $b36288e2db101ba3$var$Wg = null;
    }
    return a;
}
function $b36288e2db101ba3$var$Nk(a, b) {
    do {
        var c = $b36288e2db101ba3$var$Y;
        try {
            $b36288e2db101ba3$var$Qg();
            $b36288e2db101ba3$var$Ph.current = $b36288e2db101ba3$var$ai;
            if ($b36288e2db101ba3$var$Sh) {
                for(var d = $b36288e2db101ba3$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $b36288e2db101ba3$var$Sh = !1;
            }
            $b36288e2db101ba3$var$Rh = 0;
            $b36288e2db101ba3$var$P = $b36288e2db101ba3$var$O = $b36288e2db101ba3$var$N = null;
            $b36288e2db101ba3$var$Th = !1;
            $b36288e2db101ba3$var$Uh = 0;
            $b36288e2db101ba3$var$ok.current = null;
            if (null === c || null === c.return) {
                $b36288e2db101ba3$var$T = 1;
                $b36288e2db101ba3$var$qk = b;
                $b36288e2db101ba3$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $b36288e2db101ba3$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $b36288e2db101ba3$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $b36288e2db101ba3$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $b36288e2db101ba3$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $b36288e2db101ba3$var$Ti(f, l, b);
                            $b36288e2db101ba3$var$uj();
                            break a;
                        }
                        k = Error($b36288e2db101ba3$var$p(426));
                    }
                } else if ($b36288e2db101ba3$var$I && h.mode & 1) {
                    var J = $b36288e2db101ba3$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $b36288e2db101ba3$var$Wi(J, g, h, f, b);
                        $b36288e2db101ba3$var$Jg($b36288e2db101ba3$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $b36288e2db101ba3$var$Ki(k, h);
                4 !== $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 2);
                null === $b36288e2db101ba3$var$tk ? $b36288e2db101ba3$var$tk = [
                    f
                ] : $b36288e2db101ba3$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $b36288e2db101ba3$var$Oi(f, k, b);
                            $b36288e2db101ba3$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $b36288e2db101ba3$var$Ri(f, h, b);
                                $b36288e2db101ba3$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $b36288e2db101ba3$var$Tk(c);
        } catch (na) {
            b = na;
            $b36288e2db101ba3$var$Y === c && null !== c && ($b36288e2db101ba3$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $b36288e2db101ba3$var$Kk() {
    var a = $b36288e2db101ba3$var$nk.current;
    $b36288e2db101ba3$var$nk.current = $b36288e2db101ba3$var$ai;
    return null === a ? $b36288e2db101ba3$var$ai : a;
}
function $b36288e2db101ba3$var$uj() {
    if (0 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T || 2 === $b36288e2db101ba3$var$T) $b36288e2db101ba3$var$T = 4;
    null === $b36288e2db101ba3$var$R || 0 === ($b36288e2db101ba3$var$hh & 268435455) && 0 === ($b36288e2db101ba3$var$rk & 268435455) || $b36288e2db101ba3$var$Dk($b36288e2db101ba3$var$R, $b36288e2db101ba3$var$Z);
}
function $b36288e2db101ba3$var$Jk(a, b) {
    var c = $b36288e2db101ba3$var$K;
    $b36288e2db101ba3$var$K |= 2;
    var d = $b36288e2db101ba3$var$Kk();
    if ($b36288e2db101ba3$var$R !== a || $b36288e2db101ba3$var$Z !== b) $b36288e2db101ba3$var$vk = null, $b36288e2db101ba3$var$Lk(a, b);
    for(;;)try {
        $b36288e2db101ba3$var$Uk();
        break;
    } catch (e) {
        $b36288e2db101ba3$var$Nk(a, e);
    }
    $b36288e2db101ba3$var$Qg();
    $b36288e2db101ba3$var$K = c;
    $b36288e2db101ba3$var$nk.current = d;
    if (null !== $b36288e2db101ba3$var$Y) throw Error($b36288e2db101ba3$var$p(261));
    $b36288e2db101ba3$var$R = null;
    $b36288e2db101ba3$var$Z = 0;
    return $b36288e2db101ba3$var$T;
}
function $b36288e2db101ba3$var$Uk() {
    for(; null !== $b36288e2db101ba3$var$Y;)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Mk() {
    for(; null !== $b36288e2db101ba3$var$Y && !$b36288e2db101ba3$var$cc();)$b36288e2db101ba3$var$Vk($b36288e2db101ba3$var$Y);
}
function $b36288e2db101ba3$var$Vk(a) {
    var b = $b36288e2db101ba3$var$Wk(a.alternate, a, $b36288e2db101ba3$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $b36288e2db101ba3$var$Tk(a) : $b36288e2db101ba3$var$Y = b;
    $b36288e2db101ba3$var$ok.current = null;
}
function $b36288e2db101ba3$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $b36288e2db101ba3$var$Fj(c, b, $b36288e2db101ba3$var$gj), null !== c) {
                $b36288e2db101ba3$var$Y = c;
                return;
            }
        } else {
            c = $b36288e2db101ba3$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $b36288e2db101ba3$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $b36288e2db101ba3$var$T = 6;
                $b36288e2db101ba3$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $b36288e2db101ba3$var$Y = b;
            return;
        }
        $b36288e2db101ba3$var$Y = b = a;
    }while (null !== b);
    0 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$T = 5);
}
function $b36288e2db101ba3$var$Qk(a, b, c) {
    var d = $b36288e2db101ba3$var$C, e = $b36288e2db101ba3$var$pk.transition;
    try {
        $b36288e2db101ba3$var$pk.transition = null, $b36288e2db101ba3$var$C = 1, $b36288e2db101ba3$var$Xk(a, b, c, d);
    } finally{
        $b36288e2db101ba3$var$pk.transition = e, $b36288e2db101ba3$var$C = d;
    }
    return null;
}
function $b36288e2db101ba3$var$Xk(a, b, c, d) {
    do $b36288e2db101ba3$var$Ik();
    while (null !== $b36288e2db101ba3$var$xk);
    if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($b36288e2db101ba3$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $b36288e2db101ba3$var$Bc(a, f);
    a === $b36288e2db101ba3$var$R && ($b36288e2db101ba3$var$Y = $b36288e2db101ba3$var$R = null, $b36288e2db101ba3$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $b36288e2db101ba3$var$wk || ($b36288e2db101ba3$var$wk = !0, $b36288e2db101ba3$var$Gk($b36288e2db101ba3$var$hc, function() {
        $b36288e2db101ba3$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $b36288e2db101ba3$var$pk.transition;
        $b36288e2db101ba3$var$pk.transition = null;
        var g = $b36288e2db101ba3$var$C;
        $b36288e2db101ba3$var$C = 1;
        var h = $b36288e2db101ba3$var$K;
        $b36288e2db101ba3$var$K |= 4;
        $b36288e2db101ba3$var$ok.current = null;
        $b36288e2db101ba3$var$Pj(a, c);
        $b36288e2db101ba3$var$ek(c, a);
        $b36288e2db101ba3$var$Oe($b36288e2db101ba3$var$Df);
        $b36288e2db101ba3$var$dd = !!$b36288e2db101ba3$var$Cf;
        $b36288e2db101ba3$var$Df = $b36288e2db101ba3$var$Cf = null;
        a.current = c;
        $b36288e2db101ba3$var$ik(c, a, e);
        $b36288e2db101ba3$var$dc();
        $b36288e2db101ba3$var$K = h;
        $b36288e2db101ba3$var$C = g;
        $b36288e2db101ba3$var$pk.transition = f;
    } else a.current = c;
    $b36288e2db101ba3$var$wk && ($b36288e2db101ba3$var$wk = !1, $b36288e2db101ba3$var$xk = a, $b36288e2db101ba3$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($b36288e2db101ba3$var$Si = null);
    $b36288e2db101ba3$var$mc(c.stateNode, d);
    $b36288e2db101ba3$var$Ek(a, $b36288e2db101ba3$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($b36288e2db101ba3$var$Pi) throw $b36288e2db101ba3$var$Pi = !1, a = $b36288e2db101ba3$var$Qi, $b36288e2db101ba3$var$Qi = null, a;
    0 !== ($b36288e2db101ba3$var$yk & 1) && 0 !== a.tag && $b36288e2db101ba3$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $b36288e2db101ba3$var$Ak ? $b36288e2db101ba3$var$zk++ : ($b36288e2db101ba3$var$zk = 0, $b36288e2db101ba3$var$Ak = a) : $b36288e2db101ba3$var$zk = 0;
    $b36288e2db101ba3$var$jg();
    return null;
}
function $b36288e2db101ba3$var$Ik() {
    if (null !== $b36288e2db101ba3$var$xk) {
        var a = $b36288e2db101ba3$var$Dc($b36288e2db101ba3$var$yk), b = $b36288e2db101ba3$var$pk.transition, c = $b36288e2db101ba3$var$C;
        try {
            $b36288e2db101ba3$var$pk.transition = null;
            $b36288e2db101ba3$var$C = 16 > a ? 16 : a;
            if (null === $b36288e2db101ba3$var$xk) var d = !1;
            else {
                a = $b36288e2db101ba3$var$xk;
                $b36288e2db101ba3$var$xk = null;
                $b36288e2db101ba3$var$yk = 0;
                if (0 !== ($b36288e2db101ba3$var$K & 6)) throw Error($b36288e2db101ba3$var$p(331));
                var e = $b36288e2db101ba3$var$K;
                $b36288e2db101ba3$var$K |= 4;
                for($b36288e2db101ba3$var$V = a.current; null !== $b36288e2db101ba3$var$V;){
                    var f = $b36288e2db101ba3$var$V, g = f.child;
                    if (0 !== ($b36288e2db101ba3$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($b36288e2db101ba3$var$V = l; null !== $b36288e2db101ba3$var$V;){
                                    var m = $b36288e2db101ba3$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $b36288e2db101ba3$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $b36288e2db101ba3$var$V = q;
                                    else for(; null !== $b36288e2db101ba3$var$V;){
                                        m = $b36288e2db101ba3$var$V;
                                        var r = m.sibling, y = m.return;
                                        $b36288e2db101ba3$var$Tj(m);
                                        if (m === l) {
                                            $b36288e2db101ba3$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $b36288e2db101ba3$var$V = r;
                                            break;
                                        }
                                        $b36288e2db101ba3$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $b36288e2db101ba3$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $b36288e2db101ba3$var$V = g;
                    else b: for(; null !== $b36288e2db101ba3$var$V;){
                        f = $b36288e2db101ba3$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $b36288e2db101ba3$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $b36288e2db101ba3$var$V = x;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = f.return;
                    }
                }
                var w = a.current;
                for($b36288e2db101ba3$var$V = w; null !== $b36288e2db101ba3$var$V;){
                    g = $b36288e2db101ba3$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $b36288e2db101ba3$var$V = u;
                    else b: for(g = w; null !== $b36288e2db101ba3$var$V;){
                        h = $b36288e2db101ba3$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $b36288e2db101ba3$var$Rj(9, h);
                            }
                        } catch (na) {
                            $b36288e2db101ba3$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $b36288e2db101ba3$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $b36288e2db101ba3$var$V = F;
                            break b;
                        }
                        $b36288e2db101ba3$var$V = h.return;
                    }
                }
                $b36288e2db101ba3$var$K = e;
                $b36288e2db101ba3$var$jg();
                if ($b36288e2db101ba3$var$lc && "function" === typeof $b36288e2db101ba3$var$lc.onPostCommitFiberRoot) try {
                    $b36288e2db101ba3$var$lc.onPostCommitFiberRoot($b36288e2db101ba3$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $b36288e2db101ba3$var$C = c, $b36288e2db101ba3$var$pk.transition = b;
        }
    }
    return !1;
}
function $b36288e2db101ba3$var$Yk(a, b, c) {
    b = $b36288e2db101ba3$var$Ki(c, b);
    b = $b36288e2db101ba3$var$Oi(a, b, 1);
    a = $b36288e2db101ba3$var$dh(a, b, 1);
    b = $b36288e2db101ba3$var$L();
    null !== a && ($b36288e2db101ba3$var$Ac(a, 1, b), $b36288e2db101ba3$var$Ek(a, b));
}
function $b36288e2db101ba3$var$W(a, b, c) {
    if (3 === a.tag) $b36288e2db101ba3$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $b36288e2db101ba3$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $b36288e2db101ba3$var$Si || !$b36288e2db101ba3$var$Si.has(d))) {
                a = $b36288e2db101ba3$var$Ki(c, a);
                a = $b36288e2db101ba3$var$Ri(b, a, 1);
                b = $b36288e2db101ba3$var$dh(b, a, 1);
                a = $b36288e2db101ba3$var$L();
                null !== b && ($b36288e2db101ba3$var$Ac(b, 1, a), $b36288e2db101ba3$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $b36288e2db101ba3$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $b36288e2db101ba3$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $b36288e2db101ba3$var$R === a && ($b36288e2db101ba3$var$Z & c) === c && (4 === $b36288e2db101ba3$var$T || 3 === $b36288e2db101ba3$var$T && ($b36288e2db101ba3$var$Z & 130023424) === $b36288e2db101ba3$var$Z && 500 > $b36288e2db101ba3$var$B() - $b36288e2db101ba3$var$gk ? $b36288e2db101ba3$var$Lk(a, 0) : $b36288e2db101ba3$var$sk |= c);
    $b36288e2db101ba3$var$Ek(a, b);
}
function $b36288e2db101ba3$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $b36288e2db101ba3$var$sc, $b36288e2db101ba3$var$sc <<= 1, 0 === ($b36288e2db101ba3$var$sc & 130023424) && ($b36288e2db101ba3$var$sc = 4194304)));
    var c = $b36288e2db101ba3$var$L();
    a = $b36288e2db101ba3$var$Zg(a, b);
    null !== a && ($b36288e2db101ba3$var$Ac(a, b, c), $b36288e2db101ba3$var$Ek(a, c));
}
function $b36288e2db101ba3$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $b36288e2db101ba3$var$Zk(a, c);
}
function $b36288e2db101ba3$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($b36288e2db101ba3$var$p(314));
    }
    null !== d && d.delete(b);
    $b36288e2db101ba3$var$Zk(a, c);
}
var $b36288e2db101ba3$var$Wk;
$b36288e2db101ba3$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $b36288e2db101ba3$var$Wf.current) $b36288e2db101ba3$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$zj(a, b, c);
            $b36288e2db101ba3$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $b36288e2db101ba3$var$Ug = !1, $b36288e2db101ba3$var$I && 0 !== (b.flags & 1048576) && $b36288e2db101ba3$var$ug(b, $b36288e2db101ba3$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $b36288e2db101ba3$var$jj(a, b);
            a = b.pendingProps;
            var e = $b36288e2db101ba3$var$Yf(b, $b36288e2db101ba3$var$H.current);
            $b36288e2db101ba3$var$Tg(b, c);
            e = $b36288e2db101ba3$var$Xh(null, b, d, a, e, c);
            var f = $b36288e2db101ba3$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $b36288e2db101ba3$var$Zf(d) ? (f = !0, $b36288e2db101ba3$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $b36288e2db101ba3$var$ah(b), e.updater = $b36288e2db101ba3$var$nh, b.stateNode = e, e._reactInternals = b, $b36288e2db101ba3$var$rh(b, d, a, c), b = $b36288e2db101ba3$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $b36288e2db101ba3$var$I && f && $b36288e2db101ba3$var$vg(b), $b36288e2db101ba3$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $b36288e2db101ba3$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $b36288e2db101ba3$var$$k(d);
                a = $b36288e2db101ba3$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $b36288e2db101ba3$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $b36288e2db101ba3$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $b36288e2db101ba3$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $b36288e2db101ba3$var$aj(null, b, d, $b36288e2db101ba3$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($b36288e2db101ba3$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $b36288e2db101ba3$var$lj(b);
                if (null === a) throw Error($b36288e2db101ba3$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $b36288e2db101ba3$var$bh(a, b);
                $b36288e2db101ba3$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(423)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $b36288e2db101ba3$var$Ki(Error($b36288e2db101ba3$var$p(424)), b);
                        b = $b36288e2db101ba3$var$mj(a, b, d, c, e);
                        break a;
                    } else for($b36288e2db101ba3$var$yg = $b36288e2db101ba3$var$Lf(b.stateNode.containerInfo.firstChild), $b36288e2db101ba3$var$xg = b, $b36288e2db101ba3$var$I = !0, $b36288e2db101ba3$var$zg = null, c = $b36288e2db101ba3$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $b36288e2db101ba3$var$Ig();
                    if (d === e) {
                        b = $b36288e2db101ba3$var$$i(a, b, c);
                        break a;
                    }
                    $b36288e2db101ba3$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $b36288e2db101ba3$var$Kh(b), null === a && $b36288e2db101ba3$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $b36288e2db101ba3$var$Ef(d, e) ? g = null : null !== f && $b36288e2db101ba3$var$Ef(d, f) && (b.flags |= 32), $b36288e2db101ba3$var$hj(a, b), $b36288e2db101ba3$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $b36288e2db101ba3$var$Eg(b), null;
        case 13:
            return $b36288e2db101ba3$var$pj(a, b, c);
        case 4:
            return $b36288e2db101ba3$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $b36288e2db101ba3$var$Bh(b, null, d, c) : $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$Zi(a, b, d, e, c);
        case 7:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $b36288e2db101ba3$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $b36288e2db101ba3$var$G($b36288e2db101ba3$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($b36288e2db101ba3$var$He(f.value, g)) {
                        if (f.children === e.children && !$b36288e2db101ba3$var$Wf.current) {
                            b = $b36288e2db101ba3$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $b36288e2db101ba3$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $b36288e2db101ba3$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($b36288e2db101ba3$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $b36288e2db101ba3$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $b36288e2db101ba3$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $b36288e2db101ba3$var$Tg(b, c), e = $b36288e2db101ba3$var$Vg(e), d = d(e), b.flags |= 1, $b36288e2db101ba3$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $b36288e2db101ba3$var$Lg(d, b.pendingProps), e = $b36288e2db101ba3$var$Lg(d.type, e), $b36288e2db101ba3$var$aj(a, b, d, e, c);
        case 15:
            return $b36288e2db101ba3$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $b36288e2db101ba3$var$Lg(d, e), $b36288e2db101ba3$var$jj(a, b), b.tag = 1, $b36288e2db101ba3$var$Zf(d) ? (a = !0, $b36288e2db101ba3$var$cg(b)) : a = !1, $b36288e2db101ba3$var$Tg(b, c), $b36288e2db101ba3$var$ph(b, d, e), $b36288e2db101ba3$var$rh(b, d, e, c), $b36288e2db101ba3$var$kj(null, b, d, !0, a, c);
        case 19:
            return $b36288e2db101ba3$var$yj(a, b, c);
        case 22:
            return $b36288e2db101ba3$var$ej(a, b, c);
    }
    throw Error($b36288e2db101ba3$var$p(156, b.tag));
};
function $b36288e2db101ba3$var$Gk(a, b) {
    return $b36288e2db101ba3$var$ac(a, b);
}
function $b36288e2db101ba3$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $b36288e2db101ba3$var$Bg(a, b, c, d) {
    return new $b36288e2db101ba3$var$al(a, b, c, d);
}
function $b36288e2db101ba3$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $b36288e2db101ba3$var$$k(a) {
    if ("function" === typeof a) return $b36288e2db101ba3$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $b36288e2db101ba3$var$Da) return 11;
        if (a === $b36288e2db101ba3$var$Ga) return 14;
    }
    return 2;
}
function $b36288e2db101ba3$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $b36288e2db101ba3$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $b36288e2db101ba3$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $b36288e2db101ba3$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $b36288e2db101ba3$var$ya:
            return $b36288e2db101ba3$var$Ah(c.children, e, f, b);
        case $b36288e2db101ba3$var$za:
            g = 8;
            e |= 8;
            break;
        case $b36288e2db101ba3$var$Aa:
            return a = $b36288e2db101ba3$var$Bg(12, c, b, e | 2), a.elementType = $b36288e2db101ba3$var$Aa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ea:
            return a = $b36288e2db101ba3$var$Bg(13, c, b, e), a.elementType = $b36288e2db101ba3$var$Ea, a.lanes = f, a;
        case $b36288e2db101ba3$var$Fa:
            return a = $b36288e2db101ba3$var$Bg(19, c, b, e), a.elementType = $b36288e2db101ba3$var$Fa, a.lanes = f, a;
        case $b36288e2db101ba3$var$Ia:
            return $b36288e2db101ba3$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $b36288e2db101ba3$var$Ba:
                    g = 10;
                    break a;
                case $b36288e2db101ba3$var$Ca:
                    g = 9;
                    break a;
                case $b36288e2db101ba3$var$Da:
                    g = 11;
                    break a;
                case $b36288e2db101ba3$var$Ga:
                    g = 14;
                    break a;
                case $b36288e2db101ba3$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($b36288e2db101ba3$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $b36288e2db101ba3$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $b36288e2db101ba3$var$Ah(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$qj(a, b, c, d) {
    a = $b36288e2db101ba3$var$Bg(22, a, d, b);
    a.elementType = $b36288e2db101ba3$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $b36288e2db101ba3$var$xh(a, b, c) {
    a = $b36288e2db101ba3$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $b36288e2db101ba3$var$zh(a, b, c) {
    b = $b36288e2db101ba3$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $b36288e2db101ba3$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $b36288e2db101ba3$var$zc(0);
    this.expirationTimes = $b36288e2db101ba3$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $b36288e2db101ba3$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $b36288e2db101ba3$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $b36288e2db101ba3$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $b36288e2db101ba3$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $b36288e2db101ba3$var$ah(f);
    return a;
}
function $b36288e2db101ba3$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $b36288e2db101ba3$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $b36288e2db101ba3$var$el(a) {
    if (!a) return $b36288e2db101ba3$var$Vf;
    a = a._reactInternals;
    a: {
        if ($b36288e2db101ba3$var$Vb(a) !== a || 1 !== a.tag) throw Error($b36288e2db101ba3$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($b36288e2db101ba3$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($b36288e2db101ba3$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($b36288e2db101ba3$var$Zf(c)) return $b36288e2db101ba3$var$bg(a, c, b);
    }
    return b;
}
function $b36288e2db101ba3$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $b36288e2db101ba3$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $b36288e2db101ba3$var$el(null);
    c = a.current;
    d = $b36288e2db101ba3$var$L();
    e = $b36288e2db101ba3$var$lh(c);
    f = $b36288e2db101ba3$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $b36288e2db101ba3$var$dh(c, f, e);
    a.current.lanes = e;
    $b36288e2db101ba3$var$Ac(a, e, d);
    $b36288e2db101ba3$var$Ek(a, d);
    return a;
}
function $b36288e2db101ba3$var$gl(a, b, c, d) {
    var e = b.current, f = $b36288e2db101ba3$var$L(), g = $b36288e2db101ba3$var$lh(e);
    c = $b36288e2db101ba3$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $b36288e2db101ba3$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $b36288e2db101ba3$var$dh(e, b, g);
    null !== a && ($b36288e2db101ba3$var$mh(a, e, g, f), $b36288e2db101ba3$var$eh(a, e, g));
    return g;
}
function $b36288e2db101ba3$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $b36288e2db101ba3$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $b36288e2db101ba3$var$jl(a, b) {
    $b36288e2db101ba3$var$il(a, b);
    (a = a.alternate) && $b36288e2db101ba3$var$il(a, b);
}
function $b36288e2db101ba3$var$kl() {
    return null;
}
var $b36288e2db101ba3$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $b36288e2db101ba3$var$ml(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.render = $b36288e2db101ba3$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($b36288e2db101ba3$var$p(409));
    $b36288e2db101ba3$var$gl(a, b, null, null);
};
$b36288e2db101ba3$var$nl.prototype.unmount = $b36288e2db101ba3$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $b36288e2db101ba3$var$Sk(function() {
            $b36288e2db101ba3$var$gl(null, a, null, null);
        });
        b[$b36288e2db101ba3$var$uf] = null;
    }
};
function $b36288e2db101ba3$var$nl(a) {
    this._internalRoot = a;
}
$b36288e2db101ba3$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $b36288e2db101ba3$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $b36288e2db101ba3$var$Qc.length && 0 !== b && b < $b36288e2db101ba3$var$Qc[c].priority; c++);
        $b36288e2db101ba3$var$Qc.splice(c, 0, a);
        0 === c && $b36288e2db101ba3$var$Vc(a);
    }
};
function $b36288e2db101ba3$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $b36288e2db101ba3$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $b36288e2db101ba3$var$ql() {}
function $b36288e2db101ba3$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                f.call(a);
            };
        }
        var g = $b36288e2db101ba3$var$fl(b, d, a, 0, null, !1, !1, "", $b36288e2db101ba3$var$ql);
        a._reactRootContainer = g;
        a[$b36288e2db101ba3$var$uf] = g.current;
        $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
        $b36288e2db101ba3$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $b36288e2db101ba3$var$hl(k);
            h.call(a);
        };
    }
    var k = $b36288e2db101ba3$var$cl(a, 0, !1, null, null, !1, !1, "", $b36288e2db101ba3$var$ql);
    a._reactRootContainer = k;
    a[$b36288e2db101ba3$var$uf] = k.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    $b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$gl(b, k, c, d);
    });
    return k;
}
function $b36288e2db101ba3$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $b36288e2db101ba3$var$hl(g);
                h.call(a);
            };
        }
        $b36288e2db101ba3$var$gl(b, g, a, e);
    } else g = $b36288e2db101ba3$var$rl(c, b, a, e, d);
    return $b36288e2db101ba3$var$hl(g);
}
$b36288e2db101ba3$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $b36288e2db101ba3$var$tc(b.pendingLanes);
                0 !== c && ($b36288e2db101ba3$var$Cc(b, c | 1), $b36288e2db101ba3$var$Ek(b, $b36288e2db101ba3$var$B()), 0 === ($b36288e2db101ba3$var$K & 6) && ($b36288e2db101ba3$var$Hj = $b36288e2db101ba3$var$B() + 500, $b36288e2db101ba3$var$jg()));
            }
            break;
        case 13:
            $b36288e2db101ba3$var$Sk(function() {
                var b = $b36288e2db101ba3$var$Zg(a, 1);
                if (null !== b) {
                    var c = $b36288e2db101ba3$var$L();
                    $b36288e2db101ba3$var$mh(b, a, 1, c);
                }
            }), $b36288e2db101ba3$var$jl(a, 1);
    }
};
$b36288e2db101ba3$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(b, a, 134217728, c);
        }
        $b36288e2db101ba3$var$jl(a, 134217728);
    }
};
$b36288e2db101ba3$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $b36288e2db101ba3$var$lh(a), c = $b36288e2db101ba3$var$Zg(a, b);
        if (null !== c) {
            var d = $b36288e2db101ba3$var$L();
            $b36288e2db101ba3$var$mh(c, a, b, d);
        }
        $b36288e2db101ba3$var$jl(a, b);
    }
};
$b36288e2db101ba3$var$Hc = function() {
    return $b36288e2db101ba3$var$C;
};
$b36288e2db101ba3$var$Ic = function(a, b) {
    var c = $b36288e2db101ba3$var$C;
    try {
        return $b36288e2db101ba3$var$C = a, b();
    } finally{
        $b36288e2db101ba3$var$C = c;
    }
};
$b36288e2db101ba3$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $b36288e2db101ba3$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $b36288e2db101ba3$var$Db(d);
                        if (!e) throw Error($b36288e2db101ba3$var$p(90));
                        $b36288e2db101ba3$var$Wa(d);
                        $b36288e2db101ba3$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $b36288e2db101ba3$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $b36288e2db101ba3$var$fb(a, !!c.multiple, b, !1);
    }
};
$b36288e2db101ba3$var$Gb = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$var$Hb = $b36288e2db101ba3$var$Sk;
var $b36288e2db101ba3$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $b36288e2db101ba3$var$Cb,
        $b36288e2db101ba3$var$ue,
        $b36288e2db101ba3$var$Db,
        $b36288e2db101ba3$var$Eb,
        $b36288e2db101ba3$var$Fb,
        $b36288e2db101ba3$var$Rk
    ]
}, $b36288e2db101ba3$var$ul = {
    findFiberByHostInstance: $b36288e2db101ba3$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $b36288e2db101ba3$var$vl = {
    bundleType: $b36288e2db101ba3$var$ul.bundleType,
    version: $b36288e2db101ba3$var$ul.version,
    rendererPackageName: $b36288e2db101ba3$var$ul.rendererPackageName,
    rendererConfig: $b36288e2db101ba3$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $b36288e2db101ba3$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $b36288e2db101ba3$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $b36288e2db101ba3$var$ul.findFiberByHostInstance || $b36288e2db101ba3$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $b36288e2db101ba3$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$b36288e2db101ba3$var$wl.isDisabled && $b36288e2db101ba3$var$wl.supportsFiber) try {
        $b36288e2db101ba3$var$kc = $b36288e2db101ba3$var$wl.inject($b36288e2db101ba3$var$vl), $b36288e2db101ba3$var$lc = $b36288e2db101ba3$var$wl;
    } catch (a) {}
}
$b36288e2db101ba3$export$ae55be85d98224ed = $b36288e2db101ba3$var$tl;
$b36288e2db101ba3$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$b36288e2db101ba3$var$ol(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$dl(a, b, null, c);
};
$b36288e2db101ba3$export$882461b6382ed46c = function(a, b) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(299));
    var c = !1, d = "", e = $b36288e2db101ba3$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $b36288e2db101ba3$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $b36288e2db101ba3$var$ml(b);
};
$b36288e2db101ba3$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($b36288e2db101ba3$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($b36288e2db101ba3$var$p(268, a));
    }
    a = $b36288e2db101ba3$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$b36288e2db101ba3$export$cd75ccfd720a3cd4 = function(a) {
    return $b36288e2db101ba3$var$Sk(a);
};
$b36288e2db101ba3$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !0, c);
};
$b36288e2db101ba3$export$757ceba2d55c277e = function(a, b, c) {
    if (!$b36288e2db101ba3$var$ol(a)) throw Error($b36288e2db101ba3$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $b36288e2db101ba3$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $b36288e2db101ba3$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$b36288e2db101ba3$var$uf] = b.current;
    $b36288e2db101ba3$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $b36288e2db101ba3$var$nl(b);
};
$b36288e2db101ba3$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$b36288e2db101ba3$var$pl(b)) throw Error($b36288e2db101ba3$var$p(200));
    return $b36288e2db101ba3$var$sl(null, a, b, !1, c);
};
$b36288e2db101ba3$export$502457920280e6be = function(a) {
    if (!$b36288e2db101ba3$var$pl(a)) throw Error($b36288e2db101ba3$var$p(40));
    return a._reactRootContainer ? ($b36288e2db101ba3$var$Sk(function() {
        $b36288e2db101ba3$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$b36288e2db101ba3$var$uf] = null;
        });
    }), !0) : !1;
};
$b36288e2db101ba3$export$c78a37762a8d58e1 = $b36288e2db101ba3$var$Rk;
$b36288e2db101ba3$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$b36288e2db101ba3$var$pl(c)) throw Error($b36288e2db101ba3$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($b36288e2db101ba3$var$p(38));
    return $b36288e2db101ba3$var$sl(a, b, c, !1, d);
};
$b36288e2db101ba3$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("4LCdk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8BKFp"));

});
parcelRequire.register("8BKFp", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $6445fa7f31ec0ca5$export$c4744153514ff05d; }, function (v) { return $6445fa7f31ec0ca5$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7; }, function (v) { return $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875; }, function (v) { return $6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $6445fa7f31ec0ca5$export$502329bbf4b505b1; }, function (v) { return $6445fa7f31ec0ca5$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $6445fa7f31ec0ca5$export$6e3807111c4874c4; }, function (v) { return $6445fa7f31ec0ca5$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $6445fa7f31ec0ca5$export$c27134553091fb3a; }, function (v) { return $6445fa7f31ec0ca5$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2; }, function (v) { return $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2; }, function (v) { return $6445fa7f31ec0ca5$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62; }, function (v) { return $6445fa7f31ec0ca5$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b; }, function (v) { return $6445fa7f31ec0ca5$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555; }, function (v) { return $6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $6445fa7f31ec0ca5$export$839f9183b0465a69; }, function (v) { return $6445fa7f31ec0ca5$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $6445fa7f31ec0ca5$export$72fdf0e06517287b; }, function (v) { return $6445fa7f31ec0ca5$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4; }, function (v) { return $6445fa7f31ec0ca5$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1; }, function (v) { return $6445fa7f31ec0ca5$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0; }, function (v) { return $6445fa7f31ec0ca5$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f; }, function (v) { return $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed; }, function (v) { return $6445fa7f31ec0ca5$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $6445fa7f31ec0ca5$export$cf845f2c119da08a; }, function (v) { return $6445fa7f31ec0ca5$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6445fa7f31ec0ca5$export$c4744153514ff05d;
var $6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7;
var $6445fa7f31ec0ca5$export$e26fe2ed2fa76875;
var $6445fa7f31ec0ca5$export$502329bbf4b505b1;
var $6445fa7f31ec0ca5$export$6e3807111c4874c4;
var $6445fa7f31ec0ca5$export$c27134553091fb3a;
var $6445fa7f31ec0ca5$export$33ee1acdc04fd2a2;
var $6445fa7f31ec0ca5$export$b00a404bbd5edef2;
var $6445fa7f31ec0ca5$export$8352ce38b91d0c62;
var $6445fa7f31ec0ca5$export$d66a1c1c77bd778b;
var $6445fa7f31ec0ca5$export$d3dfb8e4810cb555;
var $6445fa7f31ec0ca5$export$839f9183b0465a69;
var $6445fa7f31ec0ca5$export$72fdf0e06517287b;
var $6445fa7f31ec0ca5$export$4b844e58a3e414b4;
var $6445fa7f31ec0ca5$export$816d2913ae6b83b1;
var $6445fa7f31ec0ca5$export$61bcfe829111a1d0;
var $6445fa7f31ec0ca5$export$7ee8c9beb337bc3f;
var $6445fa7f31ec0ca5$export$b5836b71941fa3ed;
var $6445fa7f31ec0ca5$export$cf845f2c119da08a;
"use strict";
function $6445fa7f31ec0ca5$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $6445fa7f31ec0ca5$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $6445fa7f31ec0ca5$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $6445fa7f31ec0ca5$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $6445fa7f31ec0ca5$var$g(C, c)) n < e && 0 > $6445fa7f31ec0ca5$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $6445fa7f31ec0ca5$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $6445fa7f31ec0ca5$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $6445fa7f31ec0ca5$var$l = performance;
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$l.now();
    };
} else {
    var $6445fa7f31ec0ca5$var$p = Date, $6445fa7f31ec0ca5$var$q = $6445fa7f31ec0ca5$var$p.now();
    $6445fa7f31ec0ca5$export$c4744153514ff05d = function() {
        return $6445fa7f31ec0ca5$var$p.now() - $6445fa7f31ec0ca5$var$q;
    };
}
var $6445fa7f31ec0ca5$var$r = [], $6445fa7f31ec0ca5$var$t = [], $6445fa7f31ec0ca5$var$u = 1, $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = 3, $6445fa7f31ec0ca5$var$z = !1, $6445fa7f31ec0ca5$var$A = !1, $6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$D = "function" === typeof setTimeout ? setTimeout : null, $6445fa7f31ec0ca5$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $6445fa7f31ec0ca5$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $6445fa7f31ec0ca5$var$G(a) {
    for(var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t); null !== b;){
        if (null === b.callback) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t);
        else if (b.startTime <= a) $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$t), b.sortIndex = b.expirationTime, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, b);
        else break;
        b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
    }
}
function $6445fa7f31ec0ca5$var$H(a) {
    $6445fa7f31ec0ca5$var$B = !1;
    $6445fa7f31ec0ca5$var$G(a);
    if (!$6445fa7f31ec0ca5$var$A) {
        if (null !== $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r)) $6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J);
        else {
            var b = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== b && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, b.startTime - a);
        }
    }
}
function $6445fa7f31ec0ca5$var$J(a, b) {
    $6445fa7f31ec0ca5$var$A = !1;
    $6445fa7f31ec0ca5$var$B && ($6445fa7f31ec0ca5$var$B = !1, $6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1);
    $6445fa7f31ec0ca5$var$z = !0;
    var c = $6445fa7f31ec0ca5$var$y;
    try {
        $6445fa7f31ec0ca5$var$G(b);
        for($6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r); null !== $6445fa7f31ec0ca5$var$v && (!($6445fa7f31ec0ca5$var$v.expirationTime > b) || a && !$6445fa7f31ec0ca5$var$M());){
            var d = $6445fa7f31ec0ca5$var$v.callback;
            if ("function" === typeof d) {
                $6445fa7f31ec0ca5$var$v.callback = null;
                $6445fa7f31ec0ca5$var$y = $6445fa7f31ec0ca5$var$v.priorityLevel;
                var e = d($6445fa7f31ec0ca5$var$v.expirationTime <= b);
                b = $6445fa7f31ec0ca5$export$c4744153514ff05d();
                "function" === typeof e ? $6445fa7f31ec0ca5$var$v.callback = e : $6445fa7f31ec0ca5$var$v === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
                $6445fa7f31ec0ca5$var$G(b);
            } else $6445fa7f31ec0ca5$var$k($6445fa7f31ec0ca5$var$r);
            $6445fa7f31ec0ca5$var$v = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
        }
        if (null !== $6445fa7f31ec0ca5$var$v) var w = !0;
        else {
            var m = $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t);
            null !== m && $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $6445fa7f31ec0ca5$var$v = null, $6445fa7f31ec0ca5$var$y = c, $6445fa7f31ec0ca5$var$z = !1;
    }
}
var $6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null, $6445fa7f31ec0ca5$var$L = -1, $6445fa7f31ec0ca5$var$P = 5, $6445fa7f31ec0ca5$var$Q = -1;
function $6445fa7f31ec0ca5$var$M() {
    return $6445fa7f31ec0ca5$export$c4744153514ff05d() - $6445fa7f31ec0ca5$var$Q < $6445fa7f31ec0ca5$var$P ? !1 : !0;
}
function $6445fa7f31ec0ca5$var$R() {
    if (null !== $6445fa7f31ec0ca5$var$O) {
        var a = $6445fa7f31ec0ca5$export$c4744153514ff05d();
        $6445fa7f31ec0ca5$var$Q = a;
        var b = !0;
        try {
            b = $6445fa7f31ec0ca5$var$O(!0, a);
        } finally{
            b ? $6445fa7f31ec0ca5$var$S() : ($6445fa7f31ec0ca5$var$N = !1, $6445fa7f31ec0ca5$var$O = null);
        }
    } else $6445fa7f31ec0ca5$var$N = !1;
}
var $6445fa7f31ec0ca5$var$S;
if ("function" === typeof $6445fa7f31ec0ca5$var$F) $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$F($6445fa7f31ec0ca5$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $6445fa7f31ec0ca5$var$T = new MessageChannel, $6445fa7f31ec0ca5$var$U = $6445fa7f31ec0ca5$var$T.port2;
    $6445fa7f31ec0ca5$var$T.port1.onmessage = $6445fa7f31ec0ca5$var$R;
    $6445fa7f31ec0ca5$var$S = function() {
        $6445fa7f31ec0ca5$var$U.postMessage(null);
    };
} else $6445fa7f31ec0ca5$var$S = function() {
    $6445fa7f31ec0ca5$var$D($6445fa7f31ec0ca5$var$R, 0);
};
function $6445fa7f31ec0ca5$var$I(a) {
    $6445fa7f31ec0ca5$var$O = a;
    $6445fa7f31ec0ca5$var$N || ($6445fa7f31ec0ca5$var$N = !0, $6445fa7f31ec0ca5$var$S());
}
function $6445fa7f31ec0ca5$var$K(a, b) {
    $6445fa7f31ec0ca5$var$L = $6445fa7f31ec0ca5$var$D(function() {
        a($6445fa7f31ec0ca5$export$c4744153514ff05d());
    }, b);
}
$6445fa7f31ec0ca5$export$3e506c1ccc9cc1a7 = 5;
$6445fa7f31ec0ca5$export$e26fe2ed2fa76875 = 1;
$6445fa7f31ec0ca5$export$502329bbf4b505b1 = 4;
$6445fa7f31ec0ca5$export$6e3807111c4874c4 = 3;
$6445fa7f31ec0ca5$export$c27134553091fb3a = null;
$6445fa7f31ec0ca5$export$33ee1acdc04fd2a2 = 2;
$6445fa7f31ec0ca5$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$6445fa7f31ec0ca5$export$8352ce38b91d0c62 = function() {
    $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J));
};
$6445fa7f31ec0ca5$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $6445fa7f31ec0ca5$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$6445fa7f31ec0ca5$export$d3dfb8e4810cb555 = function() {
    return $6445fa7f31ec0ca5$var$y;
};
$6445fa7f31ec0ca5$export$839f9183b0465a69 = function() {
    return $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r);
};
$6445fa7f31ec0ca5$export$72fdf0e06517287b = function(a) {
    switch($6445fa7f31ec0ca5$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $6445fa7f31ec0ca5$var$y;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = b;
    try {
        return a();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$4b844e58a3e414b4 = function() {};
$6445fa7f31ec0ca5$export$816d2913ae6b83b1 = function() {};
$6445fa7f31ec0ca5$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $6445fa7f31ec0ca5$var$y;
    $6445fa7f31ec0ca5$var$y = a;
    try {
        return b();
    } finally{
        $6445fa7f31ec0ca5$var$y = c;
    }
};
$6445fa7f31ec0ca5$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $6445fa7f31ec0ca5$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $6445fa7f31ec0ca5$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$t, a), null === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$r) && a === $6445fa7f31ec0ca5$var$h($6445fa7f31ec0ca5$var$t) && ($6445fa7f31ec0ca5$var$B ? ($6445fa7f31ec0ca5$var$E($6445fa7f31ec0ca5$var$L), $6445fa7f31ec0ca5$var$L = -1) : $6445fa7f31ec0ca5$var$B = !0, $6445fa7f31ec0ca5$var$K($6445fa7f31ec0ca5$var$H, c - d))) : (a.sortIndex = e, $6445fa7f31ec0ca5$var$f($6445fa7f31ec0ca5$var$r, a), $6445fa7f31ec0ca5$var$A || $6445fa7f31ec0ca5$var$z || ($6445fa7f31ec0ca5$var$A = !0, $6445fa7f31ec0ca5$var$I($6445fa7f31ec0ca5$var$J)));
    return a;
};
$6445fa7f31ec0ca5$export$b5836b71941fa3ed = $6445fa7f31ec0ca5$var$M;
$6445fa7f31ec0ca5$export$cf845f2c119da08a = function(a) {
    var b = $6445fa7f31ec0ca5$var$y;
    return function() {
        var c = $6445fa7f31ec0ca5$var$y;
        $6445fa7f31ec0ca5$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $6445fa7f31ec0ca5$var$y = c;
        }
    };
};

});



var $d4dab640dcbe486c$exports = {};
"use strict";

$d4dab640dcbe486c$exports = (parcelRequire("0qhf8"));


parcelRequire("bh6RR");
var $6fc264ec92100d3a$export$882461b6382ed46c;
var $6fc264ec92100d3a$export$757ceba2d55c277e;
"use strict";
var $47cfd4084854a574$exports = {};
"use strict";
function $47cfd4084854a574$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($47cfd4084854a574$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$47cfd4084854a574$var$checkDCE();

$47cfd4084854a574$exports = (parcelRequire("foRq4"));


var $6fc264ec92100d3a$var$i;
$6fc264ec92100d3a$export$882461b6382ed46c = $47cfd4084854a574$exports.createRoot;
$6fc264ec92100d3a$export$757ceba2d55c277e = $47cfd4084854a574$exports.hydrateRoot;



parcelRequire("bh6RR");
/**
 * React Router DOM v6.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");
/**
 * React Router v6.14.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $bh6RR = parcelRequire("bh6RR");
/**
 * @remix-run/router v1.7.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $b8f852338811df1a$var$_extends() {
    $b8f852338811df1a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b8f852338811df1a$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $b8f852338811df1a$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($b8f852338811df1a$export$e19cd5f9376f8cee || ($b8f852338811df1a$export$e19cd5f9376f8cee = {}));
const $b8f852338811df1a$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $b8f852338811df1a$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $b8f852338811df1a$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $b8f852338811df1a$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $b8f852338811df1a$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $b8f852338811df1a$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $b8f852338811df1a$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $b8f852338811df1a$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $b8f852338811df1a$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $b8f852338811df1a$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $b8f852338811df1a$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $b8f852338811df1a$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $b8f852338811df1a$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $b8f852338811df1a$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $b8f852338811df1a$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $b8f852338811df1a$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $b8f852338811df1a$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $b8f852338811df1a$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $b8f852338811df1a$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($b8f852338811df1a$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let location = $b8f852338811df1a$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $b8f852338811df1a$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $b8f852338811df1a$export$fe53371bee54353d(to);
        $b8f852338811df1a$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($b8f852338811df1a$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $b8f852338811df1a$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($b8f852338811df1a$var$ResultType || ($b8f852338811df1a$var$ResultType = {}));
const $b8f852338811df1a$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $b8f852338811df1a$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $b8f852338811df1a$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $b8f852338811df1a$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($b8f852338811df1a$var$isIndexRoute(route)) {
            let indexRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $b8f852338811df1a$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $b8f852338811df1a$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $b8f852338811df1a$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $b8f852338811df1a$var$flattenRoutes(routes);
    $b8f852338811df1a$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $b8f852338811df1a$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $b8f852338811df1a$var$safelyDecodeURI(pathname));
    return matches;
}
function $b8f852338811df1a$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $b8f852338811df1a$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $b8f852338811df1a$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $b8f852338811df1a$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $b8f852338811df1a$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $b8f852338811df1a$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $b8f852338811df1a$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $b8f852338811df1a$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $b8f852338811df1a$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $b8f852338811df1a$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $b8f852338811df1a$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $b8f852338811df1a$var$paramRe = /^:\w+$/;
const $b8f852338811df1a$var$dynamicSegmentValue = 3;
const $b8f852338811df1a$var$indexRouteValue = 2;
const $b8f852338811df1a$var$emptySegmentValue = 1;
const $b8f852338811df1a$var$staticSegmentValue = 10;
const $b8f852338811df1a$var$splatPenalty = -2;
const $b8f852338811df1a$var$isSplat = (s)=>s === "*";
function $b8f852338811df1a$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($b8f852338811df1a$var$isSplat)) initialScore += $b8f852338811df1a$var$splatPenalty;
    if (index) initialScore += $b8f852338811df1a$var$indexRouteValue;
    return segments.filter((s)=>!$b8f852338811df1a$var$isSplat(s)).reduce((score, segment)=>score + ($b8f852338811df1a$var$paramRe.test(segment) ? $b8f852338811df1a$var$dynamicSegmentValue : segment === "" ? $b8f852338811df1a$var$emptySegmentValue : $b8f852338811df1a$var$staticSegmentValue), initialScore);
}
function $b8f852338811df1a$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $b8f852338811df1a$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $b8f852338811df1a$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $b8f852338811df1a$export$a5c6d149b50c1d86($b8f852338811df1a$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $b8f852338811df1a$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $b8f852338811df1a$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $b8f852338811df1a$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $b8f852338811df1a$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $b8f852338811df1a$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $b8f852338811df1a$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $b8f852338811df1a$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $b8f852338811df1a$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $b8f852338811df1a$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $b8f852338811df1a$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $b8f852338811df1a$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $b8f852338811df1a$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $b8f852338811df1a$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $b8f852338811df1a$var$normalizeSearch(search),
        hash: $b8f852338811df1a$var$normalizeHash(hash)
    };
}
function $b8f852338811df1a$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $b8f852338811df1a$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $b8f852338811df1a$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $b8f852338811df1a$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $b8f852338811df1a$export$8ccf933b0513f8d0(toArg);
    else {
        to = $b8f852338811df1a$var$_extends({}, toArg);
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $b8f852338811df1a$var$getInvalidPathError("?", "pathname", "search", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "pathname", "hash", to));
        $b8f852338811df1a$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $b8f852338811df1a$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $b8f852338811df1a$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $b8f852338811df1a$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $b8f852338811df1a$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $b8f852338811df1a$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $b8f852338811df1a$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $b8f852338811df1a$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $b8f852338811df1a$export$42a99a7a4bc0e76a extends Error {
}
class $b8f852338811df1a$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $b8f852338811df1a$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $b8f852338811df1a$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $b8f852338811df1a$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $b8f852338811df1a$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $b8f852338811df1a$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $b8f852338811df1a$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $b8f852338811df1a$var$unwrapTrackedPromise(value) {
    if (!$b8f852338811df1a$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $b8f852338811df1a$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $b8f852338811df1a$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $b8f852338811df1a$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $b8f852338811df1a$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $b8f852338811df1a$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $b8f852338811df1a$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $b8f852338811df1a$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $b8f852338811df1a$var$validMutationMethods = new Set($b8f852338811df1a$var$validMutationMethodsArr);
const $b8f852338811df1a$var$validRequestMethodsArr = [
    "get",
    ...$b8f852338811df1a$var$validMutationMethodsArr
];
const $b8f852338811df1a$var$validRequestMethods = new Set($b8f852338811df1a$var$validRequestMethodsArr);
const $b8f852338811df1a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $b8f852338811df1a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $b8f852338811df1a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $b8f852338811df1a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $b8f852338811df1a$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $b8f852338811df1a$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $b8f852338811df1a$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $b8f852338811df1a$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $b8f852338811df1a$var$_extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && // And we have to either have no loaders or have been provided hydrationData
    (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $b8f852338811df1a$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($b8f852338811df1a$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $b8f852338811df1a$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $b8f852338811df1a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $b8f852338811df1a$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $b8f852338811df1a$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $b8f852338811df1a$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        updateState($b8f852338811df1a$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $b8f852338811df1a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }));
        // Reset stateful navigation vars
        pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $b8f852338811df1a$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $b8f852338811df1a$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $b8f852338811df1a$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $b8f852338811df1a$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, location, basename);
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $b8f852338811df1a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $b8f852338811df1a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$b8f852338811df1a$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $b8f852338811df1a$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $b8f852338811df1a$var$getLoadingNavigation(location, opts.submission);
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $b8f852338811df1a$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $b8f852338811df1a$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        });
        // Call our action and get the result
        let result;
        let actionMatch = $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $b8f852338811df1a$var$ResultType.error,
            error: $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $b8f852338811df1a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($b8f852338811df1a$var$isDeferredResult(result)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $b8f852338811df1a$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $b8f852338811df1a$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $b8f852338811df1a$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($b8f852338811df1a$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $b8f852338811df1a$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $b8f852338811df1a$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $b8f852338811df1a$export$52eace9c284d3585;
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $b8f852338811df1a$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        let matches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        let { path: path, submission: submission, error: error } = $b8f852338811df1a$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error);
            return;
        }
        let match = $b8f852338811df1a$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher);
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $b8f852338811df1a$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($b8f852338811df1a$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our action started, so that
                // should take precedence over this redirect navigation.  We already
                // set isRevalidationRequired so all loaders for the new route should
                // fire unless opted out via shouldRevalidate
                let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                let loadingFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission);
                state.fetchers.set(key, loadingFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return startRedirectNavigation(state, actionResult, {
                    submission: submission,
                    isFetchActionRedirect: true
                });
            }
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($b8f852338811df1a$var$isDeferredResult(actionResult)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $b8f852338811df1a$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $b8f852338811df1a$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $b8f852338811df1a$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $b8f852338811df1a$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $b8f852338811df1a$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let didAbortFetchLoads = abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $b8f852338811df1a$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($b8f852338811df1a$var$_extends({
                errors: errors,
                loaderData: $b8f852338811df1a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key);
        // Put this fetcher into it's loading state
        let loadingFetcher = $b8f852338811df1a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined);
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $b8f852338811df1a$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $b8f852338811df1a$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($b8f852338811df1a$var$isDeferredResult(result)) result = await $b8f852338811df1a$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($b8f852338811df1a$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(undefined);
                state.fetchers.set(key, doneFetcher);
                updateState({
                    fetchers: new Map(state.fetchers)
                });
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key);
            // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(result.data);
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $b8f852338811df1a$var$createLocation(state.location, redirect.location, $b8f852338811df1a$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $b8f852338811df1a$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        // Check if this an absolute external redirect that goes to a new origin
        if ($b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser) {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) == null;
            if (routerWindow.location.origin !== url.origin || isDifferentBasename) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $b8f852338811df1a$export$e19cd5f9376f8cee.Replace : $b8f852338811df1a$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let activeSubmission = submission || $b8f852338811df1a$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($b8f852338811df1a$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $b8f852338811df1a$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $b8f852338811df1a$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: $b8f852338811df1a$var$getLoadingNavigation(redirectLocation),
            fetcherSubmission: activeSubmission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a submission, we will preserve it through the redirect navigation
            let overrideNavigation = $b8f852338811df1a$var$getLoadingNavigation(redirectLocation, activeSubmission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$b8f852338811df1a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $b8f852338811df1a$var$callLoaderOrAction("loader", $b8f852338811df1a$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                else {
                    let error = {
                        type: $b8f852338811df1a$var$ResultType.error,
                        error: $b8f852338811df1a$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $b8f852338811df1a$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $b8f852338811df1a$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $b8f852338811df1a$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $b8f852338811df1a$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $b8f852338811df1a$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $b8f852338811df1a$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $b8f852338811df1a$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $b8f852338811df1a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$b8f852338811df1a$var$createUseMatchesMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $b8f852338811df1a$export$4d0306f8f6a4585b = Symbol("deferred");
function $b8f852338811df1a$export$3336b097a6fbc59a(routes, opts) {
    $b8f852338811df1a$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $b8f852338811df1a$var$defaultMapRouteProperties;
    let dataRoutes = $b8f852338811df1a$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD") {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $b8f852338811df1a$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $b8f852338811df1a$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $b8f852338811df1a$var$createLocation("", $b8f852338811df1a$export$fe53371bee54353d(url), null, "default");
        let matches = $b8f852338811df1a$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$b8f852338811df1a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $b8f852338811df1a$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $b8f852338811df1a$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $b8f852338811df1a$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $b8f852338811df1a$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($b8f852338811df1a$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$b8f852338811df1a$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $b8f852338811df1a$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($b8f852338811df1a$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $b8f852338811df1a$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $b8f852338811df1a$var$isResponse(result) ? result : $b8f852338811df1a$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($b8f852338811df1a$var$isQueryRouteResponse(e)) {
                if (e.type === $b8f852338811df1a$var$ResultType.error && !$b8f852338811df1a$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($b8f852338811df1a$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $b8f852338811df1a$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        } else {
            result = await $b8f852338811df1a$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($b8f852338811df1a$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($b8f852338811df1a$var$isDeferredResult(result)) {
            let error = $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $b8f852338811df1a$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($b8f852338811df1a$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $b8f852338811df1a$var$_extends({}, context, {
                statusCode: $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $b8f852338811df1a$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $b8f852338811df1a$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $b8f852338811df1a$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$b8f852338811df1a$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        }
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $b8f852338811df1a$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $b8f852338811df1a$export$fec11da027c70692(routes, context, error) {
    let newContext = $b8f852338811df1a$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $b8f852338811df1a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $b8f852338811df1a$var$normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $b8f852338811df1a$export$cae722b0cc860f13(to ? to : ".", $b8f852338811df1a$export$90ba53ce1c7fdff2(contextualMatches).map((m)=>m.pathnameBase), $b8f852338811df1a$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$b8f852338811df1a$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $b8f852338811df1a$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $b8f852338811df1a$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $b8f852338811df1a$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$b8f852338811df1a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$b8f852338811df1a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $b8f852338811df1a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $b8f852338811df1a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $b8f852338811df1a$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$b8f852338811df1a$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $b8f852338811df1a$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $b8f852338811df1a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($b8f852338811df1a$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $b8f852338811df1a$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $b8f852338811df1a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $b8f852338811df1a$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $b8f852338811df1a$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $b8f852338811df1a$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
        // Always call the loader on new route instances and pending defer cancellations
        if ($b8f852338811df1a$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $b8f852338811df1a$var$shouldRevalidateLoader(match, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $b8f852338811df1a$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $b8f852338811df1a$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $b8f852338811df1a$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $b8f852338811df1a$var$shouldRevalidateLoader(fetcherMatch, $b8f852338811df1a$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $b8f852338811df1a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $b8f852338811df1a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $b8f852338811df1a$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $b8f852338811df1a$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $b8f852338811df1a$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$b8f852338811df1a$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $b8f852338811df1a$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $b8f852338811df1a$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $b8f852338811df1a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $b8f852338811df1a$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $b8f852338811df1a$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $b8f852338811df1a$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $b8f852338811df1a$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $b8f852338811df1a$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $b8f852338811df1a$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($b8f852338811df1a$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($b8f852338811df1a$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $b8f852338811df1a$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$b8f852338811df1a$var$ABSOLUTE_URL_REGEX.test(location)) location = $b8f852338811df1a$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $b8f852338811df1a$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $b8f852338811df1a$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $b8f852338811df1a$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type");
        // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $b8f852338811df1a$var$ResultType.error) return {
            type: resultType,
            error: new $b8f852338811df1a$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $b8f852338811df1a$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($b8f852338811df1a$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $b8f852338811df1a$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $b8f852338811df1a$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($b8f852338811df1a$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $b8f852338811df1a$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $b8f852338811df1a$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $b8f852338811df1a$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $b8f852338811df1a$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $b8f852338811df1a$export$3e9cee6b33872309(!$b8f852338811df1a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($b8f852338811df1a$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $b8f852338811df1a$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($b8f852338811df1a$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $b8f852338811df1a$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $b8f852338811df1a$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $b8f852338811df1a$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($b8f852338811df1a$var$isErrorResult(result)) {
            let boundaryMatch = $b8f852338811df1a$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $b8f852338811df1a$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($b8f852338811df1a$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($b8f852338811df1a$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $b8f852338811df1a$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $b8f852338811df1a$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $b8f852338811df1a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $b8f852338811df1a$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $b8f852338811df1a$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $b8f852338811df1a$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $b8f852338811df1a$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $b8f852338811df1a$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $b8f852338811df1a$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($b8f852338811df1a$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $b8f852338811df1a$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(path) : path;
    return $b8f852338811df1a$export$fe53371bee54353d($b8f852338811df1a$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $b8f852338811df1a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $b8f852338811df1a$var$isDeferredResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.deferred;
}
function $b8f852338811df1a$var$isErrorResult(result) {
    return result.type === $b8f852338811df1a$var$ResultType.error;
}
function $b8f852338811df1a$var$isRedirectResult(result) {
    return (result && result.type) === $b8f852338811df1a$var$ResultType.redirect;
}
function $b8f852338811df1a$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $b8f852338811df1a$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $b8f852338811df1a$var$isRedirectResponse(result) {
    if (!$b8f852338811df1a$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $b8f852338811df1a$var$isQueryRouteResponse(obj) {
    return obj && $b8f852338811df1a$var$isResponse(obj.response) && (obj.type === $b8f852338811df1a$var$ResultType.data || $b8f852338811df1a$var$ResultType.error);
}
function $b8f852338811df1a$var$isValidMethod(method) {
    return $b8f852338811df1a$var$validRequestMethods.has(method.toLowerCase());
}
function $b8f852338811df1a$var$isMutationMethod(method) {
    return $b8f852338811df1a$var$validMutationMethods.has(method.toLowerCase());
}
async function $b8f852338811df1a$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$b8f852338811df1a$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($b8f852338811df1a$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $b8f852338811df1a$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $b8f852338811df1a$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $b8f852338811df1a$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $b8f852338811df1a$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $b8f852338811df1a$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $b8f852338811df1a$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $b8f852338811df1a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
// Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $b8f852338811df1a$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $b8f852338811df1a$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $b8f852338811df1a$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $b8f852338811df1a$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $b8f852338811df1a$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
}
function $b8f852338811df1a$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $b8f852338811df1a$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $b8f852338811df1a$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $b8f852338811df1a$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data,
            " _hasFetcherDoneAnything ": true
        };
        return fetcher;
    }
}
function $b8f852338811df1a$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}
function $b8f852338811df1a$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data,
        " _hasFetcherDoneAnything ": true
    };
    return fetcher;
}


function $6a9dcc96d11bcd0d$var$_extends() {
    $6a9dcc96d11bcd0d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $6a9dcc96d11bcd0d$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $6a9dcc96d11bcd0d$export$3add0d5dce533e2e = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$145dfa71566a64dc = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$var$AwaitContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level <Router> API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $6a9dcc96d11bcd0d$export$26749e8557646306 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$c7914228fb69b0f5 = /*#__PURE__*/ $bh6RR.createContext(null);
const $6a9dcc96d11bcd0d$export$9072aa6dd1f93057 = /*#__PURE__*/ $bh6RR.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $6a9dcc96d11bcd0d$var$RouteErrorContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $6a9dcc96d11bcd0d$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $6a9dcc96d11bcd0d$export$45d76561a5302f2b() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $6a9dcc96d11bcd0d$export$1b3f31771c5d07c() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $6a9dcc96d11bcd0d$export$6c330e8992e8a295(pattern) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    return $bh6RR.useMemo(()=>(0, $b8f852338811df1a$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $6a9dcc96d11bcd0d$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $bh6RR.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $6a9dcc96d11bcd0d$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $6a9dcc96d11bcd0d$var$useNavigateStable() : $6a9dcc96d11bcd0d$var$useNavigateUnstable();
}
function $6a9dcc96d11bcd0d$var$useNavigateUnstable() {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    let { basename: basename, navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $b8f852338811df1a$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $b8f852338811df1a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$OutletContext = /*#__PURE__*/ $bh6RR.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $6a9dcc96d11bcd0d$export$4138103a3ae699cc() {
    return $bh6RR.useContext($6a9dcc96d11bcd0d$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(context) {
    let outlet = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $6a9dcc96d11bcd0d$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $b8f852338811df1a$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase));
    return $bh6RR.useMemo(()=>(0, $b8f852338811df1a$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $6a9dcc96d11bcd0d$export$5d3fca4a98652595(routes, locationArg) {
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, locationArg, dataRouterState) {
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$26749e8557646306);
    let { matches: parentMatches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $b8f852338811df1a$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $b8f852338811df1a$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $6a9dcc96d11bcd0d$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $b8f852338811df1a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $6a9dcc96d11bcd0d$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $b8f852338811df1a$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $6a9dcc96d11bcd0d$var$DefaultErrorComponent() {
    let error = $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2();
    let message = (0, $b8f852338811df1a$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $bh6RR.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $bh6RR.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $6a9dcc96d11bcd0d$var$defaultErrorElement = /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DefaultErrorComponent, null);
class $6a9dcc96d11bcd0d$var$RenderErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $6a9dcc96d11bcd0d$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $6a9dcc96d11bcd0d$var$_renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null;
        // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || $6a9dcc96d11bcd0d$var$defaultErrorElement;
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $bh6RR.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $6a9dcc96d11bcd0d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})($6a9dcc96d11bcd0d$var$DataRouterHook || ($6a9dcc96d11bcd0d$var$DataRouterHook = {}));
var $6a9dcc96d11bcd0d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})($6a9dcc96d11bcd0d$var$DataRouterStateHook || ($6a9dcc96d11bcd0d$var$DataRouterStateHook = {}));
function $6a9dcc96d11bcd0d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $6a9dcc96d11bcd0d$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext($6a9dcc96d11bcd0d$export$3add0d5dce533e2e);
    !ctx && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $6a9dcc96d11bcd0d$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext($6a9dcc96d11bcd0d$export$145dfa71566a64dc);
    !state && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return state;
}
function $6a9dcc96d11bcd0d$var$useRouteContext(hookName) {
    let route = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    !route && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $6a9dcc96d11bcd0d$var$useCurrentRouteId(hookName) {
    let route = $6a9dcc96d11bcd0d$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $6a9dcc96d11bcd0d$export$5fc8298006ad9e58() {
    return $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $6a9dcc96d11bcd0d$export$d0fd4b7106de2769() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $6a9dcc96d11bcd0d$export$600dc272ed516c15() {
    let dataRouterContext = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseRevalidator);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $6a9dcc96d11bcd0d$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseMatches);
    return $bh6RR.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match;
            // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $6a9dcc96d11bcd0d$export$1448a5050d252c4d() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $6a9dcc96d11bcd0d$export$fd5d37484eab868d(routeId) {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $6a9dcc96d11bcd0d$export$fdc00f3f26066d5e() {
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseActionData);
    let route = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    !route && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $6a9dcc96d11bcd0d$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $bh6RR.useContext($6a9dcc96d11bcd0d$var$RouteErrorContext);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    let routeId = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $6a9dcc96d11bcd0d$export$78a72ddb39bdd145() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $6a9dcc96d11bcd0d$export$17f53340677d5831() {
    let value = $bh6RR.useContext($6a9dcc96d11bcd0d$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $6a9dcc96d11bcd0d$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $6a9dcc96d11bcd0d$export$2af03a1de5c0910(shouldBlock) {
    let { router: router, basename: basename } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseBlocker);
    let state = $6a9dcc96d11bcd0d$var$useDataRouterState($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $bh6RR.useState("");
    let blockerFunction = $bh6RR.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $6a9dcc96d11bcd0d$var$_extends({}, currentLocation, {
                pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $6a9dcc96d11bcd0d$var$_extends({}, nextLocation, {
                pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $bh6RR.useEffect(()=>{
        let key = String(++$6a9dcc96d11bcd0d$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $bh6RR.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $b8f852338811df1a$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $6a9dcc96d11bcd0d$var$useNavigateStable() {
    let { router: router } = $6a9dcc96d11bcd0d$var$useDataRouterContext($6a9dcc96d11bcd0d$var$DataRouterHook.UseNavigateStable);
    let id = $6a9dcc96d11bcd0d$var$useCurrentRouteId($6a9dcc96d11bcd0d$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $bh6RR.useRef(false);
    $6a9dcc96d11bcd0d$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $bh6RR.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $6a9dcc96d11bcd0d$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $6a9dcc96d11bcd0d$var$alreadyWarned = {};
function $6a9dcc96d11bcd0d$var$warningOnce(key, cond, message) {
    if (!cond && !$6a9dcc96d11bcd0d$var$alreadyWarned[key]) $6a9dcc96d11bcd0d$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $6a9dcc96d11bcd0d$var$START_TRANSITION = "startTransition";
const $6a9dcc96d11bcd0d$var$startTransitionImpl = $bh6RR[$6a9dcc96d11bcd0d$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $6a9dcc96d11bcd0d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    let [state, setStateImpl] = $bh6RR.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl ? $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    let navigator = $bh6RR.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $bh6RR.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator
    }, state.initialized ? /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function $6a9dcc96d11bcd0d$var$DataRoutes(_ref2) {
    let { routes: routes, state: state } = _ref2;
    return $6a9dcc96d11bcd0d$export$5fcee62552a12fbf(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $6a9dcc96d11bcd0d$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $6a9dcc96d11bcd0d$var$startTransitionImpl ? $6a9dcc96d11bcd0d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $6a9dcc96d11bcd0d$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let { matches: matches } = $bh6RR.useContext($6a9dcc96d11bcd0d$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $6a9dcc96d11bcd0d$export$45d76561a5302f2b();
    let navigate = $6a9dcc96d11bcd0d$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $b8f852338811df1a$export$cae722b0cc860f13)(to, (0, $b8f852338811df1a$export$90ba53ce1c7fdff2)(matches).map((match)=>match.pathnameBase), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $bh6RR.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $6a9dcc96d11bcd0d$export$910ae8079b2c2852(props) {
    return $6a9dcc96d11bcd0d$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6(_props) {
    (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $6a9dcc96d11bcd0d$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $b8f852338811df1a$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false } = _ref5;
    !!$6a9dcc96d11bcd0d$export$9c954a9d03d32f4a() && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $bh6RR.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $b8f852338811df1a$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $bh6RR.useMemo(()=>{
        let trailingPathname = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $6a9dcc96d11bcd0d$export$5d3fca4a98652595($6a9dcc96d11bcd0d$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $6a9dcc96d11bcd0d$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$ResolveAwait, null, children));
}
var $6a9dcc96d11bcd0d$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($6a9dcc96d11bcd0d$var$AwaitRenderStatus || ($6a9dcc96d11bcd0d$var$AwaitRenderStatus = {}));
const $6a9dcc96d11bcd0d$var$neverSettledPromise = new Promise(()=>{});
class $6a9dcc96d11bcd0d$var$AwaitErrorBoundary extends $bh6RR.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error : promise._data !== undefined ? $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success : $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $6a9dcc96d11bcd0d$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && promise._error instanceof (0, $b8f852338811df1a$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $6a9dcc96d11bcd0d$var$neverSettledPromise;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $6a9dcc96d11bcd0d$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $bh6RR.createElement($6a9dcc96d11bcd0d$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $6a9dcc96d11bcd0d$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $6a9dcc96d11bcd0d$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $bh6RR.createElement($bh6RR.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $6a9dcc96d11bcd0d$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $bh6RR.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $bh6RR.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $bh6RR.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $6a9dcc96d11bcd0d$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $6a9dcc96d11bcd0d$export$daf73786167a7f72(matches) {
    return $6a9dcc96d11bcd0d$var$_renderMatches(matches);
}
function $6a9dcc96d11bcd0d$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $bh6RR.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $bh6RR.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $6a9dcc96d11bcd0d$export$f30f7e456d254e83(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $6a9dcc96d11bcd0d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $6a9dcc96d11bcd0d$export$52b333d321859367
    }).initialize();
}



function $0bd3411f2ec14e23$var$_extends() {
    $0bd3411f2ec14e23$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0bd3411f2ec14e23$var$_extends.apply(this, arguments);
}
function $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $0bd3411f2ec14e23$var$defaultMethod = "get";
const $0bd3411f2ec14e23$var$defaultEncType = "application/x-www-form-urlencoded";
function $0bd3411f2ec14e23$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $0bd3411f2ec14e23$var$isButtonElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $0bd3411f2ec14e23$var$isFormElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $0bd3411f2ec14e23$var$isInputElement(object) {
    return $0bd3411f2ec14e23$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $0bd3411f2ec14e23$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$0bd3411f2ec14e23$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $0bd3411f2ec14e23$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
// One-time check for submitter support
let $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = null;
function $0bd3411f2ec14e23$var$isFormDataSubmitterSupported() {
    if ($0bd3411f2ec14e23$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $0bd3411f2ec14e23$var$_formDataSupportsSubmitter = true;
    }
    return $0bd3411f2ec14e23$var$_formDataSupportsSubmitter;
}
const $0bd3411f2ec14e23$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $0bd3411f2ec14e23$var$getFormEncType(encType) {
    if (encType != null && !$0bd3411f2ec14e23$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($0bd3411f2ec14e23$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $b8f852338811df1a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        formData = new FormData(target);
    } else if ($0bd3411f2ec14e23$var$isButtonElement(target) || $0bd3411f2ec14e23$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $b8f852338811df1a$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $0bd3411f2ec14e23$var$defaultMethod;
        encType = $0bd3411f2ec14e23$var$getFormEncType(target.getAttribute("formenctype")) || $0bd3411f2ec14e23$var$getFormEncType(form.getAttribute("enctype")) || $0bd3411f2ec14e23$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$0bd3411f2ec14e23$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($0bd3411f2ec14e23$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $0bd3411f2ec14e23$var$defaultMethod;
        action = null;
        encType = $0bd3411f2ec14e23$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $0bd3411f2ec14e23$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $0bd3411f2ec14e23$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $0bd3411f2ec14e23$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "submit",
    "relative",
    "preventScrollReset"
];
function $0bd3411f2ec14e23$export$1f3f55432a00e06d(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6a9dcc96d11bcd0d$export$52b333d321859367)
    }).initialize();
}
function $0bd3411f2ec14e23$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $b8f852338811df1a$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $0bd3411f2ec14e23$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $b8f852338811df1a$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $0bd3411f2ec14e23$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $6a9dcc96d11bcd0d$export$52b333d321859367)
    }).initialize();
}
function $0bd3411f2ec14e23$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $0bd3411f2ec14e23$var$_extends({}, state, {
        errors: $0bd3411f2ec14e23$var$deserializeErrors(state.errors)
    });
    return state;
}
function $0bd3411f2ec14e23$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $b8f852338811df1a$export$acf1a680051f5031)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $0bd3411f2ec14e23$var$START_TRANSITION = "startTransition";
const $0bd3411f2ec14e23$var$startTransitionImpl = $bh6RR[$0bd3411f2ec14e23$var$START_TRANSITION];
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $0bd3411f2ec14e23$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref2;
    let historyRef = $bh6RR.useRef();
    if (historyRef.current == null) historyRef.current = (0, $b8f852338811df1a$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $0bd3411f2ec14e23$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, future: future, history: history } = _ref3;
    let [state, setStateImpl] = $bh6RR.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $bh6RR.useCallback((newState)=>{
        v7_startTransition && $0bd3411f2ec14e23$var$startTransitionImpl ? $0bd3411f2ec14e23$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $bh6RR.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $bh6RR.createElement((0, $6a9dcc96d11bcd0d$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $0bd3411f2ec14e23$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $0bd3411f2ec14e23$export$a6c7ac8248d6e38a = /*#__PURE__*/ $bh6RR.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref4, $0bd3411f2ec14e23$var$_excluded);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $0bd3411f2ec14e23$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($0bd3411f2ec14e23$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $b8f852338811df1a$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $6a9dcc96d11bcd0d$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $0bd3411f2ec14e23$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $bh6RR.createElement("a", $0bd3411f2ec14e23$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $0bd3411f2ec14e23$export$b0d92dbee9b5b60d = /*#__PURE__*/ $bh6RR.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref5, $0bd3411f2ec14e23$var$_excluded2);
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let routerState = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc));
    let { navigator: navigator } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$export$a6c7ac8248d6e38a, $0bd3411f2ec14e23$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $0bd3411f2ec14e23$export$a7fed597f4b8afd8 = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
    let submit = $0bd3411f2ec14e23$export$47c85c6e3a081d3();
    return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$var$FormImpl, $0bd3411f2ec14e23$var$_extends({}, props, {
        submit: submit,
        ref: ref
    }));
});
const $0bd3411f2ec14e23$var$FormImpl = /*#__PURE__*/ $bh6RR.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, state: state, method: method = $0bd3411f2ec14e23$var$defaultMethod, action: action, onSubmit: onSubmit, submit: submit, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $0bd3411f2ec14e23$var$_objectWithoutPropertiesLoose(_ref6, $0bd3411f2ec14e23$var$_excluded3);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $bh6RR.createElement("form", $0bd3411f2ec14e23$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $0bd3411f2ec14e23$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $0bd3411f2ec14e23$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $0bd3411f2ec14e23$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($0bd3411f2ec14e23$var$DataRouterHook || ($0bd3411f2ec14e23$var$DataRouterHook = {}));
var $0bd3411f2ec14e23$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($0bd3411f2ec14e23$var$DataRouterStateHook || ($0bd3411f2ec14e23$var$DataRouterStateHook = {}));
function $0bd3411f2ec14e23$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $0bd3411f2ec14e23$var$useDataRouterContext(hookName) {
    let ctx = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$3add0d5dce533e2e));
    !ctx && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return ctx;
}
function $0bd3411f2ec14e23$var$useDataRouterState(hookName) {
    let state = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$145dfa71566a64dc));
    !state && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $0bd3411f2ec14e23$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let path = (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $bh6RR.useCallback((event)=>{
        if ($0bd3411f2ec14e23$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $b8f852338811df1a$export$fe53371bee54353d)(location) === (0, $b8f852338811df1a$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $0bd3411f2ec14e23$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $bh6RR.useRef($0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $bh6RR.useRef(false);
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let searchParams = $bh6RR.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $0bd3411f2ec14e23$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $6a9dcc96d11bcd0d$export$9770f232ac06a008)();
    let setSearchParams = $bh6RR.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $0bd3411f2ec14e23$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $0bd3411f2ec14e23$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $0bd3411f2ec14e23$export$47c85c6e3a081d3() {
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let currentRouteId = (0, $6a9dcc96d11bcd0d$export$5fc8298006ad9e58)();
    return $bh6RR.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0bd3411f2ec14e23$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename);
        router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
/**
 * Returns the implementation for fetcher.submit
 */ function $0bd3411f2ec14e23$var$useSubmitFetcher(fetcherKey, fetcherRouteId) {
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseSubmitFetcher);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    return $bh6RR.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $0bd3411f2ec14e23$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $0bd3411f2ec14e23$var$getFormSubmissionInfo(target, basename);
        !(fetcherRouteId != null) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, fetcherRouteId, options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType
        });
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $0bd3411f2ec14e23$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let routeContext = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$9072aa6dd1f93057));
    !routeContext && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $0bd3411f2ec14e23$var$_extends({}, (0, $6a9dcc96d11bcd0d$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash;
        // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $b8f852338811df1a$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $b8f852338811df1a$export$fe53371bee54353d)(path);
}
function $0bd3411f2ec14e23$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $bh6RR.forwardRef((props, ref)=>{
        let submit = $0bd3411f2ec14e23$var$useSubmitFetcher(fetcherKey, routeId);
        return /*#__PURE__*/ $bh6RR.createElement($0bd3411f2ec14e23$var$FormImpl, $0bd3411f2ec14e23$var$_extends({}, props, {
            ref: ref,
            submit: submit
        }));
    });
    return FetcherForm;
}
let $0bd3411f2ec14e23$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $0bd3411f2ec14e23$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseFetcher);
    let route = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$9072aa6dd1f93057));
    !route && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
    let [fetcherKey] = $bh6RR.useState(()=>String(++$0bd3411f2ec14e23$var$fetcherId));
    let [Form] = $bh6RR.useState(()=>{
        !routeId && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
        return $0bd3411f2ec14e23$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $bh6RR.useState(()=>(href)=>{
            !router && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
            !routeId && (0, $b8f852338811df1a$export$3e9cee6b33872309)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $0bd3411f2ec14e23$var$useSubmitFetcher(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $bh6RR.useMemo(()=>$0bd3411f2ec14e23$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $bh6RR.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $0bd3411f2ec14e23$export$fa996778a3a31087() {
    let state = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $0bd3411f2ec14e23$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $0bd3411f2ec14e23$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $0bd3411f2ec14e23$var$useDataRouterContext($0bd3411f2ec14e23$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $0bd3411f2ec14e23$var$useDataRouterState($0bd3411f2ec14e23$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $bh6RR.useContext((0, $6a9dcc96d11bcd0d$export$26749e8557646306));
    let location = (0, $6a9dcc96d11bcd0d$export$45d76561a5302f2b)();
    let matches = (0, $6a9dcc96d11bcd0d$export$2378eb7f5ff86053)();
    let navigation = (0, $6a9dcc96d11bcd0d$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $bh6RR.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $0bd3411f2ec14e23$var$usePageHide($bh6RR.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $0bd3411f2ec14e23$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($0bd3411f2ec14e23$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $0bd3411f2ec14e23$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $0bd3411f2ec14e23$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($0bd3411f2ec14e23$var$_extends({}, location, {
                    pathname: (0, $b8f852338811df1a$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($0bd3411f2ec14e23$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $bh6RR.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $0bd3411f2ec14e23$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $bh6RR.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $0bd3411f2ec14e23$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $6a9dcc96d11bcd0d$export$2af03a1de5c0910)(when);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $bh6RR.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}



parcelRequire("bh6RR");

parcelRequire("bh6RR");
const $e61a2220d08bc5b0$export$182d03b4b654e012 = ({ className: className, fill: fill = "none", width: width = 50, stroke: stroke = "none" })=>{
    return (0, $d4dab640dcbe486c$exports.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        className: className,
        xmlSpace: "preserve",
        role: "img",
        "aria-labelledby": "logoTitle logoDesc",
        width: width,
        stroke: stroke,
        strokeWidth: 0,
        viewBox: "0 0 2076.79 850.61",
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("title", {
                id: "logoTitle",
                children: "Pinbaile Logo"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("desc", {
                id: "logoDesc",
                children: "A text logo influenced by Irish typefaces with a modern twist"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m1555.94,317.5c-4.42,0-8,3.58-8,8v255c0,4.42,3.58,8,8,8s8-3.58,8-8v-255c0-4.42-3.58-8-8-8Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m345.64,346.53c-3.95-12.88-11.39-24.51-19.92-35.5-8.12-10.47-17.22-20.35-25.22-30.18-12.79-15.72-25.58-31.45-38.37-47.17l-.2-.24-101,55-30-55-82,43,30,55v463.07l94-46.07v-156l72.24-6.88c9.34-.89,18.48-3.37,26.96-7.4,35.88-17.05,56.35-44.01,67.78-71.95.41-.76.83-1.56,1.25-2.4,11.89-23.47,14.74-50.46,14.29-76.43-.45-26.28-2.11-55.67-9.83-80.86Zm-172.7,200.9v-223l66-35c46.06,53.47,53.07,106.08,55.69,121.89.41,2.44.62,4.91.58,7.38-1.83,139.69-122.28,128.73-122.28,128.73Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
                fill: fill,
                points: "353.44 276.43 382.44 332.43 382.44 632.43 477.44 632.43 477.44 313.43 434.44 233.43 353.44 276.43"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m683.94,236.5c-34.44.77-66.19,42.89-71.4,49.26l-29.6-54.26-82,43,30,55v302.93h94v-219.63c0-9.71.23-20.59,0-30.3-1-42,8.63-63.04,35-79,38-23,73,15,63,187-8.88,152.79-61,225-61,225,80-36,138-128.86,138-260,0-144-26-221-116-219Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m1107.94,452.5c.04-2.28-95-184-95-184l-91.49,48,.49-169-43-80-82,43,30,55v466.93h82.7c4.17.05,8.33-.55,12.32-1.76l31.97-12.17,128-91,26-75Zm-169,100h-18v-80l.46-128.83,23.54,44.83,35-19,53,110-94,73Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("polygon", {
                fill: fill,
                points: "1407.94 276.43 1436.94 332.43 1436.94 632.43 1531.94 632.43 1531.94 313.43 1488.94 233.43 1407.94 276.43"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m1750.92,563.63c-5.59,4.52-29.89,19.8-45.98,23.73-8.96,2.19-19.57,3.93-26.26-3.98-8.18-9.69-5.69-29.19-5.54-41.02.89-70.18.31-140.38.31-210.57v-34.43l.49-169-43-80-82,43,30,55v389.91c0,.7.03,1.38.05,2.07,0,0-1.05,42.01,10.95,67.01,11.23,18.66,41,28,64,27,29.38,0,95.19-35.48,97.91-67.94.06-.69.09-1.63-.93-.8Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m1893.11,571.3c-19.02,0-32.72-6.69-44.41-21.69-38.25-49.08-37.05-65.29-34.76-69.98,1.62-3.32,6.03-5,13.1-5,.29,0,.59,0,.89,0,5.42.11,11.11.22,16.94.34,26.93.55,57.46,1.17,75.39,1.17,6.99,0,19.82-7.98,38.12-23.72,6.38-5.49,12.89-11.52,17.86-16.55,8.36-8.46,8.98-10.47,8.98-12.57,0-1.49-.63-2.92-1.72-3.9-.97-.87-2.23-1.35-3.56-1.35-1.6,0-11.45-.29-23.93-.66-28.67-.85-76.65-2.27-95.63-2.27-7.19,0-34.65.23-47.46.34.53-1.92,1.04-3.83,1.33-5.02,3.46-14.18,9.54-28.75,15.79-41.91,6.86-14.44,16.28-30.53,34.21-30.81,7.48-.12,14.82,2.3,21.42,5.82,6.6,3.52,33.94,24.62,41.58,30.52,3.9,3.01,7.8,6.02,11.7,9.03,3.16,2.44,6.86,4.73,9.78,7.52.48.46,1.22.52,1.75.1,5.37-4.2,11.06-8.13,16.56-12.19,9.06-6.68,18.11-13.36,27.17-20.04,1.63-1.2,3.26-2.4,4.89-3.61.38-.28.43-.82.12-1.16-.64-.71-1.66-1.82-2.27-2.49-11.09-12.08-22.46-23.95-34.12-35.48-19.74-19.52-41.43-37.66-70.98-34.7-11.32,1.14-22.26,4.67-32.86,8.8-39.34,15.32-71.64,40.27-92.2,77.57-10.67,19.36-18.04,40.42-23.12,61.88-6.23,26.32-6.28,53.49-.64,80.01,3.33,15.63,8.65,30.85,15.98,45.07,18.32,35.52,50.67,65.22,90.21,74.77,6.14,1.48,12.42,2.37,18.73,2.65,22.4.98,45.92-4.9,66.56-13.3,16.37-6.67,31.75-15.87,45.05-27.54.63-.55,1.25-1.11,1.87-1.67,21.7-19.71,29.79-38.67,30.13-39.46l4.22-10.08-10.39,3.4c-.52.17-52.01,16.99-67.66,20.9-17.5,4.37-31.78,7.29-44.62,7.29Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m272.58,412.81c-2.44-15.02-8.14-50.2-35.3-89.59-2.31-3.34-6.75-4.43-10.33-2.53l-27.76,14.72c-2.62,1.39-4.25,4.11-4.25,7.07v172.48c0,2.45,1.12,4.76,3.04,6.27,1.43,1.13,3.18,1.73,4.96,1.73.61,0,1.23-.07,1.84-.21,30.69-7.26,67.48-31.25,68.44-104.33.01-1.08-.08-2.25-.29-3.47l-.35-2.14Zm-61.64,91.37v-156.88l17.11-9.07c21.75,34.01,26.6,63.95,28.75,77.16l.35,2.17c.07.44.07.65.07.66-.6,45.66-16.15,74.52-46.28,85.97Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m1232.32,470.09l-3.21-8.61c-1.17-3.15-4.15-5.21-7.54-5.21-3.36.02-6.35,2.13-7.48,5.29l-10.44,29.06c-.14.39-.25.78-.33,1.18l-2.01,10.37c-.93,4.8,3.45,11.21,5.77,15.19,2.93,5.03,6.42,9.73,10.41,13.97,4.88,5.19,10.74,9.82,17.67,11.5,7.35,1.78,23.46-1.65,19.44-12.51-8.02-21.68-21.85-59.07-22.28-60.23Zm2.8,55.5c-5.83-3.25-10.15-9.02-13.41-14.7-3.01-5.23-4.94-9.49-2.8-15.44,0,0,2.83-7.86,2.83-7.86,4.69,12.67,10.5,25.42,14.15,38.41-.26-.13-.51-.27-.77-.41Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m1867.04,358.81c-.76-.21-1.54-.31-2.3-.31-2.37,0-4.67.98-6.32,2.78-2.94,3.2-6.11,8.24-9.43,14.97-.92,1.87-1.87,3.91-2.81,6.04-1.18,2.66-.92,5.74.67,8.18,1.59,2.42,4.29,3.88,7.18,3.88h.04c2.21-.01,4.02-.02,5.27-.02,7.27,0,19.18.19,35.41.58.07,0,.14,0,.2,0,3.58,0,6.79-2.22,8.04-5.58,1.28-3.43.25-7.29-2.57-9.62-17.43-14.44-27.78-19.33-33.39-20.89Zm-7.67,23.51c.13-.26.25-.52.38-.78,2.63-5.34,4.71-8.58,6.12-10.47,3.33,1.3,9.39,4.38,18.99,11.6-11.21-.23-19.76-.35-25.5-.35Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m969.04,403.28c-2.08-.67-4.35-.46-6.27.58l-15.45,8.39c-2.57,1.39-4.17,4.08-4.18,7l-.19,53.31v32.65c0,3.05,1.74,5.84,4.48,7.19,1.12.55,2.32.81,3.52.81,1.74,0,3.48-.57,4.91-1.68l44.45-34.52c2.98-2.31,3.94-6.39,2.3-9.79l-28.81-59.79c-.95-1.97-2.67-3.47-4.75-4.14Zm-10.1,85.58v-16.27l.17-48.54,3.9-2.12,22.36,46.4-26.44,20.53Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m2074.67,485.41c-2.12-2.3-5.39-3.15-8.37-2.18l-72.74,23.77c-13.05,4.27-53.01,17.14-65.05,20.15-12.78,3.2-25.92,6.15-35.4,6.15-7.27,0-9.97-1.32-14.44-7.05-3.47-4.46-6.68-8.73-9.59-12.78,19.06.37,38.22.68,51.19.68,17.49,0,35.71-9.54,62.9-32.91,7.13-6.13,14.46-12.93,20.12-18.66,8.42-8.52,19.94-20.19,19.94-39.28,0-10.79-4.05-21.17-11.24-29.09,3.86-2.79,6.8-5.01,7.3-5.4l30.56-23.25c1.79-1.36,2.92-3.42,3.12-5.66.2-2.24-.55-4.46-2.08-6.12l-25.96-28.28c-18.74-20.42-52.89-56.33-70.97-67.44l-.79-.49c-.12-.07-.24-.15-.37-.21l-.76-.41c-17.52-9.55-36.23-14.39-55.63-14.39-18.36,0-36.67,4.35-54.38,12.91-28.35,13.46-49.7,25.07-68.55,41.35-14.53,12.55-26.7,27.54-35.97,44.35-5.1,9.25-8.89,18.99-13.16,28.62-2.33,5.26-4.74,10.49-6.99,15.79-1.13,2.65-2.22,5.31-3.25,8-.8,2.08-2.66,5.38-2.66,7.52v-103.63l.51-176.6c0-1.33-.32-2.64-.95-3.81l-60.66-112.85c-2.08-3.86-6.88-5.33-10.76-3.3l-135.31,70.95c-1.9,1-3.32,2.71-3.94,4.77-.62,2.05-.39,4.27.63,6.15l39.96,73.26v93.86l-32.66-60.76c-2.08-3.88-6.91-5.34-10.8-3.28l-133.59,70.92c-3.87,2.06-5.37,6.85-3.35,10.74l38.4,74.15v214.93c-4.51-7.57-10-18.22-16.28-33.1-12.78-30.28-25.89-70.85-38.95-120.58-22.56-85.9-37.17-170.11-37.32-170.95l-7.04-40.89c-.44-2.53-2.06-4.7-4.36-5.83-2.31-1.13-5.01-1.08-7.28.12l-110.33,58.74c-6.14,3.27-16.41,8.75-21.31,22.77l-.08.23s-.03.08-.04.12l-39.23,118.38c-6.38-12.36-13.93-26.92-22.54-43.5-23.41-45.04-47.33-90.79-47.56-91.23l-13.92-26.62c-.98-1.88-2.68-3.29-4.7-3.93-2.03-.63-4.22-.44-6.1.55l-62.25,32.66.33-113.54c0-1.33-.32-2.64-.95-3.81l-60.66-112.85c-2.08-3.86-6.88-5.33-10.76-3.3l-135.31,70.95c-1.9,1-3.32,2.71-3.94,4.77-.62,2.05-.39,4.27.63,6.15l39.96,73.27v66.24c-7.91-9-16.77-16.63-26.49-22.8-21.05-13.38-46.33-20.16-75.12-20.16-1.4,0-2.81.02-4.24.05-20.55.46-41.24,8.63-61.6,24.32l-19.33-35.43c-2.09-3.83-6.87-5.28-10.74-3.25l-109.48,57.41-28.17-52.4c-2.08-3.88-6.91-5.34-10.8-3.28l-119.25,63.31-48.04-59.07c-2.43-2.99-6.65-3.82-10.03-1.98l-89.54,48.76-25.95-47.57c-2.09-3.83-6.87-5.28-10.74-3.25L4.28,256.94c-1.9,1-3.32,2.71-3.94,4.77-.62,2.05-.39,4.27.63,6.15l39.96,73.26v501.49c0,2.76,1.42,5.33,3.77,6.79,1.29.81,2.76,1.21,4.23,1.21,1.2,0,2.41-.27,3.52-.82l154-75.47c2.74-1.34,4.48-4.13,4.48-7.18v-140.15l37.84-3.6c13.88-1.32,27.23-4.99,39.67-10.9,21.98-10.45,40.74-24.47,55.99-41.83v91.79c0,4.42,3.58,8,8,8,0,0,291.12,0,291.12,0-11.34,23.96-28.46,44.47-44.15,65.65-11.58,15.63-23.15,31.26-34.73,46.89-.57.77-1.14,1.53-1.71,2.3-2.17,2.93-2.08,6.94.2,9.78s6.19,3.77,9.51,2.28l104.84-47.18c44.97-20.24,83.28-54.69,111.41-100.02v12.3c0,4.42,3.58,8,8,8h113.16c7.77,0,15.47-1.14,22.9-3.4l.99-.3c.18-.05.35-.11.52-.18l36.53-13.9c.63-.24,1.24-.56,1.79-.96l72.88-51.82-2.41,7.28c-.84,2.02-2.33,5.6-3.35,8.04,0,0-.87,2.09-.87,2.09-7.89,18.91.52,41.39,19.21,50.29.1.04.19.09.29.13,8.55,3.93,19.83,3.53,28.65.63,9.18-3.02,17.26-8.84,24.72-14.82.02-.01.03-.03.05-.04,6.78-5.44,12.64-12.25,19.48-17.49,16.17,14.47,35.84,25.99,57.11,30.95,13.06,3.05,26.58,3.59,39.99,3.35,13.16-.24,26.49-1.25,38.9-5.61,10.47-3.67,19.94-9.6,28.96-15.96,2.18-1.54,4.29-3.17,6.48-4.69,3.1-2.15,3.51-1.75,6.37.6,4.38,3.61,8.88,7,13.7,9.99,12.97,8.03,27.9,13.51,43.18,14.61,1.52.11,3.04.18,4.57.18h.48c9.9-.03,19.29-1.58,28.06-4.62,1.01,3.26,4.05,5.63,7.64,5.63h155c4.42,0,8-3.58,8-8v-21.86c21.35,20.5,53.89,29.86,80.61,29.86,1.42,0,2.86-.03,4.28-.08,25.97-.31,57.49-14.49,78.36-27.66,10.74-6.78,20.11-14.03,27.98-21.61,6.69,6.59,13.84,12.62,21.35,17.98,35.85,25.59,80.35,37.19,123.66,27.19,36.04-8.32,69.62-21.68,97.85-46.23,1-.87,1.99-1.75,2.97-2.64,26.85-24.39,37.72-48.35,39.62-52.9l29.57-70.56c1.21-2.89.62-6.21-1.5-8.52Zm-42.83,72.9c-1.68,4.01-11.28,25.12-35.62,47.24-24.3,22.07-54.73,36.55-86.66,43.61-21.31,4.72-41.86,6.76-63.27,1.65-19.56-4.67-38.11-13.08-54.48-24.77-8.86-6.32-17.19-13.68-24.75-21.87-1.51-1.64-3.64-2.57-5.88-2.57h-.03c-2.24,0-4.38.96-5.89,2.62-7.95,8.74-18.25,17.14-30.62,24.95-19.04,12.02-47.44,24.96-70.09,25.19-.07,0-.15,0-.22,0-1.25.05-2.52.07-3.78.07-28.25,0-63.78-11.67-79.46-37.73l-.54-.89-.45-.93c-.3-.62-.58-1.24-.87-1.89-1.54-3.44-5.28-5.34-8.97-4.55-3.69.79-6.32,4.05-6.32,7.82v38.17h-139v-1.67c0-2.81-1.48-5.42-3.89-6.86-2.41-1.44-5.4-1.52-7.88-.19-9.52,5.08-20.28,7.68-32.04,7.72h-.37c-5.23,0-32.64-1.35-58.61-27.99-7.61-7.8-19.83,6.68-25.84,10.88-9.6,6.69-19.98,12.54-31.4,15.43-9.68,2.45-19.76,2.69-29.75,2.64-10.57-.06-21.2-.45-31.53-2.68-12.19-2.62-23.71-7.79-34.19-14.5-5.19-3.32-10.13-7.02-14.83-11.01-3.81-3.23-8.22-9.7-13.68-9.57-2.18.05-4.25.99-5.72,2.61l-.1.11c-7.12,7.71-15.33,15.4-23.13,21.66-9.42,7.56-20.18,15.17-32.93,13.07-.88-.15-1.76-.33-2.61-.62-7.63-2.6-12.77-9.74-14-17.55-1.65-10.4,4.84-19.77,7.9-29.26,2.32-7.2,4.76-14.36,7.14-21.54.37-1.13.75-2.25,1.12-3.38,1.09-3.28-.06-6.9-2.84-8.95-2.78-2.06-6.57-2.09-9.39-.09l-91.97,65.38-35.31,13.44-.73.22c-5.92,1.8-12.06,2.71-18.25,2.71h-105.16v-35.46c0-3.73-2.58-6.96-6.21-7.8-3.64-.84-7.36.95-8.99,4.31-2.78,5.74-5.69,11.3-8.66,16.54-26.87,47.41-64.95,83.21-110.11,103.54,0,0-76.88,34.6-76.88,34.6,14.55-19.65,30.47-38.28,44.24-58.51,13.13-19.29,23.17-40.17,31.29-62.02,11.92-32.05,27.03-85.89,31.36-160.42,1.23-21.18,1.93-42.41,1.64-63.62-.2-15.17-.89-30.36-2.55-45.45-1.12-10.17-2.66-20.34-5.11-30.28-1.43-5.81-3.19-11.56-5.61-17.03-2.04-4.61-4.73-11.67-10.41-12.67-5.97-1.06-13.73,5.82-17.87,9.74-4.07,3.86-7.21,8.52-9.33,13.7-4.89,11.97-5.12,25.64-4.82,38.36.16,6.85.11,14.09.06,21.11v.32c-.03,3.2-.05,6.35-.05,9.39v241.63h-136v-306.93c0-4.42-3.58-8-8-8s-8,3.58-8,8v306.93h-134.5v-107.58c0-3.54-2.33-6.66-5.73-7.67-3.4-1.01-7.05.34-8.98,3.31-15.61,24.04-37.19,42.72-64.15,55.53-10.75,5.11-22.3,8.28-34.32,9.43l-45.08,4.29c-4.11.39-7.24,3.84-7.24,7.96v142.44l-138,67.63v-490.7c0-1.34-.34-2.66-.98-3.83l-37.05-67.92,120.97-63.44,26.01,47.68c2.12,3.88,6.97,5.31,10.85,3.19l90.73-49.41,47.99,59.01c2.41,2.96,6.58,3.81,9.96,2.02l118.03-62.66,28.15,52.36c2.08,3.86,6.88,5.33,10.76,3.3l109.53-57.43,20.18,36.99c1.16,2.13,3.22,3.61,5.6,4.04,2.38.43,4.83-.24,6.66-1.83,19.93-17.27,39.82-26.24,59.12-26.67,1.31-.03,2.6-.04,3.88-.04,25.71,0,48.09,5.94,66.54,17.66,14.26,9.06,26.46,21.82,36.23,37.9,1.86,3.07,5.54,4.51,8.99,3.55,3.45-.97,5.84-4.12,5.84-7.7v-92.72c0-1.34-.34-2.66-.98-3.83l-37.05-67.92,121.09-63.5,55.95,104.09-.36,124.79c0,2.81,1.45,5.41,3.85,6.86,2.4,1.46,5.38,1.55,7.87.24l66.91-35.11,10.21,19.52c.23.44,24.14,46.17,47.54,91.2,12.92,24.87,23.43,45.18,31.23,60.36,1.47,2.87,4.52,4.57,7.73,4.32,3.21-.25,5.96-2.4,6.98-5.46l45.19-136.39.06-.17c2.84-8.12,8.38-11.07,13.73-13.93l100.56-53.53,5.16,29.99c.15.85,14.88,85.74,37.61,172.3,13.26,50.47,26.61,91.77,39.68,122.74,16.06,38.05,28.16,51.71,33.94,56.47,2.39,1.97,5.7,2.38,8.5,1.06,2.8-1.32,4.58-4.14,4.58-7.23v-240.29c0-1.28-.31-2.54-.9-3.68l-35.65-68.85,119.57-63.47,43.94,81.74c1.74,3.23,5.44,4.87,9,3.97,3.56-.9,6.05-4.09,6.05-7.76v-127.69c0-1.34-.34-2.66-.98-3.83l-37.05-67.92,121.09-63.5,55.95,104.09-.5,174.6v230.24c0,6.5-.02,13-.05,19.5-.01,3.27-.31,6.69-.05,9.95.09,1.12.4,2.17.97,3.17.28.5,2.47,2.42,2.47,2.67,2.21,1.5,5.03,1.8,7.51.79,7.99-3.25,17.01-8.44,20.51-10.52,3.33-1.98,4.77-6.07,3.4-9.7-9.01-23.91-13.5-49.24-13.36-75.27.03-5.55.28-11.1.74-16.62,1.51-18.11,5.54-35.74,11.97-52.68,7.75-20.44,16.14-40.83,27.88-59.35,11.34-17.88,26.84-32.45,44.41-44.15,14.91-9.93,30.99-17.79,47.09-25.57,29.68-14.35,66.12-15.97,95.12,1.15,9.68,5.72,18.04,13.38,26.16,21.16,21.72,20.81,41.95,43.04,62.28,65.18.23.25.45.49.68.74l-23.57,17.93c-.81.61-8.09,6.14-15.12,10.83-2.25,1.5-3.59,4.04-3.56,6.74.03,2.7,1.42,5.21,3.7,6.66,1.27.81,2.49,1.74,3.6,2.74,5.72,5.16,9,12.54,9,20.25,0,12.51-7.79,20.4-15.33,28.03-5.37,5.43-12.35,11.91-19.17,17.77-23.67,20.36-39.37,29.04-52.47,29.04-16.37,0-42.83-.51-66.34-.98-.05,0-.11,0-.16,0-2.88,0-5.55,1.56-6.97,4.08-1.45,2.57-1.36,5.72.22,8.21,5.02,7.9,11.42,16.86,19.04,26.63,7.51,9.63,14.84,13.21,27.06,13.21,11.21,0,25.51-3.19,39.28-6.63,12.5-3.12,52.95-16.15,66.14-20.47l56.12-18.34-22.81,54.44Zm-1368.91-176.71c-.57-23.79,2.83-33.56,8.14-39.25,1.62-1.73,4.51-1.08,5.3,1.16,5.84,16.54,13.79,56.18,8.64,144.79-3.24,55.78-12.65,99.54-22.06,130.89v-206.38c0-3,.02-6.12.05-9.28v-.33c.06-7.12.11-14.49-.06-21.6Z"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("path", {
                fill: fill,
                d: "m1268.94,238.42s-76.99,40.98-77,41l-113,341c-.8,1.93-5.06,12.14-5,12,4.1.46,21.44-13.31,35-28,5.31-5.75,10.31-11.79,15.04-18.03,1.6-2.11,3.72-6.71,6.16-7.74,10.45,15.79,25.84,30.03,41.73,40.24,7.45,4.79,15.49,8.84,24.11,10.89,7.09,1.69,14.43,1.99,21.72,2.28,11.84.48,23.97.92,35.24-2.74,9.03-2.93,17.02-8.36,24.66-14,8.56-6.32,16.85-13,24.76-20.11,2.06-1.86,4.06-3.79,6.11-5.66,2.52-2.3,2.48-2.37,4.28.54,2.4,3.87,4.89,7.67,7.68,11.28,11.38,14.7,30.56,30.55,50.51,30.04,28,0,37.2-19.99,37.2-19.99.11-.11.33-.43.18-.42-74.37,5.4-139.37-372.6-139.37-372.6Zm9.79,303.3c-5.16,8.21-11.91,15.79-20.81,20.01-10.7,5.08-23.53,4.66-34.53.28-11-4.38-20.26-12.45-27.46-21.85-8.27-10.82-19.22-26.75-16.46-40.97,0,0,2.29-11.85,2.29-11.85.26-1.33.62-2.64,1.08-3.91l32.09-89.31,5.95-14.68c.2-.5.89-.53,1.14-.05,0,0,30.91,83.02,30.91,83.02,5.66,15.2,11.26,30.43,16.88,45.64,3.29,8.88,6.57,17.77,9.86,26.65.55,1.48.85,2.33.84,3.12-.01,1.02-.55,1.92-1.79,3.89Z"
            })
        ]
    });
};





parcelRequire("bh6RR");
const $4c7973dd2dea1988$export$3261d0822363911f = ({ machines: machines, locations: locations })=>{
    return (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                className: "text-xs font-montserrat uppercase font-extrabold  mt-10 mb-2",
                children: "Our Pinball Locations"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                className: "font-source text-md sm:text-lg grid sm:grid-cols-2 xl:grid-cols-3 gap-4 gap-y-10",
                children: locations.map((loc)=>{
                    const pins = machines.filter((m)=>m.location.name === loc.name);
                    const pinCount = pins.length;
                    return (0, $d4dab640dcbe486c$exports.jsxs)("li", {
                        children: [
                            " ",
                            (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: loc.url,
                                className: "underline underline-offset-2 font-bold",
                                target: "_blank",
                                rel: "noreferrer",
                                children: (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                                    children: `${loc.name} - ${pinCount} ${pinCount === 1 ? "pinball machine" : "pinball machines"}`
                                })
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                                className: "list-disc list-outside ms-8 font-source space-y-2 sm:space-y-2 sm:text-base mt-3",
                                children: pins.map((machine)=>{
                                    return (0, $d4dab640dcbe486c$exports.jsx)("li", {
                                        children: (0, $d4dab640dcbe486c$exports.jsxs)("a", {
                                            href: machine.url,
                                            className: "hover:underline focus:underline underline-offset-2",
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: [
                                                (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    children: machine.name
                                                }),
                                                (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                                    className: "text-sm",
                                                    children: `(${machine.manufacturer} ${machine.year})`
                                                })
                                            ]
                                        })
                                    }, machine.name);
                                })
                            })
                        ]
                    }, loc.name);
                })
            })
        ]
    });
};






var $bh6RR = parcelRequire("bh6RR");

var $bh6RR = parcelRequire("bh6RR");
const $5a987cc8d0a38856$export$c1cf1cf4c5d51937 = (url, headers)=>{
    const [data, setData] = (0, $bh6RR.useState)({
        data: undefined,
        isLoading: true,
        isError: false
    });
    (0, $bh6RR.useEffect)(()=>{
        let ignore = false;
        fetch(url, {
            headers: headers
        }).then((response)=>response.json()).then((json)=>{
            if (!ignore) setData(json);
        }).catch(()=>{
            if (!ignore) setData({
                data: undefined,
                isLoading: false,
                isError: true
            });
        });
        return ()=>{
            ignore = true;
        };
    }, [
        url
    ]);
    return data;
};








const $602574c53fccfbe1$var$byStartDate = (a, b)=>a.startLocal < b.startLocal ? -1 : a.startLocal > b.startLocal ? 1 : 0;
const $602574c53fccfbe1$var$matchplayHeaders = {
    Authorization: "Bearer 122|OtQ4qQBnH36Lz9rrUNhhjdkpeFHWZyqkD4vt3smA6abc6c7d",
    "Content-Type": "application/json",
    Accept: "application/json"
};
const $602574c53fccfbe1$var$TournamentListItem = ({ tournament: tournament })=>{
    const date = new Date(tournament.startLocal);
    const day = new Intl.DateTimeFormat("en-IE", {
        weekday: "short"
    }).format(date);
    const month = new Intl.DateTimeFormat("en-IE", {
        month: "short"
    }).format(date);
    const dayNumber = new Intl.DateTimeFormat("en-IE", {
        day: "numeric"
    }).format(date);
    const time = new Intl.DateTimeFormat("en-IE", {
        hour: "numeric",
        minute: "numeric",
        hour12: true
    }).format(new Date(tournament.startLocal));
    return (0, $d4dab640dcbe486c$exports.jsx)("li", {
        children: (0, $d4dab640dcbe486c$exports.jsxs)("a", {
            className: "cursor-pointer transition-colors group",
            href: `https://app.matchplay.events/tournaments/${tournament.tournamentId}`,
            children: [
                (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                    className: "flex flex-row gap-2 border border-white group-hover:border-red-500 cursor-pointer transition-colors",
                    children: [
                        (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                            className: "font-bold flex-grow-0 flex flex-col gap-0 leading-none p-2 bg-white group-hover:bg-red-500 transition-colors text-black",
                            children: [
                                (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    children: day.toUpperCase()
                                }),
                                (0, $d4dab640dcbe486c$exports.jsxs)("span", {
                                    className: "text-lg uppercase",
                                    children: [
                                        month,
                                        " ",
                                        dayNumber
                                    ]
                                }),
                                (0, $d4dab640dcbe486c$exports.jsx)("span", {
                                    children: time.toUpperCase()
                                })
                            ]
                        }),
                        (0, $d4dab640dcbe486c$exports.jsxs)("h4", {
                            className: "text-lg flex-1 flex-grow p-2",
                            children: [
                                tournament.name,
                                " ",
                                tournament.organizerId === 51332 && " - Women's tournament"
                            ]
                        })
                    ]
                }),
                (0, $d4dab640dcbe486c$exports.jsx)("div", {
                    className: "border font-bold border-white group-hover:border-red-500 transition-colors  border-t-0 p-1 text-center",
                    children: "REGISTER"
                })
            ]
        })
    });
};
const $602574c53fccfbe1$export$114abf057c58f51 = ()=>{
    const [showAllTournaments, setShowAllTournaments] = (0, $bh6RR.useState)(false);
    const openTournamentData = (0, $5a987cc8d0a38856$export$c1cf1cf4c5d51937)("https://snowy-wind-eb12.asperellis.workers.dev/api/tournaments?owner=9817&status=planned&page=2", $602574c53fccfbe1$var$matchplayHeaders);
    const openTournamentData2 = (0, $5a987cc8d0a38856$export$c1cf1cf4c5d51937)("https://snowy-wind-eb12.asperellis.workers.dev/api/tournaments?owner=9817&status=planned", $602574c53fccfbe1$var$matchplayHeaders);
    const { data: womensTournaments = [], isLoading: loadingWomensTournaments, isError: errorLoadingWomensTournaments } = (0, $5a987cc8d0a38856$export$c1cf1cf4c5d51937)("https://snowy-wind-eb12.asperellis.workers.dev/api/tournaments?owner=51332&status=planned", $602574c53fccfbe1$var$matchplayHeaders);
    const allTournaments = [
        ...openTournamentData.data || [],
        ...openTournamentData2.data || [],
        ...womensTournaments
    ];
    const touramentsToShow = showAllTournaments ? allTournaments.length : 3;
    const tournaments = [
        ...allTournaments
    ].sort($602574c53fccfbe1$var$byStartDate).slice(0, touramentsToShow);
    const errorLoadingTournaments = openTournamentData.isError || openTournamentData2.isError;
    const loading = openTournamentData.isLoading || openTournamentData2.isLoading || loadingWomensTournaments;
    return (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "mb-6",
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("h2", {
                className: "text-xs font-montserrat uppercase font-extrabold mb-2",
                children: "Our Pinball Events"
            }),
            (0, $d4dab640dcbe486c$exports.jsx)("h3", {
                className: "text-2xl tracking-tight leading-6 font-source font-extrabold mb-4",
                children: "2026 Pinball Event Calendar - All skill levels welcome!"
            }),
            errorLoadingTournaments && (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "text-red-600 mb-2",
                children: "We had issues fetching our open tournaments"
            }),
            errorLoadingWomensTournaments && (0, $d4dab640dcbe486c$exports.jsx)("p", {
                className: "text-red-600 mb-2",
                children: "We had issues fetching our women's tournaments"
            }),
            loading && (0, $d4dab640dcbe486c$exports.jsx)((0, $d4dab640dcbe486c$exports.Fragment), {
                children: "Loading tournaments..."
            }),
            !loading && !!allTournaments.length && (0, $d4dab640dcbe486c$exports.jsx)("ul", {
                className: "font-source text-md sm:text-sm grid sm:grid-cols-2 xl:grid-cols-3 gap-4",
                children: tournaments.map((t)=>{
                    return (0, $d4dab640dcbe486c$exports.jsx)($602574c53fccfbe1$var$TournamentListItem, {
                        tournament: t
                    }, t.tournamentId);
                })
            }),
            !loading && !!allTournaments.length && allTournaments.length > 3 && !showAllTournaments && (0, $d4dab640dcbe486c$exports.jsx)("div", {
                className: "flex flex-row xl:items-center xl:justify-center mt-5",
                children: (0, $d4dab640dcbe486c$exports.jsx)("button", {
                    onClick: ()=>{
                        setShowAllTournaments(true);
                    },
                    className: "group w-auto inline-block",
                    rel: "noreferrer",
                    children: (0, $d4dab640dcbe486c$exports.jsx)("div", {
                        className: "h-full text-xl  font-bold px-6 py-2.5 divide-x-2 relative flex border-2 border-black bg-white text-black transition-all duration-150 [box-shadow:5px_5px_rgb(255_255_255)] active:translate-x-[3px] active:translate-y-[3px] active:[box-shadow:0px_0px_rgb(0_0_0)]",
                        children: "SHOW ALL EVENTS"
                    })
                })
            })
        ]
    });
};






const $0b840daf983d6743$export$9396c9157495b4d = {
    FIBBERS: {
        name: "Fibber Magees",
        url: "https://www.google.com/maps/place/Fibber+Magees/@53.3529458,-6.2603666,15z/data=!4m2!3m1!1s0x0:0xa9e461e298020e37?sa=X&ved=2ahUKEwjg5oDV1-GDAxW6TUEAHYbsAH8Q_BJ6BAgTEAA"
    },
    MURRAYS: {
        name: "Murray's Bar",
        url: "https://www.google.com/maps/place/Fibber+Magees/@53.3529458,-6.2603666,15z/data=!4m2!3m1!1s0x0:0xa9e461e298020e37?sa=X&ved=2ahUKEwjg5oDV1-GDAxW6TUEAHYbsAH8Q_BJ6BAgTEAA"
    },
    BACK_PAGE: {
        name: "The Back Page",
        url: "https://www.google.com/maps/place/Fibber+Magees/@53.3529458,-6.2603666,15z/data=!4m2!3m1!1s0x0:0xa9e461e298020e37?sa=X&ved=2ahUKEwjg5oDV1-GDAxW6TUEAHYbsAH8Q_BJ6BAgTEAA"
    },
    NONE: {
        name: "None",
        url: ""
    }
};
const $0b840daf983d6743$export$b73c01a6aa329da7 = [
    {
        name: "Foo Fighters (Pro)",
        url: "https://sternpinball.com/game/foo-fighters/",
        manufacturer: "Stern",
        year: "2023",
        location: $0b840daf983d6743$export$9396c9157495b4d.BACK_PAGE,
        howTo: "https://www.youtube.com/watch?v=CdUOl1aVCzo"
    },
    {
        name: "Black Knight Sword of Rage (Pro)",
        url: "https://sternpinball.com/game/black-knight/",
        manufacturer: "Stern",
        year: "2019",
        location: $0b840daf983d6743$export$9396c9157495b4d.BACK_PAGE,
        howTo: "https://www.youtube.com/watch?v=musEx6lbttQ"
    },
    {
        name: "The Getaway: High Speed II",
        url: "https://www.ipdb.org/machine.cgi?id=1000",
        manufacturer: "Williams",
        year: "1992",
        location: $0b840daf983d6743$export$9396c9157495b4d.MURRAYS,
        howTo: "https://www.youtube.com/watch?v=Elz5Ksr4Tzk"
    },
    {
        name: "Fish Tales",
        url: "https://www.ipdb.org/machine.cgi?id=861",
        manufacturer: "Williams",
        year: "1992",
        location: $0b840daf983d6743$export$9396c9157495b4d.NONE,
        howTo: "https://www.youtube.com/watch?v=60a_nKnEdUA"
    },
    {
        name: "Who Dunnit?",
        url: "https://www.ipdb.org/machine.cgi?id=3685",
        manufacturer: "Bally",
        year: "1995",
        location: $0b840daf983d6743$export$9396c9157495b4d.FIBBERS,
        howTo: "https://www.youtube.com/watch?v=wM5nkmtDcx8"
    },
    {
        name: "Deadpool (Pro)",
        url: "https://www.ipdb.org/machine.cgi?id=6558",
        manufacturer: "Stern",
        year: "2018",
        location: $0b840daf983d6743$export$9396c9157495b4d.FIBBERS,
        howTo: "https://youtu.be/7ZMPyTqiot4?si=bGfljocCaTRlQOD9"
    },
    {
        name: "Guardians of the Galaxy (Pro)",
        url: "https://www.ipdb.org/machine.cgi?gid=6474",
        manufacturer: "Stern",
        year: "2017",
        location: $0b840daf983d6743$export$9396c9157495b4d.BACK_PAGE,
        howTo: "https://youtu.be/BOP6gXVB0VU?si=pNGgDcWO1Ji6wYRt"
    },
    {
        name: "James Bond (Pro)",
        url: "https://www.ipdb.org/machine.cgi?id=6896",
        manufacturer: "Stern",
        year: "2022",
        location: $0b840daf983d6743$export$9396c9157495b4d.BACK_PAGE,
        howTo: "https://www.youtube.com/watch?v=GnQr9qIZz_0"
    },
    {
        name: "Jurassic Park (Pro)",
        url: "https://www.ipdb.org/machine.cgi?gid=6573",
        manufacturer: "Stern",
        year: "2019",
        location: $0b840daf983d6743$export$9396c9157495b4d.BACK_PAGE,
        howTo: "https://youtu.be/vVs_0jqCPGA?si=-hFnJzOviJBijalx"
    },
    {
        name: "Avengers: Infinity Quest (Pro)",
        url: "https://www.ipdb.org/machine.cgi?id=6754",
        manufacturer: "Stern",
        year: "2020",
        location: $0b840daf983d6743$export$9396c9157495b4d.BACK_PAGE,
        howTo: "https://youtu.be/2_xcLBHzaSo?si=Lr1nx9h2c3m88QKr"
    },
    {
        name: "Twilight Zone",
        url: "https://www.ipdb.org/machine.cgi?id=2684",
        manufacturer: "Bally",
        year: "1993",
        location: $0b840daf983d6743$export$9396c9157495b4d.NONE,
        howTo: "https://www.youtube.com/watch?v=DYy0aNj9GLU"
    },
    {
        name: "Doctor Who",
        url: "https://www.ipdb.org/machine.cgi?id=738",
        manufacturer: "Bally",
        year: "1992",
        location: $0b840daf983d6743$export$9396c9157495b4d.FIBBERS,
        howTo: "https://www.youtube.com/watch?v=iawmrs69jrQ"
    },
    {
        name: "Red & Ted's Road Show",
        url: "https://www.ipdb.org/machine.cgi?id=1972",
        manufacturer: "Williams",
        year: "1994",
        location: $0b840daf983d6743$export$9396c9157495b4d.NONE,
        howTo: "https://www.youtube.com/watch?v=vEl6ywIOfdc"
    },
    {
        name: "John Wick (Pro)",
        url: "https://app.matchplay.events/opdb/entries/GQK1P-MW9pj",
        manufacturer: "Stern",
        year: "2024",
        location: $0b840daf983d6743$export$9396c9157495b4d.FIBBERS,
        howTo: "https://www.youtube.com/watch?v=ilfCVAvlnZU"
    },
    {
        name: "King Kong: Myth of Terror Island (Pro)",
        url: "https://app.matchplay.events/opdb/entries/GEL0V-MBRyb",
        manufacturer: "Stern",
        year: "2025",
        location: $0b840daf983d6743$export$9396c9157495b4d.BACK_PAGE,
        howTo: "https://www.youtube.com/watch?v=ydJbSPds95Y"
    }
];



const $2ddb6a49e8b6db8c$export$355f3d6a1f8b250c = ()=>{
    return (0, $d4dab640dcbe486c$exports.jsxs)("div", {
        className: "py-10 bg-black text-white px-5 sm:p-10 h-screen w-screen flex flex-col overflow-x-hidden",
        children: [
            (0, $d4dab640dcbe486c$exports.jsx)("header", {
                className: "flex flex-col md:flex-row gap-4 items-center justify-center sm:justify-between",
                children: (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$a6c7ac8248d6e38a), {
                    to: "/",
                    title: "Pinbaile homepage",
                    children: (0, $d4dab640dcbe486c$exports.jsx)((0, $e61a2220d08bc5b0$export$182d03b4b654e012), {
                        fill: "#fff",
                        width: 300
                    })
                })
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("main", {
                className: "flex-1 mt-10 sm:mt-20 mb-5 flex flex-col xl:grid xl:grid-cols-3 gap-4 xl:gap-20",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "mb-6",
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsxs)("h1", {
                                className: "text-lg lg:text-5xl font-montserrat uppercase font-extrabold mb-2",
                                children: [
                                    "Dublin's Home ",
                                    (0, $d4dab640dcbe486c$exports.jsx)("br", {
                                        className: "hidden lg:block"
                                    }),
                                    "for Pinball"
                                ]
                            }),
                            (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                                className: "mb-10 text-xl",
                                children: [
                                    "Pinbaile brings pinball fun to businesses, events, and communities across Dublin. Whether you're looking to add a machine to your venue or run a one-off event, we offer options to suit your needs. Our mission is simple: grow the love of pinball across Ireland and make it accessible to everyone. Are you ready to flip?",
                                    (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                    (0, $d4dab640dcbe486c$exports.jsx)("br", {}),
                                    "Contact us at",
                                    " ",
                                    (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        className: "underline underline-offset-2",
                                        href: "mailto:info@pinbaile.com",
                                        children: "info@pinbaile.com"
                                    }),
                                    " ",
                                    "or",
                                    " ",
                                    (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                        className: "underline underline-offset-2",
                                        href: "https://www.instagram.com/pinbaile/",
                                        children: "@pinbaile on Instagram"
                                    })
                                ]
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: "https://pinballmap.com/operators?by_operator_id=555",
                                target: "_blank",
                                className: "group w-auto inline-block",
                                rel: "noreferrer",
                                children: (0, $d4dab640dcbe486c$exports.jsx)("div", {
                                    className: "h-full text-xl font-bold px-6 py-2.5 divide-x-2 relative flex border-2 border-black bg-white text-black transition-all duration-150 [box-shadow:5px_5px_rgb(255_255_255)] active:translate-x-[3px] active:translate-y-[3px] active:[box-shadow:0px_0px_rgb(0_0_0)]",
                                    children: "FIND US ON THE PINBALL MAP"
                                })
                            })
                        ]
                    }),
                    (0, $d4dab640dcbe486c$exports.jsxs)("div", {
                        className: "col-span-1 xl:col-span-2 mt-6 lg:mt-0 mb-6",
                        children: [
                            (0, $d4dab640dcbe486c$exports.jsx)((0, $602574c53fccfbe1$export$114abf057c58f51), {}),
                            (0, $d4dab640dcbe486c$exports.jsx)((0, $4c7973dd2dea1988$export$3261d0822363911f), {
                                machines: (0, $0b840daf983d6743$export$b73c01a6aa329da7),
                                locations: Object.values((0, $0b840daf983d6743$export$9396c9157495b4d)).filter((l)=>l.name !== "None")
                            })
                        ]
                    })
                ]
            }),
            (0, $d4dab640dcbe486c$exports.jsxs)("footer", {
                className: "text-sm font-source flex flex-col lg:flex-row justify-between gap-4 items-center sm:items-start lg:items-end",
                children: [
                    (0, $d4dab640dcbe486c$exports.jsxs)("p", {
                        className: "text-center sm:text-left",
                        children: [
                            "For more information on purchasing and renting, contact us at:",
                            (0, $d4dab640dcbe486c$exports.jsx)("br", {
                                className: "hidden md:block"
                            }),
                            (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: "mailto:info@pinbaile.com",
                                children: "info@pinbaile.com"
                            }),
                            " |",
                            " ",
                            (0, $d4dab640dcbe486c$exports.jsx)("a", {
                                href: "https://www.instagram.com/pinbaile/",
                                children: "@pinbaile"
                            })
                        ]
                    }),
                    (0, $d4dab640dcbe486c$exports.jsx)("p", {
                        className: "italic",
                        children: "actual website coming soon"
                    })
                ]
            })
        ]
    });
};






const $41065e38cf2f42b4$export$86fbec116b87613f = ()=>{
    return (0, $d4dab640dcbe486c$exports.jsx)((0, $0bd3411f2ec14e23$export$9ba4e89fdfa1fc54), {
        children: (0, $d4dab640dcbe486c$exports.jsx)((0, $6a9dcc96d11bcd0d$export$3565eb3d00ca5a74), {
            children: (0, $d4dab640dcbe486c$exports.jsx)((0, $6a9dcc96d11bcd0d$export$e7b0ac011bb776c6), {
                path: "/",
                element: (0, $d4dab640dcbe486c$exports.jsx)((0, $2ddb6a49e8b6db8c$export$355f3d6a1f8b250c), {})
            })
        })
    });
};


const $1f0dc3b9307be026$var$root = (0, $6fc264ec92100d3a$export$882461b6382ed46c)(document.getElementById("root"));
$1f0dc3b9307be026$var$root.render(/*#__PURE__*/ (0, $d4dab640dcbe486c$exports.jsx)((0, $41065e38cf2f42b4$export$86fbec116b87613f), {}));


//# sourceMappingURL=index.6347f5ba.js.map
